/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateAddressDto {
    /** @example "123 High Street" */
    address: string;
    /** @example "Gotham City" */
    city: string;
    /** @example "MN" */
    state: string;
    /** @example "12345" */
    zipcode: string;
    phone?: string;
    fax?: string;
    /** @example "mailing" */
    type?: string;
}

export interface CreateHomeHealthServices {
    SN?: boolean;
    PT?: boolean;
    OT?: boolean;
    ST?: boolean;
    MSW?: boolean;
    HHA?: boolean;
}

export interface CreateServicesDto {
    homeHealth?: boolean;
    homeHealthServices?: CreateHomeHealthServices;
    pca?: boolean;
    hospice?: boolean;
}

export interface CreateCompanyDto {
    /** @example "Acme Company" */
    name: string;
    address: CreateAddressDto;
    agencyId?: string;
    taxId: string;
    npi: string;
    /** @example "077001" */
    ptan: string;
    services: CreateServicesDto;
    accreditationBody?: string;
    accreditationId?: string;
}

export interface CreateOrganizationDto {
    /** @example "Acme Corporation" */
    name: string;
    /** @example "admin@acme.com" */
    adminEmail: string;
    /** @example "John" */
    adminFirstName: string;
    /** @example "Smith" */
    adminLastName: string;
    /** @example "2312322334" */
    adminPhone: string;
    company: CreateCompanyDto;
}

export interface JobDto {
    /** @example "123e4567-e89b-12d3-a456-426614174000" */
    id: string;
    /** @example "ORGANIZATION_CREATION" */
    type: 'ORGANIZATION_CREATION';
    /** @example "PENDING" */
    status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
    /** @example {"name":"Acme Corp","adminEmail":"admin@acme.com"} */
    payload: object;
    /** @example {"id":"123e4567-e89b-12d3-a456-426614174000","name":"Acme Corp"} */
    result?: object;
    /** @example "Migration command failed with exit code 1" */
    error?: string;
    /**
     * @format date-time
     * @example "2025-11-07T12:00:00Z"
     */
    createdAt: string;
    /**
     * @format date-time
     * @example "2025-11-07T12:01:00Z"
     */
    updatedAt: string;
    /**
     * @format date-time
     * @example "2025-11-07T12:05:00Z"
     */
    completedAt?: string;
}

export interface OrganizationListItemDto {
    /** @example "1234-1234-1234" */
    id: string;
    /** @example "Acme Corporation" */
    name: string;
    /** @example "admin@acme.com" */
    adminEmail: string;
    /** @example "2312322334" */
    adminPhone?: string;
    /** @example true */
    active: boolean;
    /** @format date-time */
    createdAt: string;
}

export interface OrgCompanyAddressDto {
    address: string;
    city: string;
    state: string;
    zipcode: string;
}

export interface HomeHealthServicesDto {
    SN?: boolean;
    PT?: boolean;
    OT?: boolean;
    ST?: boolean;
    MSW?: boolean;
    HHA?: boolean;
}

export interface OrgCompanyServicesDto {
    homeHealth?: boolean;
    homeHealthServices?: HomeHealthServicesDto;
    pca?: boolean;
    hospice?: boolean;
}

export interface OrgCompanyDto {
    name: string;
    address: OrgCompanyAddressDto;
    taxId?: string;
    agencyId?: string;
    npi?: string;
    ptan?: string;
    accreditationBody?: string;
    accreditationId?: string;
    services: OrgCompanyServicesDto;
}

export interface OrganizationDto {
    /** @example "1234-1234-1234" */
    id: string;
    /** @example "Acme Corporation" */
    name: string;
    /** @example "admin@acme.com" */
    adminEmail: string;
    /** @example "John" */
    adminFirstName: string;
    /** @example "Smith" */
    adminLastName: string;
    /** @example "2312322334" */
    adminPhone?: string;
    /** @example true */
    active: boolean;
    /** @format date-time */
    deactivatedAt?: string;
    deactivatedReason?: string;
    deactivatedByEmail?: string;
    /** @format date-time */
    createdAt: string;
    company?: OrgCompanyDto;
}

export interface DeactivateOrganizationDto {
    /** @example "Customer contract expired" */
    reason?: string;
}

export interface JobStatusDto {
    /** @example "123e4567-e89b-12d3-a456-426614174000" */
    id: string;
    /** @example "ORGANIZATION_CREATION" */
    type: 'ORGANIZATION_CREATION';
    /** @example "IN_PROGRESS" */
    status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
    /** @example {"id":"123e4567-e89b-12d3-a456-426614174000","name":"Acme Corp"} */
    result?: object;
    /** @example "Migration command failed with exit code 1" */
    error?: object;
    /**
     * @format date-time
     * @example "2025-11-07T12:00:00Z"
     */
    createdAt: string;
    /**
     * @format date-time
     * @example "2025-11-07T12:01:00Z"
     */
    updatedAt: string;
    /** @example "2025-11-07T12:05:00Z" */
    completedAt?: object;
}

export interface FeatureFlagOrganizationStateDto {
    organizationId: string;
    organizationName: string;
    /** Organization-specific state override */
    state: 'inherit' | 'enabled' | 'disabled';
    /** Effective boolean value for this organization */
    effective: boolean;
    /** Source of the effective value */
    source: 'organization' | 'global' | 'off';
    /** Display name of user who enabled this override */
    enabledBy?: string | null;
    /**
     * Timestamp when org override was created/modified
     * @format date-time
     */
    enabledAt?: string | null;
}

export interface FeatureFlagListItemDto {
    /** Database ID (null for enum-only flags that haven't been modified yet) */
    id?: string | null;
    /** Feature flag key from enum */
    key:
        | 'example-feature-flag'
        | 'report-feature-flag'
        | 'dashboard'
        | 'insurance-authorizations'
        | 'grouper-0120206'
        | 'scheduling-dashboard'
        | 'clinical-dashboard'
        | 'intake-dashboard';
    /** Human-readable name derived from key */
    name: string;
    /** Description (if available) */
    description?: string | null;
    /** Whether this flag supports organization-level overrides */
    kind: 'global' | 'organization';
    /** Global status of the feature flag */
    status: 'enabled' | 'disabled' | 'force-disabled';
    /** Admin reason for the current status */
    reason?: string | null;
    /** Display name of user who last modified global status */
    lastModifiedBy?: string | null;
    /** Timestamp when global status was last modified */
    lastModifiedAt?: string | null;
    /** State for each organization */
    organizations: FeatureFlagOrganizationStateDto[];
    /**
     * Last update timestamp
     * @format date-time
     */
    updatedAt?: string | null;
}

export interface FeatureFlagListResponseDto {
    /** Complete list of feature flags with organization states */
    flags: FeatureFlagListItemDto[];
}

export interface SetGlobalStatusDto {
    /**
     * New global status for the feature flag
     * @example "enabled"
     */
    status: 'enabled' | 'disabled' | 'force-disabled';
    /**
     * Optional reason for the status change
     * @example "Enabling for beta testing"
     */
    reason?: string;
}

export interface SetOrgStateDto {
    /**
     * Organization-specific state (inherit removes any override)
     * @example "enabled"
     */
    state: 'enabled' | 'disabled' | 'inherit';
}

export interface AuditEventDto {
    /**
     * Unique request ID
     * @example "123e4567-e89b-12d3-a456-426614174000"
     */
    requestId: string;
    /**
     * Audit event name
     * @example "auth.login"
     */
    eventName: string;
    /**
     * Event type - server or client side
     * @example "server"
     */
    type: 'server' | 'client';
    /**
     * User ID who performed the action
     * @example "user-uuid-123"
     */
    userId: string | null;
    /**
     * User first name
     * @example "John"
     */
    userFirstName: string | null;
    /**
     * User last name
     * @example "Doe"
     */
    userLastName: string | null;
    /**
     * User email
     * @example "john.doe@example.com"
     */
    userEmail: string | null;
    /**
     * User role name
     * @example "Administrator"
     */
    userRole: string | null;
    /**
     * Organization ID
     * @example "org-uuid-123"
     */
    organizationId: string | null;
    /**
     * HTTP method
     * @example "POST"
     */
    httpMethod: string;
    /**
     * Request path
     * @example "/api/auth/login"
     */
    path: string;
    /**
     * IP address
     * @example "192.168.1.1"
     */
    ipAddress: string | null;
    /**
     * User agent string
     * @example "Mozilla/5.0..."
     */
    userAgent: string | null;
    /**
     * Audit event status
     * @example "SUCCESS"
     */
    status: 'PENDING' | 'SUCCESS' | 'FAILURE';
    /**
     * HTTP status code
     * @example 200
     */
    httpStatus: number | null;
    /**
     * Request start timestamp
     * @example "2026-01-08T12:34:56.789Z"
     */
    startTime: string;
    /**
     * Request end timestamp
     * @example "2026-01-08T12:34:57.123Z"
     */
    endTime: string | null;
    /**
     * Duration in milliseconds
     * @example 334
     */
    durationMs: number | null;
    /**
     * Error name if request failed
     * @example "UnauthorizedException"
     */
    errorName: string | null;
    /**
     * Error message if request failed
     * @example "Invalid credentials"
     */
    errorMessage: string | null;
    /** Error stack trace if request failed */
    errorStack: string | null;
    /** Additional event details as JSON */
    details: object | null;
}

export interface PaginationMeta {
    /**
     * Current page number
     * @example 1
     */
    currentPage: number;
    /**
     * Number of records per page
     * @example 50
     */
    pageSize: number;
    /**
     * Total number of records matching query
     * @example 1234
     */
    totalRecords: number;
    /**
     * Total number of pages
     * @example 25
     */
    totalPages: number;
}

export interface AuditLogResponseDto {
    /** Array of audit events */
    events: AuditEventDto[];
    /** Pagination metadata */
    meta: PaginationMeta;
}

export interface StatusCount {
    /** Status value */
    status: 'SUCCESS' | 'FAILURE' | 'PENDING';
    /**
     * Count of events with this status
     * @example 150
     */
    count: number;
}

export interface EventTypeCount {
    /**
     * Event name
     * @example "auth.login"
     */
    eventName: string;
    /**
     * Count of events
     * @example 42
     */
    count: number;
}

export interface TimeSeriesPoint {
    /**
     * Timestamp bucket
     * @example "2026-01-08T12:00:00Z"
     */
    timestamp: string;
    /**
     * Count of events in this time bucket
     * @example 15
     */
    count: number;
}

export interface AuditStatsDto {
    /**
     * Total number of audit events matching filters
     * @example 1234
     */
    totalEvents: number;
    /** Count of events by status */
    statusBreakdown: StatusCount[];
    /** Top event types by count */
    topEventTypes: EventTypeCount[];
    /** Events over time (buckets based on date range) */
    timeSeries: TimeSeriesPoint[];
}

export interface UserSearchResultDto {
    /**
     * User ID
     * @example "user-uuid-123"
     */
    id: string;
    /**
     * User first name
     * @example "John"
     */
    firstName: object | null;
    /**
     * User last name
     * @example "Doe"
     */
    lastName: object | null;
    /**
     * User email
     * @example "john.doe@example.com"
     */
    email: object | null;
}

export interface EnquiryDto {
    id: string;
    email: string;
    agencyName: string;
    patientCensus?: object;
    /** @format date-time */
    createdAt: string;
    notifiedAt?: object;
}

export interface FeatureQuotaAttributeManifestDto {
    /** Attribute key as registered in QUOTA_ATTRIBUTE_REGISTRY */
    key: string;
    /** Human-readable description used to label the sub-limit form input */
    description: string;
}

export interface FeatureRegistryEntryDto {
    /** Feature type identifier as registered by the backend */
    featureType: string;
    /** Human-readable label; admin UIs should fall back to featureType when absent */
    displayName?: string;
    /** Quota sub-limit attributes the feature exposes; admin UI uses these to render per-attribute caps */
    quotaAttributes: FeatureQuotaAttributeManifestDto[];
}

export interface OrgFeatureHealthDto {
    organizationId: string;
    status: 'OK' | 'NEAR_LIMIT' | 'AT_LIMIT';
    /** featureType of the most-stressed feature contributing to the status; null when status is OK */
    stressedFeatureType?: string | null;
    /** Headline pct (used + reserved) / limit on the stressed axis; null when status is OK */
    stressedPct?: number | null;
}

export interface PricingEntryDto {
    provider: string;
    modelId: string;
    /** ISO timestamp this pricing took effect */
    effectiveAt: string;
    /** Input price in USD per 1k tokens */
    inputUsdPer1kTokens: number;
    /** Output price in USD per 1k tokens */
    outputUsdPer1kTokens: number;
    /** True when this is the current effective pricing for the model (latest effectiveAt <= now) */
    isCurrent: boolean;
}

export interface LlmFeatureConfigDto {
    id: string;
    organizationId: string;
    featureType: string;
    enabled: boolean;
    requestsPeriod: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    inputTokensPeriod: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    outputTokensPeriod: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    costPeriod: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    maxRequests: number | null;
    maxInputTokens: number | null;
    maxOutputTokens: number | null;
    maxCostMicrousd: number | null;
    /** Per-org per-feature default model. May be overridden per-call in lower envs. */
    modelId: string;
}

export interface UpsertLlmConfigBodyDto {
    enabled: boolean;
    requestsPeriod?: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    inputTokensPeriod?: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    outputTokensPeriod?: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    costPeriod?: 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC' | null;
    maxRequests?: number | null;
    maxInputTokens?: number | null;
    maxOutputTokens?: number | null;
    maxCostMicrousd?: number | null;
    /** Default model ID for this feature. Must be in the framework allowlist and have pricing. */
    modelId: string;
}

export interface UsageSummaryDto {
    organizationId: string;
    featureType: string;
    period: string;
    periodStart: string;
    requestsUsed: number;
    requestsReserved: number;
    inputTokensUsed: number;
    inputTokensReserved: number;
    outputTokensUsed: number;
    outputTokensReserved: number;
    costMicrousdUsed: number;
    costMicrousdReserved: number;
}

export interface UsageHistoryPointDto {
    featureType: string;
    /** ISO date string for the start of the bucket window */
    bucketStart: string;
    /** Total requests (used + reserved) in the bucket */
    requests: number;
    /** Total input tokens (used + reserved) in the bucket */
    inputTokens: number;
    /** Total output tokens (used + reserved) in the bucket */
    outputTokens: number;
    /** Total cost in microUSD (used + reserved) in the bucket */
    costMicrousd: number;
}

export interface LlmCallSummaryDto {
    id: string;
    featureType: string;
    status: string;
    modelId: string;
    /** Actual input tokens. For in-flight rows (CREATED/RESERVED/RUNNING), falls back to the reservation estimate. Null when the call terminated without consuming or reporting input tokens (e.g. REJECTED_QUOTA). */
    inputTokens: number | null;
    /** Actual output tokens. For in-flight rows, falls back to the reservation estimate. Null when the call terminated without producing output (e.g. REJECTED_QUOTA, FAILED before invocation). */
    outputTokens: number | null;
    /** Final cost in microUSD; null when not yet settled */
    costMicrousd: number | null;
    latencyMs: number | null;
    errorCode: string | null;
    errorMessage: string | null;
    /** ISO timestamp */
    createdAt: string;
    /** ISO timestamp; null when not yet completed */
    completedAt: string | null;
}

export interface LlmSublimitConfigDto {
    id: string;
    organizationId: string;
    featureType: string;
    /** Attribute key the cap scopes to (must be in QUOTA_ATTRIBUTE_REGISTRY) */
    attributeKey: string;
    enabled: boolean;
    period: 'TOTAL' | 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC';
    maxRequests: number;
}

export interface UpsertSublimitBodyDto {
    enabled: boolean;
    period: 'TOTAL' | 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC';
    /** Required cap on requests per period */
    maxRequests: number;
}

export interface SublimitUsageDto {
    organizationId: string;
    featureType: string;
    attributeKey: string;
    attributeValue: string;
    period: 'TOTAL' | 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC';
    /** @format date-time */
    periodStart: string;
    requestsUsed: number;
    requestsReserved: number;
    /** requestsUsed + requestsReserved (drives "top consumers" sort) */
    requestsTotal: number;
}

export interface StaffDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "Jeff Menuson" */
    name: string;
    /** @example "123456789" */
    phone?: string;
    /** @example ["RN","LPN"] */
    disciplines: string[];
    active: boolean;
    verified: boolean;
    lockedOut?: object;
    scheduledVisitDates?: string[];
}

export interface ReferenceDataDto {
    id: string;
    label: string;
}

export interface DemographicDataDto {
    language: ReferenceDataDto[];
    marital: ReferenceDataDto[];
    religion: ReferenceDataDto[];
    ethnicity: ReferenceDataDto[];
}

export interface SearchDiagnosisDataDto {
    code: string;
    description: string;
}

export interface StrengthResponseDto {
    /** @example "100" */
    number: string;
    /** @example "mg/5mL" */
    unit: string;
}

export interface IngredientResponseDto {
    /** @example "15687-27-1" */
    cas: string;
    /** @example "DB01050" */
    drugbank_id: string;
    /** @example "Ibuprofen" */
    name: string;
    strength: StrengthResponseDto;
}

export interface SearchMedicationResponseDto {
    /** @example "010504554" */
    id: string;
    /** @example "DB01050" */
    sourceId: string;
    /** @example "drugbank" */
    sourceName: string;
    /** @example false */
    allergen: boolean;
    /** @example true */
    approved: boolean;
    /** @example "US" */
    country: string;
    /** @example "Liquid" */
    dosage_form: string;
    dpd_codes?: string[] | null;
    ema_ma_numbers?: string[] | null;
    ema_product_codes?: string[] | null;
    /** @example true */
    generic: boolean;
    /** @example [] */
    images: string[];
    ingredients: IngredientResponseDto[];
    /** @example false */
    mixture: boolean;
    /** @example "Ibuprofen" */
    name: string;
    /** @example ["00363-0685"] */
    ndc_product_codes: string[];
    /** @example true */
    otc: boolean;
    /** @example "Ibuprofen 2% Oral Liquid" */
    prescribable_name: string;
    /** @example "Oral" */
    route: string;
    /** @example "ibuprofen 100 MG in 5 mL Oral Suspension" */
    rx_norm_prescribable_name: string;
    strength: StrengthResponseDto;
    /** @example false */
    unapproved: boolean;
    /** @example false */
    vaccine: boolean;
}

export interface SupplyDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "gauze 2x2" */
    name: string;
    /** @example "A6403" */
    serviceCode: string | null;
    /** @example "0272" */
    revenueCode: string;
    /** @example "Advanced Wound Care" */
    category: string | null;
}

export interface CreatePatientDto {
    /** @example "Sarah" */
    firstName: string;
    /** @example "Samantha" */
    middleName?: string;
    /** @example "Smith" */
    lastName: string;
    /** @example "Jr." */
    suffix?: string;
    /** @example "20001212" */
    dob: string;
    /** @example "male" */
    gender: 'male' | 'female';
    /** @example "123456789" */
    ssn?: string;
    /** @example false */
    skipSsn?: boolean;
}

export interface ExistingPatientDto {
    /** @example "Sarah" */
    firstName?: string;
    /** @example "Samantha" */
    middleName?: string;
    /** @example "Smith" */
    lastName?: string;
    /** @example "Jr." */
    suffix?: string;
    /** @example "20001212" */
    dob?: string;
    /** @example "male" */
    gender?: 'male' | 'female';
    /** @example "123456789" */
    ssn?: string;
    /** @example false */
    skipSsn?: boolean;
    /**
     * ID of an existing patient to create a new admission for
     * @example "patient-123"
     */
    patientId: string;
}

export interface AdmissionPatientSummaryDto {
    /** @example "Jeff" */
    firstName: string;
    /** @example "Jeff" */
    middleName?: string;
    /** @example "Jeff" */
    lastName: string;
    /** @example "III" */
    suffix?: string;
    /** @example "male" */
    gender: 'male' | 'female';
    /** @example "01-01-1982" */
    dob: string;
    /** @example "12345" */
    ssn?: string;
    /** @example true */
    skipSsn?: boolean;
    status: 'REFERRAL' | 'INTAKE' | 'NON_ADMIT' | 'PENDING' | 'ADMITTED' | 'TRANSFERRED' | 'DISCHARGED' | 'DECEASED';
}

export interface InsuranceVisitTypeCodeDto {
    id: string;
    visitTypeId: string;
    visitTypeTitle: string;
    revenueCode: string;
    serviceCode: string;
    notApplicable?: boolean;
    contractedRate?: string | null;
    contractedRateBasis?: 'per_unit' | 'per_visit' | null;
}

export interface InsuranceConfigDto {
    id: string;
    insuranceId: string;
    payerId?: string;
    payerName?: string;
    disableMedicareBillingPeriod?: boolean;
    /** Number of days before authorization expiry to show warning (overrides global default if set) */
    warningDaysBeforeExpiry?: number | null;
    contractStartDate?: string | null;
    contractEndDate?: string | null;
    /** Days before contract end to show warning (overrides global default if set) */
    warningDaysBeforeContractExpiry?: number | null;
    /** Whether this insurance requires authorization for visits */
    requiresAuthorization?: boolean;
    paymentMethod?: 'per_visit_type' | 'per_unit' | 'per_visit' | null;
    /** Cost for per_unit or per_visit payment methods */
    cost?: string | null;
    /** Per-visit-type revenue/service code overrides saved for this insurance. */
    visitTypeCodes: InsuranceVisitTypeCodeDto[];
}

export interface InsuranceProviderDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "name" */
    name: string;
    /** @example "1234" */
    payerId: string;
    config?: InsuranceConfigDto;
}

export interface ServiceHistoryDto {
    id: string;
    serviceType: string;
    npi: string;
    name?: string;
    contactPerson?: string;
    address?: string;
    phone?: string;
    fax?: string;
    serviceDate: string;
}

export interface AdditionalInformationDto {
    description?: string;
}

export interface BenefitsAdditionalInformationDto {
    alternativeListId?: string;
    coverageListId?: string;
    drugFormularyNumber?: string;
    familyUnitNumber?: string;
    groupDescription?: string;
    groupNumber?: string;
    hicNumber?: string;
    insurancePolicyNumber?: string;
    medicaidRecepientIdNumber?: string;
    medicalAssistanceCategory?: string;
    memberId?: string;
    planDescription?: string;
    planNetworkDescription?: string;
    planNetworkIdNumber?: string;
    planNumber?: string;
    policyNumber?: string;
    priorAuthorizationNumber?: string;
    referralNumber?: string;
}

export interface AdmissionDischargeDto {
    date?: string;
    endDate?: string;
    startDate?: string;
}

export interface BenefitsDateInformationDto {
    added?: string;
    admission?: string;
    admissions?: AdmissionDischargeDto[];
    benefit?: string;
    benefitBegin?: string;
    benefitEnd?: string;
    certification?: string;
    cobraBegin?: string;
    cobraEnd?: string;
    completion?: string;
    coordinationOfBenefits?: string;
    dateOfDeath?: string;
    dateOfLastUpdate?: string;
    discharge?: string;
    discharges?: AdmissionDischargeDto[];
    effectiveDateOfChange?: string;
    eligibility?: string;
    eligibilityBegin?: string;
    eligibilityEnd?: string;
    enrollment?: string;
    issue?: string;
    latestVisitOrConsultation?: string;
    periodEnd?: string;
    periodStart?: string;
    plan?: string;
    planBegin?: string;
    planEnd?: string;
    policyEffective?: string;
    policyExpiration?: string;
    premiumPaidToDateEnd?: string;
    premiumPaidtoDateBegin?: string;
    primaryCareProvider?: string;
    service?: string;
    status?: string;
}

export interface BenefitsRelatedEntityAddressDto {
    address1?: string;
    address2?: string;
    city?: string;
    countryCode?: string;
    countrySubDivisionCode?: string;
    postalCode?: string;
    state?: string;
}

export interface ContactDto {
    communicationMode?: string;
    communicationNumber?: string;
}

export interface ContactInformationDto {
    contacts?: ContactDto[];
    name?: string;
}

export interface BenefitsRelatedEntityDto {
    address?: BenefitsRelatedEntityAddressDto;
    contactInformation?: ContactInformationDto;
    entityFirstname?: string;
    entityIdentification?: string;
    entityIdentificationValue?: string;
    entityIdentifier?: string;
    entityMiddlename?: string;
    entityName?: string;
    entityRelationship?: string;
    entitySuffix?: string;
    entityType?: string;
    providerInformation?: string;
}

export interface BenefitsServiceDeliverDto {
    deliveryOrCalendarPatternCode?: string;
    deliveryOrCalendarPatternQualifier?: string;
    deliveryOrCalendarPatternQualifierCode?: string;
    deliveryPatternTimeCode?: string;
    deliveryPatternTimeQualifier?: string;
    deliveryPatternTimeQualifierCode?: string;
    numOfPeriods?: string;
    quantity?: string;
    quantityQualifier?: string;
    quantityQualifierCode?: string;
    sampleSelectionModulus?: string;
    timePeriodQualifier?: string;
    timePeriodQualifierCode?: string;
    unitForMeasurementCode?: string;
    unitForMeasurementQualifier?: string;
    unitForMeasurementQualifierCode?: string;
}

export interface CompositeMedicalProcedureIdentifierDto {
    diagnosisCodePointer?: string[];
    procedureCode?: string;
    procedureModifiers?: string[];
    productOrServiceID?: string;
    productOrServiceIDQualifier?: string;
    productOrServiceIDQualifierCode?: string;
}

export interface EligibilityAdditionalInformationDto {
    codeCategory?: string;
    codeListQualifier?: string;
    codeListQualifierCode?: string;
    industry?: string;
    industryCode?: string;
    injuredBodyPartName?: string;
}

export interface BenefitsInformationDto {
    additionalInformation?: AdditionalInformationDto[];
    authOrCertIndicator?: string;
    benefitAmount?: string;
    benefitPercent?: string;
    benefitQuantity?: string;
    benefitsAdditionalInformation?: BenefitsAdditionalInformationDto;
    benefitsDateInformation?: BenefitsDateInformationDto;
    benefitsRelatedEntities?: BenefitsRelatedEntityDto[];
    benefitsRelatedEntity?: BenefitsRelatedEntityDto;
    benefitsServiceDelivery?: BenefitsServiceDeliverDto[];
    code?: string;
    compositeMedicalProcedureIdentifier?: CompositeMedicalProcedureIdentifierDto;
    coverageLevel?: string;
    coverageLevelCode?: string;
    eligibilityAdditionalInformation?: EligibilityAdditionalInformationDto;
    eligibilityAdditionalInformationList?: EligibilityAdditionalInformationDto[];
    headerLoopIdentifierCode?: string;
    inPlanNetworkIndicator?: string;
    inPlanNetworkIndicatorCode?: string;
    insuranceType?: string;
    insuranceTypeCode?: string;
    name?: string;
    planCoverage?: string;
    quantityQualifier?: string;
    quantityQualifierCode?: string;
    serviceTypeCodes?: string[];
    serviceTypes?: string[];
    timeQualifier?: string;
    timeQualifierCode?: string;
    trailerLoopIdentifierCode?: string;
}

export interface CoverageDto {
    type: string;
    benefits: BenefitsInformationDto[];
}

export interface ServiceDto {
    type: string;
    coverages: CoverageDto[];
}

export interface EligibilityDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "approved" */
    result: 'approved' | 'rejected' | 'pending';
    /** @example "Invalid insurance" */
    reason?: string;
    /** @example "" */
    notes?: string;
    /** @example "availity" */
    type: string;
    /** @example "21/12/2024" */
    date: string;
    /** @example "John Smith" */
    user: string;
    serviceHistory?: ServiceHistoryDto[];
    services?: ServiceDto[];
}

export interface AdmissionInsuranceDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "medicare" */
    insuranceType: 'medicare' | 'medicaid' | 'private' | 'self-pay' | 'no-pay';
    payer?: InsuranceProviderDto;
    /** @example "ASDFDF-SDFSDFSD" */
    memberId?: string;
    /** @example "ASDFDF-SDFSDFSD" */
    groupId?: string;
    /** @example "ASDFDF-SDFSDFSD" */
    relationship?: string;
    /** @example false */
    primary: boolean;
    /** Set of checks for the insurance */
    eligibility?: EligibilityDto[];
}

export interface AdminssionLanguageDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "English" */
    name: string;
}

export interface AdmissionDemographicsDto {
    language?: AdminssionLanguageDto;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    religionId?: string;
    religion?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    maritalStatusId?: string;
    maritalStatus?: string;
    /** @example "['Yes, Puerto Rican', 'Yes, another Hispanic, Latino or Spanish origin']" */
    ethnicity?: string[];
    /** @example "['American Indian or Alaska Native', 'Yes, another Hispanic, Latino or Spanish origin']" */
    race?: string[];
    requiresTranslator: boolean | null;
}

export interface PatientPhoneDto {
    id?: string;
    number: string;
    primary: boolean;
}

export interface PatientAddressDto {
    id?: string;
    addressId?: string;
    primary: boolean;
    address: string;
    city: string;
    state: string;
    zipcode: string;
    homeType: string;
    accessCode?: string | null;
    callBell?: 'yes' | 'no' | null;
    notes?: string | null;
    livingWith?: string[] | null;
    livingWithOther?: string | null;
}

export interface AdmissionContactsDto {
    /** @example "johnny_bravo@gmail.com" */
    email: string;
    pointOfContact: 'yes' | 'no';
    phones: PatientPhoneDto[];
    addresses: PatientAddressDto[];
}

export interface PhoneDto {
    id?: string;
    number: string;
    primary: boolean;
}

export interface PatientCaregiverDto {
    id?: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    suffixName?: string;
    email: string;
    relationship?: 'spouse' | 'sibling' | 'child' | 'other';
    relationshipOther?: string | null;
    availibility?: string;
    abilityToProvideCare?: 'able' | 'limited' | 'unable';
    abilityToProvideCareNote?: string;
    emergencyContact?: boolean;
    legalRepresentative?: boolean;
    primary?: boolean;
    primaryContact?: boolean;
    phones: PhoneDto[];
}

export interface AdmissionSupportDto {
    powerOfAttorney: 'yes' | 'no';
    powerOfAttorneyName?: string | null;
    powerOfAttorneyCopyObtained?: boolean | null;
    communityServices?: string[];
    communityServicesOther?: string | null;
    caregivers?: PatientCaregiverDto[];
}

export interface ReferralDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "" */
    receivedBy: string;
    /** @example "" */
    referralSource: string;
    /** @example "" */
    admitSource: string;
    /** @example "2024-01-01" */
    referralDate?: string | null;
    /** @example "" */
    unknownReferralDate: boolean;
    /** @example "2024-01-01" */
    startOfCareDate?: string | null;
    /** @example "" */
    noStartOfCareDate: boolean;
    careType: ('SN' | 'PT' | 'OT' | 'ST' | 'MSW' | 'OTHER')[];
    /** @example "Wound care" */
    careTypeOther?: string | null;
    /** @example "Notes" */
    notes?: string;
    /** @example "Instructions" */
    specificInstructions?: string;
}

export interface AddressDto {
    /** @example "123 High Street" */
    address: string;
    /** @example "Gotham City" */
    city: string;
    /** @example "MN" */
    state: string;
    /** @example "12345" */
    zipcode: string;
    /** @example "123 High Street, Gotham City, MN 12345" */
    completeAddress?: string;
}

export interface PhysicianAddressDto {
    id: string;
    phone: string | null;
    fax: string | null;
    type: string;
    address: AddressDto;
}

export interface PhysicianDto {
    id: string;
    label: string;
    name: string;
    npi: string;
    addresses: PhysicianAddressDto[];
    firstName: string;
    lastName: string;
    credential: string | null;
    pecos: boolean;
    city?: string;
    state?: string;
    phone?: string | null;
    fax?: string | null;
    email?: string | null;
}

export interface PatientAdmissionPhysicianDto {
    physician: PhysicianDto;
    roles: ('referring' | 'PCP' | 'F2F')[];
    primary: boolean | null;
    overseePlanOfCare: boolean | null;
}

export interface PharmacyDto {
    id: string;
    label: string;
    address?: AddressDto | null;
    name: string;
    phone: string;
    fax: string | null;
}

export interface PatientAdmissionPharmacyDto {
    pharmacy: PharmacyDto;
    primary: boolean | null;
}

export interface AdmissionProvidersDto {
    physicians?: PatientAdmissionPhysicianDto[];
    pharmacies?: PatientAdmissionPharmacyDto[];
}

export interface DiagnosisDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    endVisitId?: string;
    /** @example "IC.03" */
    code: string;
    /** @example "heart issues" */
    description: string;
    /** @example true */
    primary: boolean;
    /** @example "2024-01-01" */
    onset?: string;
    /** @example "3" */
    severity?: string | null;
    /** @format date-time */
    deletedAt?: string;
}

export interface PatientRiskDto {
    risk: string;
    severity: string;
}

export interface PatientAllergyDto {
    allergy: string;
    severity: string;
}

export interface AdmissionRisksAllergiesDto {
    risks?: PatientRiskDto[];
    allergies?: PatientAllergyDto[];
}

export interface AdmissionMedicationApprovedDto {
    admissionId: string;
    approvedById?: string | null;
    approvedBy?: string | null;
    /** @format date-time */
    approvedDate?: string | null;
    /** @format date-time */
    updatedAt?: string | null;
}

export interface AdmissionDocumentRequestDto {
    id: string;
    admissionId: string;
    name: string;
    status: 'requested' | 'fulfilled' | 'cancelled';
    fileId?: string | null;
    fileUrl?: string | null;
    fileName?: string | null;
    fileContentType?: string | null;
    custom: boolean;
    mandatory: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    createdByName?: string | null;
    updatedByName?: string | null;
    noteCount: number;
}

export interface AdmissionDto {
    /**
     * The id of the admission
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    patientId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    patient: AdmissionPatientSummaryDto;
    insurance: AdmissionInsuranceDto[];
    demographics?: AdmissionDemographicsDto;
    contacts: AdmissionContactsDto;
    support: AdmissionSupportDto;
    referral?: ReferralDto;
    providers: AdmissionProvidersDto;
    diagnoses: DiagnosisDto[];
    risksAllergies: AdmissionRisksAllergiesDto;
    admissionStatus: object;
    medicationApprovals?: AdmissionMedicationApprovedDto;
    documentRequests?: AdmissionDocumentRequestDto[];
}

export interface UpdatePatientDto {
    /** @example "Sarah" */
    firstName: string;
    /** @example "Samantha" */
    middleName?: string;
    /** @example "Smith" */
    lastName: string;
    /** @example "Jr." */
    suffix?: string;
    /** @example "20001212" */
    dob: string;
    /** @example "male" */
    gender: 'male' | 'female';
    /** @example "123456789" */
    ssn?: string;
    /** @example false */
    skipSsn?: boolean;
}

export interface AdmissionPatientDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "Jeff" */
    firstName: string;
    /** @example "Jeff" */
    middleName?: string;
    /** @example "Jeff" */
    lastName: string;
    /** @example "III" */
    suffix?: string;
    /** @example "male" */
    gender: 'male' | 'female';
    /** @example "01-01-1982" */
    dob: string;
    /** @example "12345" */
    ssn?: string;
    /** @example true */
    skipSsn?: boolean;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    languageId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    religionId?: string;
    /** @example "['Yes, Puerto Rican', 'Yes, another Hispanic, Latino or Spanish origin']" */
    ethnicity?: string[] | null;
    /** @example "['American Indian or Alaska Native', 'Yes, another Hispanic, Latino or Spanish origin']" */
    race?: string[] | null;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    maritalStatusId?: string;
    requiresTranslator: boolean | null;
    powerOfAttorney: 'yes' | 'no';
    communityServices?: string[];
    communityServicesOther?: string | null;
    /** @example "medicare" */
    insuranceType: 'medicare' | 'private' | 'self-pay' | 'no-pay';
    /** @example "12345678" */
    memberId?: string;
    /** @example "johnny_bravo@gmail.com" */
    email: string;
    pointOfContact: 'yes' | 'no';
    phones: PatientPhoneDto[];
    addresses: PatientAddressDto[];
    caregivers?: PatientCaregiverDto[];
    risks: PatientRiskDto[];
    allergies: PatientAllergyDto[];
}

export interface PatientListItemDto {
    /**
     * Patient ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    id: string;
    /**
     * Patient name in "Last, First" format
     * @example "Smith, Sarah"
     */
    name: string;
    /**
     * Date of birth
     * @example "01/01/1982"
     */
    dob: string;
    /**
     * Patient status
     * @example "ADMITTED"
     */
    status: 'REFERRAL' | 'INTAKE' | 'PENDING' | 'NON_ADMIT' | 'ADMITTED' | 'TRANSFERRED' | 'DISCHARGED' | 'DECEASED';
    /**
     * Branch ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    branchId: string;
    /**
     * Branch name
     * @example "Dallas Sands"
     */
    branchName: string;
    /**
     * Admission ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    admissionId: string;
    /**
     * Admission number
     * @example 1
     */
    admissionNumber: number;
    /**
     * Episode number
     * @example 1
     */
    episodeNumber: number | null;
    /**
     * Primary phone number
     * @example "(555) 123-4567"
     */
    primaryPhone?: string | null;
    /**
     * Primary insurance name
     * @example "Aetna"
     */
    primaryInsuranceName?: string | null;
    /**
     * Primary physician name
     * @example "Smith, John MD"
     */
    primaryPhysician?: string | null;
    /**
     * Actual Start of Care date (M0030) from the episode 1 SOC OASIS assessment, regardless of current patient status. Blank if no SOC OASIS with M0030 entered exists yet.
     * @example "01/20/2025"
     */
    socDate?: string | null;
}

export interface PatientListPaginationMeta {
    /**
     * Current page number (1-indexed)
     * @example 1
     */
    currentPage: number;
    /**
     * Number of records per page
     * @example 50
     */
    pageSize: number;
    /**
     * Total number of records matching query
     * @example 1234
     */
    totalRecords: number;
    /**
     * Total number of pages
     * @example 25
     */
    totalPages: number;
}

export interface PatientListResponseDto {
    /** Array of patient list items */
    data: PatientListItemDto[];
    /** Pagination metadata */
    meta: PatientListPaginationMeta;
}

export interface CommunicationNoteParticipantDto {
    id: string;
    name: string;
    userId?: string | null;
}

export interface FileDto {
    id: string;
    name: string;
    url: string;
    title: object;
    notes: object;
    contentType: object;
    uploadedBy: string;
    /** @format date-time */
    uploadedDate: string;
}

export interface CommunicationNoteEventDto {
    id: string;
    type:
        | 'created'
        | 'submitted'
        | 'confirmed'
        | 'approved'
        | 'changes_requested'
        | 'reassigned'
        | 'archived'
        | 'restored'
        | 'linked_order';
    detail?: string | null;
    fromApproverName?: string | null;
    toApproverName?: string | null;
    /** @format date-time */
    occurredAt: string;
    createdByName: string;
}

export interface CommunicationNoteDto {
    id: string;
    patientId: string;
    admissionId: string;
    branchId: string;
    type: 'physician' | 'family' | 'facility' | 'pharmacy' | 'internal' | 'other';
    direction?: 'incoming' | 'outgoing' | null;
    method: 'phone' | 'fax' | 'email' | 'in_person' | 'portal';
    contactName: string;
    subject: string;
    narrative: string;
    isVerbalOrder: boolean;
    physicianId?: string | null;
    physicianName?: string | null;
    /** True once a verbal order has been read back and confirmed by a second clinician */
    isConfirmed: boolean;
    verbalOrderConfirmedByName?: string | null;
    /** @format date-time */
    verbalOrderConfirmedAt?: string | null;
    /** Server-computed — whether this note requires approval before it can be finalized */
    requiresApproval: boolean;
    /** @format date-time */
    occurredAt: string;
    status: 'draft' | 'pending_approval' | 'approved' | 'changes_requested';
    /** Set only on a note forked from a changes-requested original */
    previousVersionId?: string | null;
    /** The first version in this note's chain */
    rootNoteId?: string | null;
    approverId?: string | null;
    approverName?: string | null;
    followUpNeeded: boolean;
    /** @format date-time */
    archivedAt?: string | null;
    archivedByName?: string | null;
    /** Linked visit form, if any */
    visitFormId?: string | null;
    /** Linked order, if any */
    orderId?: string | null;
    /** Author user id — used client-side to gate self-approval */
    createdBy: string;
    createdByName: string;
    /** @format date-time */
    createdAt: string;
    participants: CommunicationNoteParticipantDto[];
    files: FileDto[];
    events: CommunicationNoteEventDto[];
}

export interface CreateCommunicationNoteParticipantDto {
    name: string;
    userId?: string;
}

export interface CreateCommunicationNoteDto {
    patientId: string;
    type: 'physician' | 'family' | 'facility' | 'pharmacy' | 'internal' | 'other';
    /** Omitted for internal (care-team-to-care-team) notes */
    direction?: 'incoming' | 'outgoing';
    method: 'phone' | 'fax' | 'email' | 'in_person' | 'portal';
    contactName: string;
    subject: string;
    narrative: string;
    /** Defaults to the server time when omitted */
    occurredAt?: string;
    isVerbalOrder?: boolean;
    /** Ordering practitioner; required when isVerbalOrder is true */
    physicianId?: string;
    followUpNeeded?: boolean;
    participants?: CreateCommunicationNoteParticipantDto[];
    /** Ids of files already uploaded via the file upload endpoint */
    fileIds?: string[];
    /** Linked visit form — at most one per note */
    visitFormId?: string;
    /** Linked order — at most one per note */
    orderId?: string;
}

export interface SubmitCommunicationNoteDto {
    /** Chosen approver — only meaningful when the note actually requires approval */
    approverId?: string;
}

export interface RequestChangesDto {
    /** Required — the client cannot submit an empty review comment */
    comment: string;
}

export interface ReassignCommunicationNoteDto {
    approverId: string;
}

export interface ConfirmVerbalOrderDto {
    /** Optional note captured during the confirming read-back */
    confirmationNote?: string;
}

export interface LinkOrderDto {
    /** The order this note relates to — attached after the fact, e.g. once a verbal order has a real order record */
    orderId: string;
}

export interface UpdateDemographicsDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    languageId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    religionId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    maritalStatusId?: string;
    /** @example "['Yes, Puerto Rican', 'Yes, another Hispanic, Latino or Spanish origin']" */
    ethnicity?: string[];
    /** @example "['American Indian or Alaska Native', 'Yes, another Hispanic, Latino or Spanish origin']" */
    race?: string[];
    requiresTranslator?: boolean | null;
}

export interface DemographicsDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    patientId: string;
    language: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    languageId: string;
    religion: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    religionId: string;
    /** @example "['Yes, Puerto Rican', 'Yes, another Hispanic, Latino or Spanish origin']" */
    ethnicity: string[];
    /** @example "['American Indian or Alaska Native', 'Yes, another Hispanic, Latino or Spanish origin']" */
    race: string[];
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    maritalStatusId: string;
    maritalStatus: string;
    requiresTranslator: boolean;
}

export interface UpdateDiagnosisDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "IC.03" */
    code: string;
    /** @example "heart issues" */
    description: string;
    /** @example true */
    primary: boolean;
    /** @example "2024-01-01" */
    onset?: string;
    /** @example "Moderate" */
    severity?: string;
}

export interface UpdateReferralDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "" */
    receivedBy: string;
    /** @example "" */
    referralSource: string;
    /** @example "" */
    admitSource: string;
    /** @example "2024-01-01" */
    referralDate?: string | null;
    /** @example false */
    unknownReferralDate?: boolean;
    /** @example "2024-01-01" */
    startOfCareDate?: string | null;
    /** @example false */
    noStartOfCareDate?: boolean;
    careType: ('SN' | 'PT' | 'OT' | 'ST' | 'MSW' | 'OTHER')[];
    /** @example "Wound care" */
    careTypeOther?: string | null;
    /** @example "Notes" */
    notes?: string;
    /** @example "Instructions" */
    specificInstructions?: string;
}

export interface CreateInsuranceDto {
    /** @example "medicare" */
    insuranceType: 'medicare' | 'medicaid' | 'private' | 'self-pay' | 'no-pay';
    /** @example "ASDFDF-SDFSDFSD" */
    payerId?: string;
    /** @example "AETNA" */
    payerName?: string;
    /** @example "ASDFDF-SDFSDFSD" */
    memberId?: string;
    /** @example "ASDFDF-SDFSDFSD" */
    groupId?: string;
    /** @example "ASDFDF-SDFSDFSD" */
    relationship?: string;
}

export interface UpdateEligibilityDto {
    /** @example "approved" */
    status: 'approved' | 'rejected';
    /** @example "Notes" */
    notes?: string;
}

export interface SingleInboxTransactionBranchDto {
    name: string;
    npi: string;
}

export interface SingleInboxTransactionPatientDto {
    /** Patient name in "Last, First" format */
    name: string;
    memberId: string;
    dob: string;
    insuranceId: string;
}

export interface SingleInboxTransactionStatusDto {
    claimId: string;
    message: string;
    totalCharge: number;
    statusCode: string[];
    category: string;
    status: string;
    rejected: boolean;
}

export interface SingleInboxTransactionClaimsDto {
    claimId: string;
    fileType: string;
    branch: SingleInboxTransactionBranchDto;
    patient: SingleInboxTransactionPatientDto;
    billType: string;
    serviceDate: string;
    totalRejectedQty: number;
    totalRejectedAmt: number;
    totalAcceptedQty: number;
    totalAcceptedAmt: number;
    chargedAmount: number;
    status: SingleInboxTransactionStatusDto[];
}

export interface SingleInboxTransactionDto {
    claims: SingleInboxTransactionClaimsDto[];
}

export interface InboxTransaction {
    claimId: string;
    type: string;
    processedAt: string;
    status: string;
    claimType: string;
    /** Patient name in "Last, First" format */
    name: string;
    memberId: string;
    dob: string;
    branch: string;
    transactionId: string;
    year: string;
}

export interface InboxTransactionsDto {
    '277': InboxTransaction[];
    '835': InboxTransaction[];
    '999': InboxTransaction[];
}

export interface FormVersionDto {
    name?: string | null;
    effectiveFrom: string;
}

export interface FormDto {
    id: string;
    name: string;
    title: string;
    timepoint?: string;
    versions?: FormVersionDto[];
    category?: 'order' | 'eval' | 'routine-visit' | 'other';
    discipline?: 'SN' | 'PT' | 'OT' | 'ST' | 'HHA' | 'MSW';
}

export interface VisitTypeDto {
    id: string;
    type: string;
    title: string;
    status: string;
    discipline: string;
    employeeClass: string;
    revenueCodeId: string;
    serviceCodeId: string;
    /** Resolved default revenue code string for this visit type. */
    defaultRevenueCode?: string | null;
    /** Resolved default service code string for this visit type. */
    defaultServiceCode?: string | null;
    defaultPay?: number | null;
    defaultHours?: number | null;
    adminCost?: number | null;
    payable?: boolean | null;
    payType?: string | null;
    billable?: boolean | null;
    roundHours?: boolean | null;
    mileage?: boolean | null;
    surcharge?: boolean | null;
    additionalPay?: boolean | null;
    forms: FormDto[];
}

export interface InsuranceConfigFormVisitTypeCodeRowDto {
    visitTypeId: string;
    visitTypeTitle: string;
    /** True when this active visit type has no saved override on the configuration yet. */
    isNew: boolean;
    revenueCode: string;
    serviceCode: string;
    notApplicable?: boolean;
    contractedRate?: string | null;
    contractedRateBasis?: 'per_unit' | 'per_visit' | null;
}

export interface InsuranceConfigFormInitialValuesDto {
    id?: string | null;
    payerId: string;
    payerName: string;
    disableMedicareBillingPeriod?: boolean;
    /** Number of days before authorization expiry to show warning (overrides global default if set) */
    warningDaysBeforeExpiry?: number | null;
    contractStartDate?: string | null;
    contractEndDate?: string | null;
    /** Days before contract end to show warning (overrides global default if set) */
    warningDaysBeforeContractExpiry?: number | null;
    /** Whether this insurance requires authorization for visits */
    requiresAuthorization?: boolean;
    paymentMethod?: 'per_visit_type' | 'per_unit' | 'per_visit' | null;
    cost?: string | null;
    /** One row per active visit type with defaults merged against saved overrides when editing. */
    visitTypeCodes: InsuranceConfigFormVisitTypeCodeRowDto[];
}

export interface InsuranceConfigFormDataDto {
    /** Active visit types only (same set used to build visit type code rows). */
    visitTypes: VisitTypeDto[];
    initialFormValues: InsuranceConfigFormInitialValuesDto;
    /** When false, delete must be disabled: this payer is still linked to patient insurance (and related billing claims). */
    canDelete: boolean;
}

export interface InsuranceConfigContractHistoryItemDto {
    contractStartDate?: string | null;
    contractEndDate?: string | null;
    warningDaysBeforeContractExpiry?: number | null;
    /** When this contract version was last saved (ISO 8601). */
    updatedAt?: string | null;
    updatedByName?: string | null;
    updatedByRoleName?: string | null;
    updatedByDisciplines?: string[];
}

export interface SaveInsuranceVisitTypeCodeDto {
    visitTypeId: string;
    notApplicable?: boolean;
    revenueCode: string;
    serviceCode: string;
    contractedRate?: string;
    contractedRateBasis?: 'per_unit' | 'per_visit';
}

export interface SaveInsuranceConfigDto {
    id?: string | null;
    payerName: string;
    payerId: string;
    disableMedicareBillingPeriod?: boolean;
    /**
     * Number of days before authorization expiry to show warning (1-90 days, or null to use global default)
     * @min 1
     * @max 90
     */
    warningDaysBeforeExpiry?: number | null;
    /** Contract effective start date (YYYY-MM-DD) */
    contractStartDate?: string | null;
    /** Contract effective end date (YYYY-MM-DD); null for open-ended */
    contractEndDate?: string | null;
    /**
     * Days before contract end to show warning (1-90, or null for global default of 30)
     * @min 1
     * @max 90
     */
    warningDaysBeforeContractExpiry?: number | null;
    /** Whether this insurance requires authorization for visits (default: true for private insurance) */
    requiresAuthorization?: boolean;
    paymentMethod?: 'per_visit_type' | 'per_unit' | 'per_visit' | null;
    /** Cost for per_unit or per_visit payment methods */
    cost?: string | null;
    /** Per-visit-type revenue/service code overrides for this insurance. One row per active visit type is required. */
    visitTypeCodes: SaveInsuranceVisitTypeCodeDto[];
}

export interface InsuranceConfigListItemDto {
    /** Config id when configured; null for pending payers. */
    id?: string | null;
    insuranceId: string;
    payerId: string;
    payerName: string;
    status: 'active' | 'inactive' | 'requires_configuration' | 'expiring_soon';
    /** Days until contract end when status is expiring_soon. */
    contractDaysRemaining?: number | null;
    /** True when the payer is unconfigured and can be dismissed from the settings queue. */
    canDismiss: boolean;
    disableMedicareBillingPeriod?: boolean;
    requiresAuthorization?: boolean;
    warningDaysBeforeExpiry?: number | null;
    contractStartDate?: string | null;
    contractEndDate?: string | null;
    paymentMethod?: 'per_visit_type' | 'per_unit' | 'per_visit' | null;
}

export interface OperatingHourDto {
    start: string;
    end: string;
}

export interface OperatingHoursDto {
    monday?: OperatingHourDto[];
    tuesday?: OperatingHourDto[];
    wednesday?: OperatingHourDto[];
    thursday?: OperatingHourDto[];
    friday?: OperatingHourDto[];
    saturday?: OperatingHourDto[];
    sunday?: OperatingHourDto[];
}

export interface BranchDto {
    id: string;
    name: string;
    address?: AddressDto;
    hotlineName?: string;
    hotlineAddress?: AddressDto;
    hotlinePhone?: string;
    medicareProviderNumber?: string;
    statefacilityId?: string;
    stateBranchId?: string;
    ptan?: string;
    operatingHours?: OperatingHoursDto;
    npi?: string;
    accreditationBody?: string;
    accreditationId?: string;
    defaultBranch?: boolean;
    administrator: string;
    administratorPhone: string;
    administratorFax?: string | null;
    defaultChargeSN: string;
    defaultChargePT: string;
    defaultChargeOT: string;
    defaultChargeST: string;
    defaultChargeHHA: string;
    defaultChargeMSW: string;
}

export interface PatientDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "SK20EUDJ0212" */
    mrn: string;
    /** @example "Smith, Sarah" */
    name: string;
    /** @example "PENDING" */
    status: 'INTAKE' | 'PENDING' | 'NON_ADMIT' | 'ADMITTED' | 'TRANSFERRED' | 'DISCHARGED';
    /** @example 1 */
    admissionNumber: number;
    /** @example 1 */
    episodeNumber: number | null;
    /** @example "Aetna" */
    primaryInsuranceName?: string | null;
    /** @example "Smith, John MD" */
    primaryPhysician?: string | null;
    /** @example "(555) 123-4567" */
    primaryPhone?: string | null;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    admissionId: string;
    /** @example "Dallas Sands" */
    branchName: string;
    /** @example "01-01-1982" */
    dob: string;
    /** @example "12345" */
    ssn?: string;
    /** @example "male" */
    gender: 'male' | 'female';
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    languageId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    religionId?: string;
    /** @example "['Yes, Puerto Rican', 'Yes, another Hispanic, Latino or Spanish origin']" */
    ethnicity?: string[] | null;
    /** @example "['American Indian or Alaska Native', 'Yes, another Hispanic, Latino or Spanish origin']" */
    race?: string[] | null;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    maritalStatusId?: string;
    requiresTranslator?: boolean | null;
    powerOfAttorney: 'yes' | 'no';
    communityServices: string[] | null;
    communityServicesOther?: string | null;
    /** @example "medicare" */
    insuranceType: 'medicare' | 'private' | 'self-pay' | 'no-pay';
    /** @example "12345678" */
    memberId?: string;
    /** @example "(702) 445-1354" */
    phone?: string;
    /** @example "johnny_bravo@gmail.com" */
    email: string;
    pointOfContact: 'yes' | 'no';
    phones: PhoneDto[];
    addresses: PatientAddressDto[];
    caregivers?: PatientCaregiverDto[];
    risks: PatientRiskDto[];
    allergies: PatientAllergyDto[];
}

export interface VisitFormSupplyDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    supplyId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "gauze 2x2" */
    name: string;
    /** @example "3" */
    quantity: string;
    /** @example "5.00" */
    cost?: string | null;
    /** @example "2" */
    total?: string | null;
    /** @example "A6403" */
    serviceCode: string | null;
    /** @example "0272" */
    revenueCode: string;
}

export interface ProgressDto {
    id: string;
    visitDate: string;
    treated?: string;
    status?: string;
    depth?: string;
    length?: string;
    width?: string;
    tunneling?: string;
    tunnelingLocation?: string;
    undermining?: string;
    pressureUlcerStage?: string;
    woundEdges?: string;
    woundPain?: string;
    surroundingSkin?: string;
    drainageAmount?: string;
    drainageType?: string;
    odor?: string;
    woundBed?: string;
    woundBedGranulationPercentage?: string | null;
    woundBedSloughPercentage?: string | null;
    woundBedEscharPercentage?: string | null;
    woundBedEpithelializationPercentage?: string | null;
    drainsPresent?: string;
    surroundingTissue?: string;
    woundClosure?: string;
    dressingRemovedByDisc?: string[];
    dressingRemovedByOther?: string;
    technique?: string[];
    cleansedWith?: string;
    irrigatedWith?: string;
    treatmentApplied?: string;
    packedWith?: string;
    coveredWith?: string;
    securedWith?: string;
    toleratedWell?: string;
    comments?: string;
    infectionReportedMD?: boolean;
    newTreatmentOrder?: boolean;
    createdBy?: string;
}

export interface VisitFormWoundDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    location: string;
    type: string;
    progress: ProgressDto;
}

export interface AdmissionVaccinationDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    visitId?: string;
    endVisitId?: string;
    type: string;
    typeBrand?: string;
    typeBrandOther?: string;
    /** @format date-time */
    receivedDate: string;
    lotNumber: string;
    site: string;
    administeredBy: string;
}

export interface MedicationTeachingDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    medicationId: string;
    type: string;
    notes?: string | null;
    date: string;
}

export interface MedicationInteractions {
    id: string;
    medication: string;
    shortDescription: string;
    description: string;
    management: string;
    severity: string;
}

export interface InfectionMedication {
    infectionId: string;
    medicationId: string;
}

export interface FormOrderSummaryDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "00001" */
    number: string;
    /** @example "2020-02-02" */
    date: string;
    status: 'DRAFT' | 'QA' | 'READY' | 'SENT' | 'SIGNED' | 'CANCELLED' | 'CHANGES_REQUESTED';
}

export interface AdmissionMedicationDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    externalMedicationId: string;
    name: string;
    code: string;
    dose: string;
    doseUnit: string;
    frequencyA: string;
    frequencyB: string;
    frequencyC?: string;
    /** @format date-time */
    startDate?: string;
    /** @format date-time */
    stopDate?: string;
    route: string;
    administeredBy: string;
    prescribingPhysician?: string;
    instructions?: string;
    sideEffects?: string;
    contraindications?: string;
    prn?: boolean;
    highRisk?: boolean;
    specialInstructions?: string;
    teachings?: MedicationTeachingDto[];
    sourceId?: string;
    sourceName?: string;
    interactions?: MedicationInteractions[];
    /** @format date-time */
    inactivatedAt?: string | null;
    visitId?: string;
    diagnosis?: DiagnosisDto;
    infections?: InfectionMedication[];
    orderId?: string;
    endOrderId?: string;
    order?: FormOrderSummaryDto;
    /** @format date-time */
    completedAt?: string | null;
    /** @format date-time */
    completedAsOf?: string | null;
}

export interface AdmissionProblemTaskLogDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemGoalTaskId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitFormId: string;
    /** @format date-time */
    visitDate: string;
    visitType: string;
    note: string;
    performed: string;
    resolved: string;
    createdBy: string;
    /** @format date-time */
    createdAt: string;
    createdByName: string;
}

export interface AdmissionProblemTaskDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemGoalId: string;
    title: string;
    /** @format date-time */
    startDate: string;
    type: string;
    description: string;
    note?: string;
    orderId?: string;
    endOrderId?: string;
    order?: FormOrderSummaryDto;
    logs?: AdmissionProblemTaskLogDto[];
}

export interface AdmissionProblemGoalDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemId: string;
    title: string;
    discipline: string;
    /** @format date-time */
    startDate: string;
    duration: number;
    period: string;
    extendedDuration: number;
    extendedPeriod: string;
    description: string;
    note?: string;
    status?: 'unmet' | 'met';
    orderId?: string;
    endOrderId?: string;
    order?: FormOrderSummaryDto;
    tasks?: AdmissionProblemTaskDto[];
}

export interface AdmissionPlanOfCareDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    title: string;
    /** @format date-time */
    startDate: string;
    /** @format date-time */
    endDate?: string;
    disciplines: string[];
    type: string;
    description: string;
    note?: string;
    unmet: number;
    goals?: AdmissionProblemGoalDto[];
    /** The source type of this problem (e.g., care_protocol, template) */
    source?: string;
    /** The source ID referencing the original entity */
    sourceId?: string;
    /** For care_protocol source: the diagnosis code this problem was added for */
    sourceProtocolDiagnosisCode?: string;
    orderId?: string;
    endOrderId?: string;
    order?: FormOrderSummaryDto;
}

export interface AdmissionInfectionDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    name: string;
    mdNotified: string;
    acquired: string;
    type: string;
    details: string[];
    cultureSource?: string;
    treatment?: string;
    /** @format date-time */
    cultureDate?: string;
    risks?: string;
    narrative?: string;
    notes?: string;
    /** @format date-time */
    logDate: string;
    /** @format date-time */
    infectionDate: string;
    /** @format date-time */
    resolvedDate?: string;
    medications: AdmissionMedicationDto[];
    branch?: string;
    patient?: string;
}

export interface AdmissionIncidentDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    notifiedPhysicianId?: string;
    notifiedUserId?: string;
    notifiedPhysician?: string;
    notifiedUser?: string;
    name: string;
    subject: string;
    nature: string;
    dateOfIncident: string;
    dateResolved?: string | null;
    place?: string;
    severity?: string;
    describe?: string;
    datePhysicianNotified?: string;
    dateSupervisorNotified?: string;
    outcome?: string;
    outcomeDetails?: string;
    narrative?: string;
    recommendations?: string;
    branch?: string;
    patient?: string;
}

export interface CarryForwardSourceDto {
    /** @example "SNN Visit" */
    formName: string;
    /** @example "2026-06-01" */
    visitDate: string;
    visitType?: string | null;
    formStatus: 'DRAFT' | 'IN PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'APPROVED';
    assignedUser?: string | null;
    signedUserName?: string | null;
    /** @example "v1" */
    version: string;
    /** @example 1 */
    visitsAgo?: number;
}

export interface VisitFormDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    /** @example "Oasis Start of Care E1" */
    name: string;
    /** @example "oasis" */
    title: string;
    formCategory?: 'order' | 'eval' | 'routine-visit' | 'other';
    formDiscipline: 'SN' | 'PT' | 'OT' | 'ST' | 'HHA' | 'MSW';
    /** @example "e1" */
    version: string;
    /** @example "soc" */
    timepoint: string;
    data: object;
    status: 'DRAFT' | 'IN PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'APPROVED';
    visitType: string;
    visitTypeDiscipline?: string;
    visitDate: string;
    assignedUser: string;
    assignedUserId?: string | null;
    assignedUserDisciplines: string[];
    signedUserId: string | null;
    signedUserDate: string | null;
    patient: PatientDto;
    supplies: VisitFormSupplyDto[];
    wounds: VisitFormWoundDto[];
    vaccinations: AdmissionVaccinationDto[];
    medications: AdmissionMedicationDto[];
    episodeStartDate: string;
    episodeEndDate: string;
    planOfCare: AdmissionPlanOfCareDto[];
    infections: AdmissionInfectionDto[];
    incidents: AdmissionIncidentDto[];
    branch: BranchDto;
    caregivers: PatientCaregiverDto[];
    physicians: PatientAdmissionPhysicianDto[];
    diagnoses: DiagnosisDto[];
    hipps?: string;
    pdgmVersion: string;
    serviceCodeRejectionReason?: string;
    pairedPOC: VisitFormDto | null;
    pairedOasis: VisitFormDto | null;
    pairedConsent: VisitFormDto | null;
    primaryInsurance: AdmissionInsuranceDto;
    language: string;
    correctionNumber?: number;
    cmsStatus?: string;
    homeAddress?: string | null;
    attendingPhysician?: string | null;
    order?: FormOrderSummaryDto;
    medicationApprovals?: AdmissionMedicationApprovedDto[];
    defaults?: object;
    /** Carry-forward review source for a DRAFT form: the most recent prior same-title/version form's data, with this draft's own already-confirmed/edited section data overlaid on top. */
    carryForwardData?: object;
    /** Metadata about the prior visit/form carryForwardData was copied from (visit date, assigned/signed users, etc). */
    carryForwardSource?: CarryForwardSourceDto;
    /** Form-level auxiliary state (workflow/UI), separate from clinical section data */
    meta?: object;
}

export interface VisitPatientDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "" */
    name: string;
    /** @example "" */
    phone: string;
    /** @example "" */
    address: AddressDto;
}

export interface VisitDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    episodeId: string;
    branch: BranchDto;
    /** @example 1 */
    episodeNumber: number;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    admissionId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "2022-01-01 11:00" */
    start: string;
    /** @example "2022-01-01 12:00" */
    end: string;
    visitType: VisitTypeDto;
    forms: VisitFormDto[];
    assignedUser?: StaffDto | null;
    patient: VisitPatientDto;
    address: PatientAddressDto;
    status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    mileage?: number;
    surcharge?: number;
    duration?: number;
}

export interface CreateVisitDto {
    /** @example "11:00" */
    start: string;
    /** @example "12:00" */
    end: string;
    visitTypeId: string;
    formIds: string[];
    assignedUserId?: string;
    addressId?: string;
}

export interface UpdateVisitDto {
    /** @example "2022-01-01" */
    date?: string;
    /** @example "11:00" */
    start?: string;
    /** @example "12:00" */
    end?: string;
    visitTypeId?: string;
    formIds?: string[];
    assignedUserId?: string;
}

export interface VisitSummaryAssignedUserDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "Jane Doe" */
    name: string;
    /** @example ["RN"] */
    disciplines: string[];
}

export interface VisitSummaryDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    episodeId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    admissionId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    patientId: string;
    /** @example "2022-01-01 11:00" */
    start: string;
    /** @example "2022-01-01 12:00" */
    end: string;
    status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    /** @example "John Smith" */
    name: string;
    /** @example "Start of Care" */
    visitType: string;
    /**
     * The visit type's service category (Nursing Care/PT/OT/ST/Medical Social/Home Health Aide Services) — not a per-clinician credential code.
     * @example "SN"
     */
    discipline: string;
    assignedUser: VisitSummaryAssignedUserDto | null;
}

export interface UpcomingVisitAssignedUserDto {
    id: string;
    name: string;
    disciplines: string[];
}

export interface UpcomingVisitDto {
    id: string;
    episodeId: string;
    start: string;
    end: string;
    status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    visitTypeTitle: string;
    visitTypeEmployeeClass: string;
    visitTypeId: string;
    assignedUser: UpcomingVisitAssignedUserDto | null;
}

export interface AuthorizationDetailsDto {
    id: string;
    code: string;
    visitTypeId: string | null;
    visitType: string | null;
    discipline: string | null;
    effectiveFrom: string;
    effectiveTo: string;
    createdAt: string;
    visitCount: number;
    used: number;
    explicit: number;
    dynamic: number;
    remaining: number;
    status: 'ACTIVE' | 'REVOKED';
    allocatedVisitIds: string[];
    explicitVisitIds: string[];
    dynamicVisitIds: string[];
}

export interface CreateAuthorizationDto {
    /**
     * Authorization code
     * @maxLength 64
     */
    code: string;
    /** Visit type ID */
    visitTypeId?: string;
    /**
     * Discipline code
     * @maxLength 32
     */
    discipline?: string;
    /**
     * Maximum number of visits authorized
     * @min 1
     */
    maxVisits: number;
    /** Effective from date */
    effectiveFrom: string;
    /** Effective to date */
    effectiveTo: string;
    /** Notes */
    notes?: string;
}

export interface AffectedVisitDto {
    visitId: string;
    visitDate: string;
    currentStatus: 'AUTHORIZED' | 'UNAUTHORIZED';
    currentMode?: 'DYNAMIC' | 'EXPLICIT';
    currentAuthorizationCode?: string;
    newStatus: 'AUTHORIZED' | 'UNAUTHORIZED';
    newMode?: 'DYNAMIC' | 'EXPLICIT';
    newAuthorizationCode?: string;
}

export interface LinkImpactDto {
    visitId: string;
    visitDate: string;
    visitTypeId: string;
    currentStatus: 'AUTHORIZED' | 'UNAUTHORIZED';
    currentMode?: 'DYNAMIC' | 'EXPLICIT';
    currentAuthorizationId?: string;
    newStatus: 'AUTHORIZED' | 'UNAUTHORIZED';
    newMode?: 'DYNAMIC' | 'EXPLICIT';
    newAuthorizationId?: string;
    valid: boolean;
    reason?: string;
    affectedVisits: AffectedVisitDto[];
}

export type LinkVisitDto = object;

export interface CreateAuthorizationDismissalDto {
    dismissalType: 'DEFERRED' | 'DISMISSED' | 'REQUESTED';
    /**
     * Number of days to defer
     * @min 1
     * @max 90
     */
    deferDays?: number;
    /** Optional reason for dismissal/deferral */
    reason?: string;
}

export interface AuthorizationDismissalDto {
    id: string;
    authorizationId: string;
    dismissalType: 'DEFERRED' | 'DISMISSED' | 'REQUESTED';
    deferredUntil?: object;
    reason?: object;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
}

export interface DraftVisitDto {
    /** Draft identifier (returned as visitId in result for mapping) */
    id: string;
    /** Visit type ID */
    visitTypeId: string;
    /**
     * Visit date in ISO format (YYYY-MM-DD)
     * @example "2025-03-15"
     */
    start: string;
    status: string;
}

export interface EvaluateComplianceDto {
    /** Draft visits */
    drafts?: DraftVisitDto[];
}

export interface MatchingAuthorizationDto {
    id: string;
    code: string;
    visitTypeId?: string;
    discipline?: string;
    effectiveFrom: string;
    effectiveTo: string;
    maxVisits: number;
    scheduledReserved: number;
    completedConsumed: number;
    remaining: number;
}

export interface ComplianceResultDto {
    visitId: string;
    visitStatus: 'DRAFT' | 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    visitDate: string;
    status: 'AUTHORIZED' | 'UNAUTHORIZED';
    mode?: 'DYNAMIC' | 'EXPLICIT';
    authorization?: MatchingAuthorizationDto;
}

export interface AuthorizationSummaryDto {
    visitTypeId: string | null;
    visitType: string | null;
    discipline: string | null;
    visitCount: number;
    used: number;
    remaining: number;
    authCount: number;
}

export interface AuthorizationComplianceDto {
    details: AuthorizationDetailsDto[];
    summary: AuthorizationSummaryDto[];
}

export interface PatientContactDto {
    patientId: string;
    email: string;
    pointOfContact: string;
    phones: PatientPhoneDto[];
    addresses: PatientAddressDto[];
}

export interface OverviewDemographicsDto {
    language: string;
    languageId: string;
    requiresTranslator: boolean;
    race: string[];
    ethnicity: string[];
    religion: string;
    religionId: string;
    maritalStatus: string;
    maritalStatusId: string;
}

export interface OverviewProfileDto {
    dob: string;
    ssn: string;
    contactDetails: PatientContactDto;
    demographics: OverviewDemographicsDto;
    firstName: string;
    lastName: string;
    middleName: string;
    skipSsn: boolean;
    suffix: string;
    /** @example "male" */
    gender: 'male' | 'female';
}

export interface OverviewEpisodeDto {
    id: string;
    status: 'PENDING' | 'STARTED' | 'COMPLETED';
    episodeNumber: number;
    startDate: string;
    endDate: string;
}

export interface OverviewAdmissionDto {
    id: string;
    branchId: string;
    admissionNumber: number;
    status:
        | 'PENDING_ELIGIBILITY'
        | 'ELIGIBLE'
        | 'PENDING'
        | 'SCHEDULED'
        | 'NON_ADMIT'
        | 'ADMITTED'
        | 'TRANSFERRED'
        | 'DISCHARGED'
        | 'DECEASED';
    episode: OverviewEpisodeDto;
    episodes: OverviewEpisodeDto[];
    episodeRangeStartDate: string;
    episodeRangeEndDate: string;
    intakeDate: string;
    intakeBranch: string;
    medications: AdmissionMedicationDto[];
    medicationApprovals?: AdmissionMedicationApprovedDto[];
    formToApproveMedication?: string;
}

export interface OverviewClinicalDto {
    dnr?: boolean;
    diagnoses: DiagnosisDto[];
    allergies: PatientAllergyDto[];
    risks: PatientRiskDto[];
}

export interface OverviewCareDto {
    careTeam: StaffDto[];
    pharmacies: PatientAdmissionPharmacyDto[];
    physicians: PatientAdmissionPhysicianDto[];
    caregivers: PatientCaregiverDto[];
    communityServices: string[];
    communityServicesOther: string;
    powerOfAttorney?: boolean | null;
    powerOfAttorneyName?: string | null;
    powerOfAttorneyCopyObtained?: boolean | null;
}

export interface OverviewMedicationDto {
    id: string;
    name: string;
    dose: string;
    doseUnit: string;
    frequencyA: string;
    frequencyB: string;
    direction: string;
    prn?: boolean;
    inactivatedAt?: object;
    /** @format date-time */
    stopDate?: string | null;
}

export interface AdmissionWoundDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    location: string;
    type: string;
    progress?: ProgressDto[];
}

export interface OverviewPatientDto {
    id: string;
    profile: OverviewProfileDto;
    admission: OverviewAdmissionDto;
    clinical: OverviewClinicalDto;
    care: OverviewCareDto;
    referral: ReferralDto;
    visits: VisitDto[];
    medications: OverviewMedicationDto[];
    insurance: AdmissionInsuranceDto[];
    planOfCare: AdmissionPlanOfCareDto[];
    medicationApprovals: boolean;
    wounds: AdmissionWoundDto[];
    highFallRisk: boolean;
    fireHazard?: boolean;
}

export interface SaveVisitFormDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    data: object;
    /** @example "staff" */
    signedUserId?: string | null;
    /** @example "10-02-2024" */
    signedUserDate?: string | null;
    /** Form-level auxiliary state (workflow/UI), separate from clinical section data */
    meta?: object;
}

export interface SaveVisitFormResponseDto {
    form: VisitFormDto;
    error?: object;
}

export interface SaveFormNotesDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    note: string;
    /** @example "COMMENT" */
    status: string;
}

export interface UpdateFormStatusDto {
    status: 'DRAFT' | 'IN PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'APPROVED';
    note?: SaveFormNotesDto;
}

export interface SaveCarryForwardSectionDto {
    /** @example "Nutrition" */
    section: string;
    data: object;
    /** @example true */
    stillAccurate?: boolean;
}

export interface FormNotesDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    status: string;
    /** @example "This is a qa note" */
    note: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    createdBy: string;
    /** @example "Mike Menuson" */
    name: string;
    /** @format date-time */
    createdAt: string;
}

export interface CreateFormAmendDto {
    data: object;
    reason: string;
}

export interface FormAmendDto {
    id: string;
    formId: string;
    data: object;
    createdBy: string;
    /** @format date-time */
    createdAt: string;
    updatedBy: string;
    /** @format date-time */
    updatedAt?: string;
}

export interface BillingDto {
    fileName: string;
    edi: string;
}

export interface ClaimNotReadyReasonDto {
    code:
        | 'MISSING_CLAIM_FIELDS'
        | 'MISSING_PRIVATE_INSURANCE_CONFIG'
        | 'EXPIRED_INSURANCE_CONTRACT'
        | 'NO_CLAIM_VISITS'
        | 'MISSING_VISIT_CODES'
        | 'VISITS_NOT_APPROVED'
        | 'INCOMPLETE_AGENCY_ZIP'
        | 'KX_MISSING_REMARKS';
    /** For MISSING_CLAIM_FIELDS: which required fields are still blank. */
    fields?: ('admissionStatus' | 'admissionType' | 'attendingPhysician' | 'careLocation' | 'occurrenceCodes' | 'valueCodes')[];
    /** For MISSING_VISIT_CODES: titles of the visit types missing a revenue/service code. */
    visitTypes?: string[];
    /** For MISSING_PRIVATE_INSURANCE_CONFIG: linked payer display name. */
    payerName?: string;
    /** For MISSING_PRIVATE_INSURANCE_CONFIG and EXPIRED_INSURANCE_CONTRACT: payer id for settings configure link. */
    insuranceId?: string;
    /** For EXPIRED_INSURANCE_CONTRACT: contract end date (YYYY-MM-DD). */
    contractEndDate?: string;
    /** For EXPIRED_INSURANCE_CONTRACT: insurance config id for settings edit link. */
    insuranceConfigId?: string;
}

export interface ClaimDto {
    id: string;
    claimId: string;
    controlId?: string;
    branchId: string;
    branchName: string;
    admissionId: string;
    episodeId: string;
    episodeNumber: number;
    type: '0329' | '032A';
    status: 'NOT_READY' | 'READY' | 'CANCELLED' | 'SENT';
    /** Patient name in "Last, First" format */
    patientName: string;
    dob: string;
    memberId: string;
    insurance: 'medicare' | 'medicaid' | 'private' | 'self-pay' | 'no-pay';
    /** Primary insurance display name (payer name when available, otherwise type label) */
    payer: string;
    startDate: string;
    endDate: string;
    sentDate: string;
    /** Outstanding reasons this claim cannot be submitted. Empty when the claim is ready/cancelled/sent. */
    notReadyReasons: ClaimNotReadyReasonDto[];
}

export interface ClaimSentDto {
    id: string;
    /** Patient name in "Last, First" format */
    patient: string;
    memberId: string;
    dob: string;
    branch: string;
    admissionId: string;
    branchId: string;
    type: string;
    claimId?: string;
    sentDate?: string;
    serviceDate?: string;
    dateCancelled?: string;
    totalBilled?: string;
    payer?: string;
    status: 'NOT_READY' | 'READY' | 'CANCELLED' | 'SENT';
}

export interface ClaimDemographicsDto {
    name: string;
    firstName: string;
    lastName: string;
    dob: string;
    ssn?: string | null;
    gender: 'male' | 'female';
    address: AddressDto;
}

export interface ClaimServicesDto {
    id: string;
    date: string;
    visitType: string;
    employee: string;
    units: string;
    hours: string;
    perUnit: number;
    rateBasis: 'per_unit' | 'per_visit';
    charges: number;
    revenueCode?: string;
    serviceCode?: string;
}

export interface ClaimOccurrenceDto {
    id: string;
    startDate: string;
    endDate: string;
    code: string;
}

export interface ClaimConditionDto {
    id: string;
    code: string;
}

export interface ClaimValueCodeDto {
    id: string;
    code: string;
    value: string;
}

export interface ClaimMissingVisitCodeDto {
    visitTypeId: string;
    visitTypeTitle: string;
    missingRevenueCode: boolean;
    missingServiceCode: boolean;
}

export interface ClaimUnpaidVisitDto {
    visitId: string;
    /** Service date (YYYY-MM-DD). */
    visitDate: string;
    visitTypeTitle: string;
}

export interface ClaimWarningDto {
    code: 'EXPIRED_INSURANCE_CONTRACT_VISITS';
    payerName?: string;
    /** Contract end date (YYYY-MM-DD). */
    contractEndDate?: string;
    /** Insurance config id for settings edit link. */
    insuranceConfigId?: string;
    /** Payer id for settings configure link. */
    insuranceId?: string;
    unpaidVisits?: ClaimUnpaidVisitDto[];
}

export interface ClaimDetailsDto {
    id: string;
    claimId: string;
    branchId: string;
    admissionId: string;
    episodeId: string;
    episodeNumber: number;
    type: '0329' | '032A';
    status: 'NOT_READY' | 'READY' | 'CANCELLED' | 'SENT';
    patientName: string;
    startDate: string;
    endDate: string;
    sentDate: string;
    controlId: string;
    demographics: ClaimDemographicsDto;
    services: ClaimServicesDto[];
    excludedServices: ClaimServicesDto[];
    diagnosis: DiagnosisDto[];
    insurance: AdmissionInsuranceDto;
    occurrences: ClaimOccurrenceDto[];
    conditions: ClaimConditionDto[];
    valueCodes: ClaimValueCodeDto[];
    attendingPhysician?: PhysicianDto;
    admissionType?: string;
    admissionSource?: string;
    admissionStatus?: string;
    careLocation?: string;
    kxModifier: boolean;
    remarksText?: string | null;
    admissionDate: string;
    /** Visit types on this claim missing an effective revenue and/or service code. Claims with any entries here cannot be submitted. */
    missingVisitTypeCodes: ClaimMissingVisitCodeDto[];
    /** Outstanding reasons this claim cannot be submitted. Empty when the claim is ready/cancelled/sent. */
    notReadyReasons: ClaimNotReadyReasonDto[];
    /** Non-blocking notices for this claim (e.g. services that will not be paid). Empty when none apply. */
    claimWarnings: ClaimWarningDto[];
}

export interface ClaimSentDetailsDto {
    id: string;
    memberId: string;
    branch: string;
    dateSent: string;
    /** Patient name in "Last, First" format */
    name: string;
    dob: string;
    from: string;
    to: string;
    billed: string;
    type: string;
    payer?: string;
}

export interface CreateOccurrenceCode {
    /** @example "60" */
    code: string;
    /** @example "2025-02-02" */
    startDate: string;
    /** @example "2025-02-02" */
    endDate?: string;
}

export interface CreateConditionCode {
    /** @example "60" */
    code: string;
}

export interface CreateValueCodeDto {
    /** @example "60" */
    code: string;
    /** @example 60 */
    value: string;
}

export interface UpdateAdmissionDetailsDto {
    attendingPhysicianId?: string;
    admissionType?: string;
    admissionSource?: string;
    admissionStatus?: string;
    careLocation?: string;
}

export interface UpdateClaimRemarksDto {
    kxModifier?: boolean;
    remarksText?: string | null;
}

export interface SubmitClaimDto {
    /** @example ["60"] */
    claimIds: string[];
}

export interface CreateSingleClaimDto {
    id: string;
}

export interface EditClaimDetailsDto {
    id: string;
    startDate?: string;
    endDate?: string;
    type?: '032A' | '0329';
}

export interface HippsAuditPdgmDetailsDto {
    /** @example "early" */
    timing?: 'early' | 'late';
    /** @example "community" */
    admissionSource?: 'community' | 'institutional';
    /** @example "MMTA - Cardiac" */
    clinicalGroup?: object;
    /** @example "medium" */
    functionalLevel?: 'low' | 'medium' | 'high';
    /** @example "none" */
    comorbidityLevel?: 'none' | 'low' | 'high';
    /** @example "MMTA - Cardiac - Medium" */
    clinicalGroupAndFunctionalLevel?: object;
    /** @example "Early - Community" */
    admissionSourceAndTiming?: object;
    /** @example "0" */
    comorbidityAdjustment?: object;
}

export interface HippsAuditCalculationDto {
    /** @example "2025.47" */
    caseMixAdjusted: string;
    /** @example "1517.08" */
    laborPortion: string;
    /** @example "508.39" */
    nonLaborPortion: string;
    /** @example "1440.76" */
    laborWageAdjusted: string;
    /** @example "1949.15" */
    estimatedPayment: string;
}

export interface HippsAuditMetaDto {
    /** @example "CY2026 Final" */
    pdgmRefVersion: string;
    /** @example "CY2026 Final" */
    wageIndexVersion: string;
    /** @example "CY2026 Final Rule Table 14" */
    rateSource: string;
}

export interface HippsAuditDetailsDto {
    /** @example 2026 */
    year: number;
    /** @example "uuid-visit-id" */
    visitId: string;
    /** @example "uuid-admission-id" */
    admissionId: string;
    /** @example "uuid-branch-id" */
    branchId: string;
    /** @example "Main Branch" */
    branchName: string;
    /** @example "1HB21" */
    hipps: string;
    /** @example "90210" */
    zip: string;
    /** @example "31080" */
    cbsa: string;
    /** @example "zip_cbsa_crosswalk" */
    cbsaSource: string;
    /** @example "Los Angeles-Long Beach-Anaheim, CA" */
    cbsaAreaName?: object;
    /** @example "1.2445" */
    wageIndex: string;
    /** @example false */
    isRural?: object;
    /** @example "2038.22" */
    national30DayRate: string;
    /** @example "0.7490" */
    laborShare: string;
    /** @example "0.2510" */
    nonLaborShare: string;
    /** @example "0.9966" */
    caseMixWeight: string;
    /** @example 4 */
    lupaThreshold: number;
    pdgmDetails: HippsAuditPdgmDetailsDto;
    calculation: HippsAuditCalculationDto;
    audit: HippsAuditMetaDto;
}

export interface FileUploadRequestDto {
    contentType: string;
    originalName: string;
    title?: string;
    notes?: string;
    orderId?: string;
}

export interface FileUploadResponseDto {
    id: string;
    uploadUrl: string;
    contentType: string;
}

export interface FileUploadConfirmRequestDto {
    fileIds: string[];
}

export interface FileMetadataDto {
    title?: object;
    notes?: object;
}

export interface CreateDocumentRequestDto {
    name: string;
    custom: boolean;
}

export interface FulfillDocumentRequestDto {
    fileId: string;
}

export interface AdmissionDocumentNoteDto {
    id: string;
    documentRequestId: string;
    note: string;
    createdBy: string;
    createdByName: string;
    /** @format date-time */
    createdAt: string;
}

export interface CreateDocumentNoteDto {
    note: string;
}

export interface AdmissionNoteDto {
    /** Admission note id */
    id: string;
    admissionId: string;
    note: string;
    category?: string | null;
    createdBy: string;
    createdByName: string;
    /** @format date-time */
    createdAt: string;
}

export interface CreateAdmissionNoteDto {
    note: string;
    category?: 'clinical' | 'administrative' | 'communication' | 'insurance';
}

export interface QaDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    patientId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    admissionId: string;
    /** @example "Oasis Start of Care E1" */
    formName: string;
    /** @example "oasis" */
    title: string;
    status: string;
    visitDate: string;
    signedUserId: string | null;
    signedUserDate: string | null;
    signedUserName: string | null;
    /** @example "Mike" */
    patientFirstName: string;
    /** @example "Menuson" */
    patientLastName: string;
    /** @example "Mike Menuson" */
    patientFullName: string;
    /** @example "Main Branch" */
    branchName: string;
    primaryInsuranceName: string | null;
    primaryPhysician: string | null;
}

export interface QaListPaginationMeta {
    /**
     * Current page number (1-indexed)
     * @example 1
     */
    currentPage: number;
    /**
     * Number of records per page
     * @example 50
     */
    pageSize: number;
    /**
     * Total number of records matching query
     * @example 1234
     */
    totalRecords: number;
    /**
     * Total number of pages
     * @example 25
     */
    totalPages: number;
}

export interface QaListResponseDto {
    /** Array of QA list items */
    data: QaDto[];
    /** Pagination metadata */
    meta: QaListPaginationMeta;
}

export interface LogErrorDto {
    message: string;
    stack?: string;
    url?: string;
    timestamp?: string;
}

export interface FeatureFlagEvaluationDto {
    /** Feature flag key */
    key:
        | 'example-feature-flag'
        | 'report-feature-flag'
        | 'dashboard'
        | 'insurance-authorizations'
        | 'grouper-0120206'
        | 'scheduling-dashboard'
        | 'clinical-dashboard'
        | 'intake-dashboard';
    /** Flag type */
    kind: 'global' | 'organization';
    /** Effective boolean value for the current organization */
    value: boolean;
    /** Source of the effective value */
    source: 'organization' | 'global' | 'off';
    /**
     * When this evaluation was performed
     * @format date-time
     */
    evaluatedAt: string;
}

export interface FeatureFlagEvaluationListDto {
    /** Feature flag evaluations for the current organization */
    flags: FeatureFlagEvaluationDto[];
}

export interface CensusOverviewDto {
    /**
     * Number of active patients with open episodes
     * @example 45
     */
    activePatients: number;
    /**
     * Number of new admits in the specified period
     * @example 12
     */
    newAdmits: number;
    /**
     * Number of pending admissions
     * @example 8
     */
    pending: number;
    /**
     * Number of referrals (placeholder)
     * @example 0
     */
    referrals: number;
}

export interface DailyCensusDataDto {
    /**
     * Date in YYYY-MM-DD format
     * @example "2025-09-29"
     */
    date: string;
    /**
     * Number of patients with open episodes on this date
     * @example 156
     */
    count: number;
}

export interface DailyAverageCensusDto {
    /**
     * Highest daily census count in the period
     * @example 180
     */
    highest: number;
    /**
     * Lowest daily census count in the period
     * @example 145
     */
    lowest: number;
    /**
     * Average daily census count in the period
     * @example 162
     */
    average: number;
    /** Daily census data for each day in the period */
    dailyData: DailyCensusDataDto[];
}

export interface CbsaReportItemDto {
    /**
     * Discipline name for display
     * @example "Skilled Nursing"
     */
    discipline: string;
    /**
     * Number of Medicare visits for this discipline
     * @example 25
     */
    medicareVisits: number;
    /**
     * Number of Medicare patients for this discipline
     * @example 10
     */
    medicarePatients: number;
    /**
     * Number of non-Medicare visits for this discipline
     * @example 15
     */
    otherVisits: number;
    /**
     * Number of non-Medicare patients for this discipline
     * @example 8
     */
    otherPatients: number;
}

export interface CbsaReportDto {
    /** CBSA report data by discipline */
    disciplines: CbsaReportItemDto[];
    /**
     * Report start date in YYYY-MM-DD format
     * @example "2024-01-01"
     */
    startDate: string;
    /**
     * Report end date in YYYY-MM-DD format
     * @example "2024-12-31"
     */
    endDate: string;
    /**
     * Branch ID used for filtering, null means all branches
     * @example "branch-123"
     */
    branchId: object | null;
}

export interface AssessmentsStatusMetaDto {
    /**
     * Current view
     * @example "overdue"
     */
    view: 'overdue' | 'upcoming';
    /**
     * Current page number
     * @example 1
     */
    page: number;
    /**
     * Page size
     * @example 25
     */
    pageSize: number;
    /**
     * Total number of items
     * @example 42
     */
    total: number;
}

export interface AssessmentsStatusPatientDto {
    /**
     * Patient ID
     * @example "uuid-patient-id"
     */
    id: string;
    /**
     * Medical Record Number
     * @example "MRN123456"
     */
    mrn: string;
    /**
     * Patient full name
     * @example "John Doe"
     */
    name: string;
    /**
     * Date of birth in ISO format
     * @example "1980-05-15"
     */
    dob: string;
}

export interface AssessmentsStatusClinicianDto {
    /**
     * Clinician ID
     * @example "uuid-clinician-id"
     */
    id: string;
    /**
     * Clinician full name
     * @example "Dr. Jane Smith"
     */
    name: string;
}

export interface AssessmentsStatusVisitDto {
    /**
     * Visit ID
     * @example "uuid-visit-id"
     */
    id: string;
    /**
     * Visit start date and time in ISO format
     * @example "2025-09-25T09:00:00.000Z"
     */
    start: string;
    /**
     * Visit end date and time in ISO format
     * @example "2025-09-25T10:30:00.000Z"
     */
    end: string;
}

export interface AssessmentsStatusItemDto {
    /**
     * Visit Form ID
     * @example "uuid-visit-form-id"
     */
    visitFormId: string;
    /**
     * Branch ID for navigation
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e71"
     */
    branchId: string;
    /**
     * Admission ID for navigation
     * @example "e9da4f93-9ca9-11f0-8c63-a39db8c30386"
     */
    admissionId: string;
    /**
     * Form template ID for navigation
     * @example "e9ffb1e3-9ca9-11f0-8c63-a39db8c30386"
     */
    formId: string;
    /**
     * Assessment type/form name
     * @example "OASIS Assessment"
     */
    assessmentType: string;
    /**
     * Normalized status for UI display
     * @example "INCOMPLETE"
     */
    status: 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'INCOMPLETE';
    /** Patient information */
    patient: AssessmentsStatusPatientDto;
    /** Assigned clinicians (primary from visit) */
    clinicians: AssessmentsStatusClinicianDto[];
    /** Visit information */
    visit: AssessmentsStatusVisitDto;
    /**
     * Due date in ISO format
     * @example "2025-09-26"
     */
    dueDate: string;
    /**
     * Number of days overdue (only for overdue view)
     * @example 3
     */
    daysOverdue?: number;
    /**
     * Number of days until due (only for upcoming view)
     * @example 2
     */
    daysUntilDue?: number;
}

export interface AssessmentsStatusResponseDto {
    /** Pagination and view metadata */
    meta: AssessmentsStatusMetaDto;
    /** Assessment status items */
    items: AssessmentsStatusItemDto[];
}

export interface ClinicianDto {
    /**
     * Unique identifier for the clinician
     * @example "550e8400-e29b-41d4-a716-446655440000"
     */
    id: string;
    /**
     * Full name of the clinician
     * @example "Dr. Jane Smith"
     */
    name: string;
    /**
     * Professional title or role
     * @example "Registered Nurse"
     */
    title?: string;
}

export interface CliniciansResponseDto {
    /** List of clinicians available for the selected branches */
    clinicians: ClinicianDto[];
}

export interface AssessmentFormDto {
    /**
     * Form ID
     * @example "uuid-string-here"
     */
    id: string;
    /**
     * Form name
     * @example "OASIS Assessment"
     */
    name: string;
}

export interface AssessmentFormsResponseDto {
    /** List of forms */
    forms: AssessmentFormDto[];
}

export interface EpisodeManagementMetaDto {
    /**
     * Current page number
     * @example 1
     */
    page: number;
    /**
     * Number of items per page
     * @example 25
     */
    pageSize: number;
    /**
     * Total number of items
     * @example 150
     */
    total: number;
    /**
     * Number of days filter applied
     * @example 30
     */
    days: number;
    /**
     * Branch ID filter applied
     * @example "branch-uuid"
     */
    branchId?: string;
    /** Event type filter applied */
    eventType?: 'RECERTIFICATION' | 'DISCHARGE' | 'EPISODE_ENDING';
    /**
     * Total count of recertification events
     * @example 12
     */
    recertificationCount: number;
    /**
     * Total count of discharge events
     * @example 8
     */
    dischargeCount: number;
    /**
     * Total count of episode ending events
     * @example 5
     */
    endingCount: number;
}

export interface EpisodeManagementPatientDto {
    /**
     * Patient ID
     * @example "patient-uuid"
     */
    id: string;
    /**
     * Patient MRN
     * @example "MRN123456"
     */
    mrn: string;
    /**
     * Patient full name
     * @example "John Smith"
     */
    name: string;
    /**
     * Patient date of birth
     * @example "1985-06-15"
     */
    dob: string;
}

export interface EpisodeManagementItemDto {
    /**
     * Unique identifier for the item (admission or episode ID)
     * @example "admission-uuid"
     */
    id: string;
    /**
     * Branch ID
     * @example "branch-uuid"
     */
    branchId: string;
    /**
     * Type of episode management event
     * @example "RECERTIFICATION"
     */
    eventType: 'RECERTIFICATION' | 'DISCHARGE' | 'EPISODE_ENDING';
    /** Patient information */
    patient: EpisodeManagementPatientDto;
    /**
     * Date of the event (visit start date for recertification, episode end date for episode ending)
     * @example "2025-10-15"
     */
    eventDate: string;
    /**
     * Number of days until the event date
     * @example 14
     */
    daysUntilEvent: number;
    /**
     * Visit ID for recertification events
     * @example "visit-uuid"
     */
    visitId?: string;
    /**
     * Episode ID for episode ending events
     * @example "episode-uuid"
     */
    episodeId?: string;
}

export interface EpisodeManagementResponseDto {
    /** Pagination and filter metadata */
    meta: EpisodeManagementMetaDto;
    /** List of episode management items */
    items: EpisodeManagementItemDto[];
}

export interface TransferMetaDto {
    /**
     * Current page number
     * @example 1
     */
    page: number;
    /**
     * Number of items per page
     * @example 25
     */
    pageSize: number;
    /**
     * Total number of transfer items
     * @example 26
     */
    total: number;
    /**
     * Branch ID filter applied
     * @example "branch-uuid"
     */
    branchId?: string;
}

export interface TransferPatientDto {
    /**
     * Patient ID
     * @example "patient-uuid"
     */
    id: string;
    /**
     * Patient MRN
     * @example "MRN123456"
     */
    mrn: string;
    /**
     * Patient full name
     * @example "John Smith"
     */
    name: string;
    /**
     * Patient date of birth
     * @example "1985-06-15"
     */
    dob: string;
}

export interface TransferItemDto {
    /**
     * Admission ID
     * @example "admission-uuid"
     */
    admissionId: string;
    /**
     * Branch ID
     * @example "branch-uuid"
     */
    branchId: string;
    /** Patient information */
    patient: TransferPatientDto;
    /**
     * Date when the transfer occurred (visit start date with transfer form)
     * @example "2025-09-12"
     */
    transferDate: string;
    /**
     * Date when the episode ends
     * @example "2025-10-01"
     */
    episodeEndDate: string;
    /**
     * Number of days until episode end date
     * @example 6
     */
    daysUntilEpisodeEnd: number;
}

export interface TransferResponseDto {
    /** Pagination and filter metadata */
    meta: TransferMetaDto;
    /** List of transfer items */
    items: TransferItemDto[];
}

export interface AuthorizationExpirationItemDto {
    admissionId: string;
    admissionNumber: number;
    patientName: string;
    branchId: string;
    branchName: string;
    payerId: string;
    payerName: string;
    memberId?: string | null;
    groupId?: string | null;
    relationship?: string | null;
    authorizationId: string;
    authorizationCode: string;
    authorizationNotes?: string;
    effectiveFrom: string;
    effectiveTo: string;
    daysUntilExpiry: number;
    warningDays: number;
    category: 'OVERDUE' | 'UPCOMING';
    visitTypeId?: string | null;
    visitTypeName?: string | null;
    discipline?: string | null;
    maxVisits: number;
    visitsUsed: number;
    /** Whether this authorization is exhausted (all visits used) */
    isExhausted: boolean;
    /** Date of last allocated visit if authorization is exhausted */
    lastVisitDate?: string | null;
    /** Why this authorization is expiring */
    expiryReason: 'DATE_BASED' | 'FULFILLED';
    dismissalId?: string | null;
    dismissalType?: 'DEFERRED' | 'DISMISSED' | 'REQUESTED';
    deferredUntil?: string | null;
    dismissalReason?: string | null;
}

export interface AuthorizationExpirationMetaCountsDto {
    overdue: number;
    upcoming: number;
    dismissed: number;
    requested: number;
    all: number;
}

export interface AuthorizationExpirationMetaDto {
    page: number;
    pageSize: number;
    total: number;
    branchId?: string;
    filter?: 'ALL' | 'OVERDUE' | 'UPCOMING' | 'DISMISSED' | 'REQUESTED';
    counts: AuthorizationExpirationMetaCountsDto;
}

export interface AuthorizationExpirationResponseDto {
    items: AuthorizationExpirationItemDto[];
    meta: AuthorizationExpirationMetaDto;
}

export interface QaDashboardStatsDto {
    /**
     * Number of forms awaiting review
     * @example 10
     */
    awaitingReview: number;
    /**
     * Number of approved forms
     * @example 25
     */
    approved: number;
    /**
     * Number of rejected forms
     * @example 5
     */
    rejected: number;
}

export interface QaDashboardFormDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    admissionId: string;
    /** @example "John Doe" */
    patient?: string;
    /** @example "12/05/2024" */
    visitDate?: string;
    /** @example "Oasis Start of Care E1" */
    formName: string;
    /** @example "Jane Smith" */
    submittedBy: string;
    /** @example "12/05/2024" */
    submittedDate: string;
}

export interface QaDashboardDto {
    /** Dashboard statistics */
    stats: QaDashboardStatsDto;
    /** Forms ready for review */
    readyToReview: QaDashboardFormDto[];
}

export interface ClinicalVisitSummaryDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    branchId: string;
    /** @example "John Smith" */
    patientName: string;
    /** @example "Start of Care" */
    visitType: string;
}

export interface TodayVisitItemDto {
    summary: ClinicalVisitSummaryDto;
    /** ISO 8601 visit start time */
    start: string;
    /** ISO 8601 visit end time */
    end: string;
    /** Visit status */
    status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    /** Visit type discipline code (e.g. "SN") */
    discipline: string;
    /** Assigned clinician full name */
    clinicianName?: string | null;
    /** Assigned clinician user ID */
    clinicianId?: string | null;
    /** Patient ID */
    patientId: string;
    /** Patient MRN */
    mrn: string;
    /** Formatted visit address (street, city, state zip) */
    address?: string | null;
    /** Admission ID for routing to patient profile */
    admissionId: string;
}

export interface VisitsPageMetaDto {
    /** Current page (1-based) */
    page: number;
    /** Items per page */
    pageSize: number;
    /** Total number of visits (all pages) */
    total: number;
}

export interface TodayVisitsResponseDto {
    items: TodayVisitItemDto[];
    meta: VisitsPageMetaDto;
}

export interface OutstandingVisitItemDto {
    summary: ClinicalVisitSummaryDto;
    /** ISO 8601 UTC timestamp of the visit start; client uses this with its local timezone to compute days outstanding */
    visitStartUtc: string;
    /** Badge status for the visit */
    status: 'IN_PROGRESS' | 'REJECTED';
    /** Number of forms in a complete state (COMPLETED/SUBMITTED/REVIEW/APPROVED) */
    completeForms?: number | null;
    /** Total number of non-deleted forms for the visit */
    totalForms?: number | null;
    /** Number of rejected forms */
    rejectedForms?: number | null;
}

export interface OutstandingVisitsResponseDto {
    items: OutstandingVisitItemDto[];
    meta: VisitsPageMetaDto;
}

export interface RecentlySubmittedVisitItemDto {
    summary: ClinicalVisitSummaryDto;
    /**
     * ISO 8601 UTC timestamp of MAX(submittedDate) across all forms; client uses this to compute daysSinceSubmitted
     * @example "2026-03-23T15:30:00.000Z"
     */
    lastSubmittedUtc: string;
    /** Badge status: APPROVED when all forms are APPROVED, otherwise SUBMITTED_UNDER_REVIEW */
    status: 'SUBMITTED_UNDER_REVIEW' | 'APPROVED';
}

export interface RecentlySubmittedVisitsResponseDto {
    items: RecentlySubmittedVisitItemDto[];
    meta: VisitsPageMetaDto;
}

export interface VisitDetailTaskItemDto {
    /** VisitForm primary key (visit_form.id) */
    visitFormId: string;
    /** Display name of the assessment/form */
    title: string;
    /** Task status mapped from VisitForm.status */
    status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'APPROVED';
    /** ISO 8601 last updated timestamp */
    updatedAt: string;
}

export interface TasksSummaryDto {
    /** Rollup status across all tasks */
    status: 'INCOMPLETE' | 'SUBMITTED' | 'REJECTED';
}

export interface VisitDetailDto {
    /** ISO 8601 visit start time */
    start: string;
    /** ISO 8601 visit end time */
    end: string;
    /** Visit status */
    status: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'MISSED';
    /** Visit type title (e.g. "RN Start of Care") */
    visitType: string;
    /** Visit type discipline code (e.g. "SN") */
    discipline: string;
    /** Patient full name (first last) */
    patientName: string;
    /** Assigned clinician full name */
    clinicianName: string | null;
    /** Assigned clinician user ID */
    clinicianId: string | null;
    /** Branch name */
    branchName: string;
    address: PatientAddressDto;
    patient: PatientDto;
    /** Task items derived from visit forms */
    tasks: VisitDetailTaskItemDto[];
    /** Rollup summary status for the tasks widget header */
    tasksSummary: TasksSummaryDto;
    /** Admission status */
    admissionStatus: string;
}

export interface IntakeMatchRequestDto {
    /**
     * Social Security Number (if available)
     * @example "123-45-6789"
     */
    ssn?: string;
    /**
     * Patient first name (optional - used to boost match confidence)
     * @example "John"
     */
    firstName?: string;
    /**
     * Patient last name (required if SSN not provided)
     * @example "Smith"
     */
    lastName?: string;
    /**
     * Patient date of birth in YYYY-MM-DD format (required if SSN not provided)
     * @example "1980-01-15"
     */
    dateOfBirth?: string;
    /**
     * Patient gender (required if SSN not provided - must match exactly)
     * @example "male"
     */
    gender?: 'male' | 'female';
}

export interface IntakeMatchCandidateDto {
    /**
     * Patient ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    patientId: string;
    /**
     * Patient first name
     * @example "John"
     */
    firstName: string;
    /**
     * Patient last name
     * @example "Smith"
     */
    lastName: string;
    /**
     * Patient date of birth
     * @example "1980-01-15"
     */
    dob: string;
    /**
     * Patient gender
     * @example "male"
     */
    gender: 'male' | 'female';
    /**
     * Social Security Number (may be masked for security)
     * @example "123-45-6789"
     */
    ssn?: string;
    /**
     * Date of last admission (if any)
     * @example "2024-12-15"
     */
    lastAdmissionDate?: string;
    /**
     * Current admission ID if patient has an active admission
     * @example "abc-123-def-456"
     */
    currentAdmissionId?: string;
    /**
     * Current admission status: INTAKE (in intake flow), PENDING (before SOC visit), ADMITTED (admitted)
     * @example "ADMITTED"
     */
    currentAdmissionStatus?: 'INTAKE' | 'PENDING' | 'ADMITTED';
    /**
     * Branch ID where the patient has their current active admission
     * @example "branch-123-abc"
     */
    currentAdmissionBranchId?: string;
    /**
     * Branch name where the patient has their current active admission
     * @example "Main Branch"
     */
    currentAdmissionBranchName?: string;
    /**
     * Medical Record Number
     * @example "MRN-2024-001234"
     */
    mrn?: string;
    /**
     * Match confidence score (0-100): 100=exact SSN match, 90-95=strong name/DOB/gender match, 85-89=partial name match
     * @example 95
     */
    score: number;
}

export interface EpisodeSummaryDto {
    /**
     * Episode ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    id: string;
    /**
     * Episode number within the admission
     * @example 1
     */
    index: number;
    /**
     * Episode start date
     * @example "2024-01-15"
     */
    startDate: string;
    /**
     * Episode end date
     * @example "2024-02-15"
     */
    endDate?: string;
    /**
     * Number of days in the episode
     * @example 31
     */
    days: number;
    /**
     * Episode status
     * @example "COMPLETED"
     */
    status: 'PENDING' | 'STARTED' | 'COMPLETED';
}

export interface PatientAdmissionSummaryDto {
    /**
     * Admission ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    id: string;
    /**
     * Admission number
     * @example 1
     */
    number: number;
    /**
     * Admission start date
     * @example "2024-01-01"
     */
    startDate: string;
    /**
     * Admission end date (null if active)
     * @example "2024-06-30"
     */
    endDate?: string;
    primaryDiagnosis: DiagnosisDto | null;
    /**
     * Reason for admission
     * @example "Home health care"
     */
    reason?: string;
    /** Episodes within this admission */
    episodes: EpisodeSummaryDto[];
    /**
     * Admission status
     * @example "ADMITTED"
     */
    status:
        | 'PENDING_ELIGIBILITY'
        | 'ELIGIBLE'
        | 'PENDING'
        | 'SCHEDULED'
        | 'NON_ADMIT'
        | 'ADMITTED'
        | 'TRANSFERRED'
        | 'DISCHARGED'
        | 'DECEASED';
    /**
     * Branch/facility name
     * @example "California Heights Medical Center"
     */
    branchName: string;
    /**
     * Branch/facility Id
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    branchId: string;
}

export interface ClientEventDto {
    /**
     * Event name for client-side event
     * @example "musa.route.navigation"
     */
    eventName: string;
    /**
     * Route path that was navigated to
     * @example "/branch/abc-123/patients"
     */
    path: string;
    /**
     * Timestamp when the event occurred on the client
     * @example "2026-01-08T12:34:56.789Z"
     */
    timestamp: string;
    /** Optional additional details about the event */
    details?: object;
}

export interface BatchClientEventsDto {
    /** Array of client events to log */
    events: ClientEventDto[];
}

export interface BatchClientEventsResponseDto {
    /**
     * Number of events successfully logged
     * @example 15
     */
    successCount: number;
    /**
     * Number of events that failed to log
     * @example 0
     */
    failureCount: number;
}

export interface MatchProtocolsDto {
    /**
     * Array of ICD-10 diagnosis codes to match against protocols
     * @example ["I50.22","E11.9"]
     */
    icdCodes: string[];
}

export interface CareProtocolTaskDto {
    id: string;
    title: string;
    frequency?: string;
    sortOrder: number;
}

export interface CareProtocolGoalDto {
    id: string;
    title: string;
    discipline?: string;
    days?: number;
    sortOrder: number;
    tasks: CareProtocolTaskDto[];
}

export interface CareProtocolProblemDto {
    id: string;
    diagnosisCode: string;
    diagnosisName: string;
    title: string;
    description?: string;
    sortOrder: number;
    goalCount: number;
    taskCount: number;
    goals: CareProtocolGoalDto[];
}

export interface CareProtocolMatchResponseDto {
    problems: CareProtocolProblemDto[];
    /** Total number of matching problems */
    total: number;
    /** List of unique diagnoses that matched */
    matchedDiagnoses: string[];
}

export interface BulkAddSelectionGoalDto {
    /** @example "123e4567-e89b-12d3-a456-426614174000" */
    goalId: string;
    tasks: string[];
}

export interface BulkAddSelectionDto {
    /** @example "123e4567-e89b-12d3-a456-426614174000" */
    problemId: string;
    goals: BulkAddSelectionGoalDto[];
}

export interface BulkAddFromProtocolsDto {
    /**
     * The visit ID to associate the problems with
     * @example "123e4567-e89b-12d3-a456-426614174000"
     */
    visitId: string;
    selections: BulkAddSelectionDto[];
}

export interface SchedulingDashboardColumnDto {
    /**
     * Column key, e.g. date string YYYY-MM-DD
     * @example "2026-02-16"
     */
    key: string;
    /**
     * Display label, e.g. Mon 16 or Mon
     * @example "Mon 16"
     */
    label: string;
    /**
     * Local date in YYYY-MM-DD
     * @example "2026-02-16"
     */
    dateLocal: string;
}

export interface SchedulingDashboardScopeDto {
    /** Branch ID filter or null for all branches */
    branchId?: string | null;
    /** Range mode */
    rangeMode: 'WEEK' | 'ROLLING_7';
    /**
     * Anchor date in local reporting timezone
     * @example "2026-02-16"
     */
    anchorDateLocal: string;
    /**
     * Window start (ISO datetime)
     * @example "2026-02-16T00:00:00.000"
     */
    windowStart: string;
    /**
     * Window end (ISO datetime, exclusive)
     * @example "2026-02-23T00:00:00.000"
     */
    windowEnd: string;
    /** Metric type */
    metric: 'visits' | 'units';
    /** Exactly 7 columns for heatmap rendering */
    columns: SchedulingDashboardColumnDto[];
    /** Discipline filter applied, null if none */
    disciplines?: string[] | null;
}

export interface SchedulingDashboardKpisDto {
    /** Total visits in window */
    totalVisits: number;
    /** Number of distinct nurses with at least 1 visit */
    activeNurses: number;
    /**
     * Load imbalance ratio: max / minNonZero
     * @example 4.5
     */
    loadImbalanceRatio: number;
    /** Number of nurse-day cells with 0 visits */
    idleNurseDays: number;
    /** Total number of conflict pairs */
    conflictPairs: number;
}

export interface SchedulingDashboardNurseDto {
    /** User ID of the nurse */
    userId: string;
    /** Display name */
    displayName: string;
    /** Disciplines */
    disciplines?: string[];
    /** Branch IDs this nurse is associated with */
    branchIds?: string[];
    /** Total visits (or units) in window */
    windowCount: number;
    /** Daily visit counts aligned to scope.columns (length 7) */
    dailyCounts: number[];
    /** Number of conflict pairs for this nurse */
    conflictPairs: number;
}

export interface SchedulingDashboardHeatmapDto {
    /** Daily totals aligned to scope.columns (length 7) */
    dailyTotals: number[];
    /** Grand total across the window */
    windowTotal: number;
}

export interface ConflictSampleDto {
    prevVisitId: string;
    nextVisitId: string;
    prevStart: string;
    prevEnd: string;
    nextStart: string;
    nextEnd: string;
    prevPatientId: string;
    nextPatientId: string;
    type: 'OVERLAP' | 'TOO_CLOSE';
    /** Minutes gap (negative means overlap) */
    minutesGap: number;
}

export interface SchedulingDashboardConflictDto {
    userId: string;
    displayName: string;
    conflictPairs: number;
    samples: ConflictSampleDto[];
}

export interface SchedulingDashboardDto {
    scope: SchedulingDashboardScopeDto;
    kpis: SchedulingDashboardKpisDto;
    nurses: SchedulingDashboardNurseDto[];
    heatmap: SchedulingDashboardHeatmapDto;
    conflicts: SchedulingDashboardConflictDto[];
}

export interface NurseVisitItemDto {
    visitId: string;
    patientId: string;
    patientName?: string;
    branchId: string;
    branchName: string;
    start: string;
    end: string;
    status: string;
    discipline?: string;
    visitType?: string;
    conflictTag?: 'OVERLAP' | 'TOO_CLOSE';
    conflictWithVisitId?: string;
}

export interface NurseVisitsDto {
    userId: string;
    displayName: string;
    windowStart: string;
    windowEnd: string;
    visits: NurseVisitItemDto[];
}

export interface ReassignmentCandidatesRequestDto {
    /** Visit IDs to find candidates for */
    visitIds: string[];
}

export interface CandidatePerVisitDto {
    visitId: string;
    isEligible: boolean;
    isAvailable: boolean;
    reason?: 'NO_BRANCH_PERMISSION' | 'ROLE_NOT_ALLOWED' | 'INACTIVE' | 'OVERLAP' | 'TOO_CLOSE';
    conflictingVisitId?: string;
    minutesGap?: number;
}

export interface ReassignmentCandidateDto {
    userId: string;
    displayName: string;
    kind: 'ADMIN' | 'SKILLED_NURSE';
    isEligibleForAll: boolean;
    isAvailableForAll: boolean;
    perVisit: CandidatePerVisitDto[];
}

export interface ReassignmentCandidatesResponseDto {
    candidates: ReassignmentCandidateDto[];
}

export interface ReassignVisitsRequestDto {
    /** User ID visits are currently assigned to */
    fromUserId: string;
    /** User ID to reassign visits to */
    toUserId: string;
    /** Visit IDs to reassign */
    visitIds: string[];
    /** Optional reason for reassignment */
    reason?: string;
}

export interface ReassignedVisitDto {
    visitId: string;
    previousUserId: string;
    newUserId: string;
    start: string;
    end: string;
    patientId: string;
    branchId: string;
}

export interface ReassignVisitsResultDto {
    updatedVisits: ReassignedVisitDto[];
}

export interface ComplianceDashboardSummaryDto {
    totalStaff: number;
    compliantCount: number;
    nonCompliantCount: number;
    pendingReviewCount: number;
}

export interface PendingReviewDocumentDto {
    id: string;
    staffId: string;
    staffName: string;
    documentTypeId?: string | null;
    documentTypeName?: string | null;
    title?: string | null;
    fileName: string;
    mimeType?: string | null;
    /** @format date-time */
    createdAt: string;
}

export interface ComplianceDashboardDto {
    summary: ComplianceDashboardSummaryDto;
    pendingDocuments: PendingReviewDocumentDto[];
}

export interface ComplianceAlertDto {
    userId: string;
    userName: string;
    documentTypeId?: string | null;
    documentTypeName: string;
    alertType: string;
    expirationDate?: string | null;
}

export interface ComplianceAlertMetaDto {
    page: number;
    pageSize: number;
    total: number;
    missingCount: number;
    expiredCount: number;
    expiringCount: number;
    rejectedCount: number;
}

export interface ComplianceAlertPageDto {
    items: ComplianceAlertDto[];
    meta: ComplianceAlertMetaDto;
}

export interface StaffComplianceDto {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    roleId?: string | null;
    roleName?: string | null;
    disciplines: ('SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW')[];
    complianceStatus: string;
    compliancePercentage: number;
    approvedCount: number;
    requiredCount: number;
    pendingCount: number;
    requiresCompliance: boolean;
    /** Employee active/inactive status from the management database */
    status: string;
}

export interface StaffComplianceListDto {
    items: StaffComplianceDto[];
    total: number;
}

export interface ComplianceSummaryDto {
    staffName: string;
    status: string;
    percentage: number;
    satisfiedCount: number;
    totalRequired: number;
    pendingCount: number;
    needsAttentionCount: number;
    requiresCompliance: boolean;
}

export interface ApplicableDocumentTypeDto {
    documentTypeId: string;
    documentTypeName: string;
    isRequired: boolean;
    requiresExpiration: boolean;
    allowMultiple: boolean;
    documentStatus: string;
    latestDocumentId?: string | null;
    fileName?: string | null;
    expirationDate?: string | null;
    rejectionReason?: string | null;
    mimeType?: string | null;
    notes?: string | null;
    version: number;
    /** @format date-time */
    createdAt?: string | null;
    /** @format date-time */
    reviewedAt?: string | null;
}

export interface MyProfileAddressDto {
    address: string;
    city: string;
    state: string;
    zipcode: string;
}

export interface MyProfileBranchDto {
    id: string;
    name: string;
    roleName?: string | null;
}

export interface MyProfileDto {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    address?: MyProfileAddressDto;
    disciplines: string[];
    branches: MyProfileBranchDto[];
}

export interface UpdateMyProfileAddressDto {
    address: string;
    city: string;
    state: string;
    zipcode: string;
}

export interface UpdateMyProfileDto {
    firstName: string;
    lastName: string;
    phone?: string | null;
    address?: UpdateMyProfileAddressDto;
}

export interface AuditLogEntryDto {
    id: string;
    employeeDocumentId?: string | null;
    documentTypeId?: string | null;
    action: object;
    actorId: string;
    details?: object | null;
    /** @format date-time */
    createdAt: string;
}

export interface AuditLogListDto {
    items: AuditLogEntryDto[];
    total: number;
}

export interface ComplianceDocumentTypeRuleDto {
    id: string;
    documentTypeId: string;
    roleId?: string | null;
    roleName?: string | null;
    discipline?: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW' | null;
    isRequired: boolean;
}

export interface ComplianceDocumentTypeDto {
    id: string;
    name: string;
    description?: object | null;
    isRequired: boolean;
    isMandatory: boolean;
    requiresExpiration: boolean;
    allowMultiple: boolean;
    isDefault: boolean;
    status: object;
    rules: ComplianceDocumentTypeRuleDto[];
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
}

export interface CreateComplianceDocumentTypeDto {
    /** @maxLength 255 */
    name: string;
    /** @maxLength 2000 */
    description?: string;
    isRequired: boolean;
    requiresExpiration: boolean;
    allowMultiple: boolean;
}

export interface UpdateComplianceDocumentTypeDto {
    /** @maxLength 255 */
    name?: string;
    /** @maxLength 2000 */
    description?: string;
    isRequired?: boolean;
    requiresExpiration?: boolean;
    allowMultiple?: boolean;
}

export interface CreateComplianceDocumentTypeRuleDto {
    roleId?: string | null;
    discipline?: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW' | null;
    isRequired: boolean;
}

export interface UpdateComplianceDocumentTypeRuleDto {
    isRequired: boolean;
}

export interface ComplianceEmployeeDocumentDto {
    id: string;
    userId: string;
    documentTypeId?: string | null;
    documentTypeName?: string | null;
    fileId: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    status: string;
    rejectionReason?: string | null;
    expirationDate?: string | null;
    version: number;
    uploadedBy: string;
    reviewedBy?: string | null;
    reviewedByName?: string | null;
    /** @format date-time */
    reviewedAt?: string | null;
    notes?: string | null;
    title?: string | null;
    isCustom: boolean;
    /** @format date-time */
    createdAt: string;
}

export interface ComplianceUploadRequestItemDto {
    contentType: string;
    originalName: string;
    fileSize: number;
    documentTypeId?: string | null;
    expirationDate?: string | null;
    notes?: string | null;
    title?: string | null;
}

export interface ComplianceUploadResponseItemDto {
    id: string;
    uploadUrl: string;
    contentType: string;
}

export interface ComplianceUploadConfirmDto {
    fileIds: string[];
}

export interface RejectComplianceDocumentDto {
    /**
     * @minLength 10
     * @maxLength 1000
     */
    reason: string;
}

export interface NoteSummaryInputDto {
    /** The visit form ID to load chart data from */
    formId: string;
    /** Additional note text / context (max 4000 chars) */
    noteText?: string;
    /** Existing clinician-authored narrative to incorporate into the AI generation (max 10000 chars). Treated as untrusted data. */
    existingNarrative?: string;
    /** Override the org-default model for this single call. Only honored in lower envs (test, local, dev, qa, branch); rejected with HTTP 400 in production. */
    modelOverride?: string;
}

export interface NoteSummaryCreatedDto {
    jobId: string;
    status: 'CREATING' | 'QUEUED' | 'RUNNING' | 'CANCEL_REQUESTED' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
    createdAt: string;
}

export interface AvailableModelDto {
    /** Bedrock model identifier */
    modelId: string;
    /** Human-readable label for the picker */
    displayName: string;
}

export interface NoteSummaryAvailableModelsDto {
    /** Org-configured default model used when no override is sent */
    defaultModelId: string;
    /** Empty in production envs (override is rejected there) */
    availableModels: AvailableModelDto[];
}

export interface NoteSummaryQuotaLimitDto {
    scope: 'feature' | 'sublimit';
    /** Parent dimension name when scope=feature */
    dimension?: string;
    /** Attribute key when scope=sublimit */
    attributeKey?: string;
    /** Attribute value when scope=sublimit */
    attributeValue?: string;
    period: 'TOTAL' | 'DAILY_UTC' | 'WEEKLY_UTC' | 'MONTHLY_UTC';
    /**
     * null when period=TOTAL
     * @format date-time
     */
    periodEnd?: string | null;
    max: number;
    remaining: number;
}

export interface NoteSummaryQuotaStatusDto {
    /** True when at least one limit has remaining = 0 */
    exhausted: boolean;
    /** min(remaining) across all enforced limits — surfaced in the UI as "X narratives remaining". Infinity when no limits apply. */
    bindingRemaining: number;
    limits: NoteSummaryQuotaLimitDto[];
}

export interface NoteSummaryResultDto {
    /** Single-paragraph nurse-voice visit narrative */
    visitNarrative: string;
    /** Short bullets summarising the most important findings for triage/handoff */
    keyFindings: string[];
    severity: 'low' | 'medium' | 'high';
    modelId: string;
    formId: string;
    formTitle: string;
    /** ISO-8601 timestamp the narrative was generated at */
    generatedAt: string;
    /** Deterministic narrative bullets from rule engine */
    ruleBullets: any[];
    /** HIGH alert rules requiring attention */
    highAlertRules: any[];
    /** True when the form had no findings to summarize and the LLM was not called. Frontend surfaces a toast instead of opening the result drawer. */
    noFormData?: boolean;
}

export interface NoteSummaryActiveDto {
    jobId: string;
    formId: string;
    status: 'CREATING' | 'QUEUED' | 'RUNNING' | 'CANCEL_REQUESTED' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
    clientOutcome?: 'ACCEPTED' | 'DISCARDED' | null;
    errorCode?: string | null;
    createdAt: string;
    result?: NoteSummaryResultDto | null;
}

export interface NoteSummaryAcknowledgeDto {
    outcome: 'ACCEPTED' | 'DISCARDED';
}

export interface NoteSummaryStatusDto {
    jobId: string;
    status: 'CREATING' | 'QUEUED' | 'RUNNING' | 'CANCEL_REQUESTED' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
    jobAttempt: number;
    /** Non-PHI result summary (JSON string) */
    resultSummary?: string | null;
    errorCode?:
        | 'PROVIDER_THROTTLED'
        | 'PROVIDER_TRANSIENT'
        | 'TIMEOUT_TRANSIENT'
        | 'LEASE_EXPIRED'
        | 'LEASE_LOST'
        | 'LLM_PARSE_FAILED'
        | 'LLM_VALIDATION_FAILED'
        | 'LLM_CALL_IN_FLIGHT'
        | 'PROVIDER_VALIDATION'
        | 'PROVIDER_GUARDRAIL_BLOCKED'
        | 'MODEL_NOT_ALLOWED'
        | 'INVALID_PAYLOAD_SCHEMA'
        | 'AUTH_FAILED'
        | 'PRICING_MISSING'
        | 'UNKNOWN_FEATURE'
        | 'UNSUPPORTED_FORM_TYPE'
        | 'PHI_GUARD_VIOLATION'
        | 'PAYLOAD_INTEGRITY_FAILED'
        | 'CALL_IDENTITY_COLLISION'
        | 'CALL_SIGNATURE_MISMATCH'
        | 'JSON_SCHEMA_NOT_FOUND'
        | 'LLM_OUTPUT_TRUNCATED'
        | 'MAX_CALLS_EXCEEDED'
        | 'CREATE_STUCK'
        | 'JOB_STUCK'
        | 'TIMEOUT'
        | 'UNKNOWN_IN_FLIGHT'
        | 'LEASE_EXPIRED_PRE_INVOKE'
        | 'LEASE_EXPIRED_PRE_RESERVE'
        | 'REJECTED_QUOTA'
        | 'QUOTA_ATTRIBUTE_INVALID_VALUE'
        | 'QUOTA_ATTRIBUTE_UNREGISTERED'
        | null;
    createdAt: string;
    startedAt?: string | null;
    completedAt?: string | null;
    cancelRequestedAt?: string | null;
    cancelRequestedByUserId?: string | null;
}

export interface NoteSummaryJobListDto {
    jobs: NoteSummaryStatusDto[];
    /** Total number of matching jobs */
    total: number;
    nextCursor?: string | null;
}

export interface FeatureStatusDto {
    featureType: string;
    status: 'READY' | 'QUOTA_EXCEEDED' | 'DISABLED' | 'UNCONFIGURED';
    /** Short reason when status !== CONFIGURED */
    reason?: string | null;
}

export interface PermissionModel {
    permissionArea:
        | '*'
        | 'visit'
        | 'patient'
        | 'intake'
        | 'qa'
        | 'employee'
        | 'payroll'
        | 'billing'
        | 'orders'
        | 'company'
        | 'branch'
        | 'physician'
        | 'pharmacy'
        | 'visit-type'
        | 'visit-form'
        | 'order'
        | 'cms'
        | 'template'
        | 'report'
        | 'admin-dashboard'
        | 'qa-dashboard'
        | 'scheduling-dashboard'
        | 'clinical-dashboard'
        | 'insurance'
        | 'amend-form'
        | 'compliance'
        | 'settings'
        | 'communication';
    PermissionAction: '*' | 'create' | 'update' | 'read' | 'delete';
}

export interface LoginRequestDto {
    /**
     * The email address of the user
     * @format email
     * @example "administrator@musa.xyz"
     */
    email: string;
    /**
     * The password of the user account
     * @format password
     * @example "Password123"
     */
    password: string;
}

export interface BranchScopeDto {
    /** @example "5ba82a64-3d92-11ec-9bbc-0242ac130002" */
    id: string;
    /** @example "Branch Name" */
    name: string;
    /** @example ["*:*"] */
    access: string[];
}

export interface ScopeDto {
    branches: BranchScopeDto[];
    /** @example ["SN"] */
    disciplines: string[];
    /** @example ["*:*"] */
    organization?: string[];
}

export interface LoginResponseDto {
    /** @example "5ba82a64-3d92-11ec-9bbc-0242ac130002" */
    id: string;
    /** @example "test@test.com" */
    email: string;
    /** @example "Stephanie" */
    firstName: string;
    /** @example "Smith" */
    lastName: string;
    /** @example "Stephanie Smith" */
    displayName: string;
    /** @example true */
    admin: boolean;
    organizations: OrganizationDto[];
    activeOrg?: OrganizationDto;
    scope?: ScopeDto;
    discipline?: string;
}

export interface OrgSelectorRequestDto {
    /**
     * The id of the active organization
     * @example "123"
     */
    id: string;
}

export interface ForgotPasswordDto {
    /**
     * The email address of the user
     * @format email
     * @example "administrator@musa.xyz"
     */
    email: string;
}

export interface ChangePasswordDto {
    /**
     * The email address of the user
     * @format email
     * @example "administrator@musa.xyz"
     */
    email: string;
    /**
     * The verification code sent to the user
     * @example "123456"
     */
    token: string;
    /**
     * @format password
     * @example "password"
     */
    password: string;
    /**
     * @format password
     * @example "password"
     */
    confirmPassword: string;
}

export interface BranchRoleDto {
    branchId: string;
    companyId: string;
    roleId: string;
}

export interface CreateUserDto {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    fax?: string;
    discipline?: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW';
    address: CreateAddressDto;
    orgAdmin: boolean;
    active: boolean;
    branches: BranchRoleDto[];
    requiresCompliance?: boolean;
}

export interface UserDto {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    fax?: string;
    discipline: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW';
    address: CreateAddressDto;
    orgAdmin: boolean;
    branches: BranchRoleDto[];
    active: boolean;
    verified: boolean;
    locked: boolean;
    requiresCompliance: boolean;
}

export interface UserEmailDto {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
}

export interface AdminUserDto {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    locked: boolean;
    active: boolean;
}

export interface CreateAdminUserDto {
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
}

export type ServicesDto = object;

export interface CompanyDto {
    id: string;
    name: string;
    address: AddressDto;
    addressId: string;
    agencyId?: string;
    taxId?: string;
    npi?: string;
    ptan?: string;
    accreditationBody?: string;
    accreditationId?: string;
    branches: BranchDto[];
    services: ServicesDto;
}

export interface UpdateCompanyDto {
    /** @example "Acme Company" */
    name: string;
    address: CreateAddressDto;
    agencyId?: string;
    taxId: string;
    npi: string;
    /** @example "077001" */
    ptan: string;
    services: CreateServicesDto;
    accreditationBody?: string;
    accreditationId?: string;
}

export interface UpdateBranchDto {
    hotlineAddress?: CreateAddressDto;
    hotlineName?: string;
    hotlinePhone?: string;
    medicareProviderNumber?: string;
    statefacilityId?: string;
    /**
     * OASIS M0016: N, P, or a CMS standard branch ID (XXQXXXX999)
     * @example "N"
     */
    stateBranchId?: string;
    npi?: string;
    /** @example "077001" */
    ptan?: string;
    operatingHours?: OperatingHoursDto;
    accreditationBody?: string;
    accreditationId?: string;
    administrator?: string;
    administratorPhone?: string;
    administratorFax?: string | null;
    defaultChargeSN?: string;
    defaultChargePT?: string;
    defaultChargeOT?: string;
    defaultChargeST?: string;
    defaultChargeHHA?: string;
    defaultChargeMSW?: string;
    /** @example "Acme Branch" */
    name: string;
    address: CreateAddressDto;
}

export interface CreateBranchDto {
    /** @example "Acme Branch" */
    name: string;
    address: CreateAddressDto;
    hotlineAddress?: CreateAddressDto;
    hotlineName?: string;
    hotlinePhone?: string;
    medicareProviderNumber?: string;
    statefacilityId?: string;
    /**
     * OASIS M0016: N, P, or a CMS standard branch ID (XXQXXXX999)
     * @example "N"
     */
    stateBranchId?: string;
    npi?: string;
    /** @example "077001" */
    ptan?: string;
    operatingHours?: OperatingHoursDto;
    accreditationBody?: string;
    accreditationId?: string;
    administrator: string;
    administratorPhone: string;
    administratorFax?: string | null;
    defaultChargeSN: string;
    defaultChargePT: string;
    defaultChargeOT: string;
    defaultChargeST: string;
    defaultChargeHHA: string;
    defaultChargeMSW: string;
}

export interface RoleDto {
    id: string;
    name: string;
    allow: string;
    deny: string;
    system: string;
    baseId: string;
}

export interface SearchPhysicianDto {
    npiNumber?: string;
    firstName?: string;
    lastName?: string;
    state?: string;
    city?: string;
    specialty?: string;
    limit?: number;
    page?: number;
}

export interface CreatePhysicianAddressDto {
    id: string;
    phone: string | null;
    fax: string | null;
    type: string;
    address: CreateAddressDto;
}

export interface CreatePhysicianDto {
    pecos: boolean;
    npi: string;
    addresses: CreatePhysicianAddressDto[];
    address: CreateAddressDto[];
    status: string;
    credential: string | null;
    firstName: string;
    middleName?: string | null;
    lastName: string;
    taxonomyCode: string | null;
    taxonomyDesc: string | null;
    taxonomyGroup: string | null;
    taxonomyState: string | null;
    taxonomyLicense: string | null;
    taxonomyPrimary: string | null;
}

export interface UpdatePhysicianDto {
    pecos?: boolean;
    npi?: string;
    addresses?: CreatePhysicianAddressDto[];
    address?: CreateAddressDto[];
    status?: string;
    credential?: string | null;
    firstName?: string;
    middleName?: string | null;
    lastName?: string;
    taxonomyCode?: string | null;
    taxonomyDesc?: string | null;
    taxonomyGroup?: string | null;
    taxonomyState?: string | null;
    taxonomyLicense?: string | null;
    taxonomyPrimary?: string | null;
}

export interface CreatePatientContactDto {
    patientId: string;
    email: string;
    pointOfContact: string;
    phones: PatientPhoneDto[];
    addresses: PatientAddressDto[];
}

export interface SavePatientSupportDto {
    patientId: string;
    powerOfAttorney: string;
    powerOfAttorneyName?: string | null;
    powerOfAttorneyCopyObtained?: boolean | null;
    communityServices?: string[];
    communityServicesOther?: string | null;
    caregivers?: PatientCaregiverDto[];
}

export interface PatientSupportDto {
    patientId: string;
    communityServices: string[];
    communityServicesOther: string;
    caregivers: PatientCaregiverDto[];
    powerOfAttorney?: boolean | null;
    powerOfAttorneyName?: string | null;
    powerOfAttorneyCopyObtained?: boolean | null;
}

export interface SaveCaregiverDto {
    id?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffixName?: string;
    email?: string;
    relationship?: 'spouse' | 'sibling' | 'child' | 'other';
    relationshipOther?: string | null;
    availibility?: string;
    abilityToProvideCare?: 'able' | 'limited' | 'unable';
    abilityToProvideCareNote?: string;
    emergencyContact?: boolean;
    legalRepresentative?: boolean;
    primary?: boolean;
    primaryContact?: boolean;
    phones?: PhoneDto[];
}

export interface CreateRiskDto {
    risk: string;
    severity: string;
}

export interface CreateAllergyDto {
    allergy: string;
    severity: string;
}

export interface CreatePatientAllergyRiskDto {
    patientId: string;
    risks: CreateRiskDto[];
    allergies: CreateAllergyDto[];
}

export interface SavePhysicianDto {
    id: string;
    label: string;
}

export interface SaveAdmissionPhysicianDto {
    physician: SavePhysicianDto | null;
    roles: string[];
    primary: boolean | null;
    overseePlanOfCare: boolean | null;
}

export interface SaveProviderPharmacyDto {
    id: string;
    label: string;
}

export interface SaveAdmissionPharmacyDto {
    pharmacy: SaveProviderPharmacyDto | null;
    primary: boolean | null;
}

export interface SaveAdmissionProviderDto {
    admissionId: string;
    physicians: SaveAdmissionPhysicianDto[];
    pharmacies: SaveAdmissionPharmacyDto[];
}

export interface SavePharmacyDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    name: string;
    phone: string;
    fax?: string | null;
    address?: CreateAddressDto | null;
}

export interface SavePatientPharmacyDto {
    id?: string;
    name?: string;
    phone?: string;
    fax?: string | null;
    address?: AddressDto | null;
    primary?: boolean;
}

export interface CreateVisitTypeDto {
    type: string;
    title: string;
    status: string;
    discipline: string;
    employeeClass: string;
    revenueCodeId?: string | null;
    serviceCodeId?: string | null;
    defaultPay?: number | null;
    defaultHours?: number | null;
    adminCost?: number | null;
    payable?: boolean | null;
    payType?: string | null;
    billable?: boolean | null;
    roundHours?: boolean | null;
    mileage?: boolean | null;
    surcharge?: boolean | null;
    additionalPay?: boolean | null;
    forms?: string[];
}

export interface UpdateVisitTypeDto {
    type?: string;
    title?: string;
    status?: string;
    discipline?: string;
    employeeClass?: string;
    revenueCodeId?: string | null;
    serviceCodeId?: string | null;
    defaultPay?: number | null;
    defaultHours?: number | null;
    adminCost?: number | null;
    payable?: boolean | null;
    payType?: string | null;
    billable?: boolean | null;
    roundHours?: boolean | null;
    mileage?: boolean | null;
    surcharge?: boolean | null;
    additionalPay?: boolean | null;
    forms?: string[];
}

export interface RevenueCodeDto {
    id: string;
    code: string;
    description: string;
    discipline: string;
}

export interface ServiceCodeDto {
    id: string;
    code: string;
    description: string;
    discipline: string;
}

export interface PayrollDto {
    employeeId: string;
    employeeName: string;
    companyId: string;
    company: string;
    visitCount: number;
    paidVisitCount: number;
    hours: number;
    mileage: number;
    mileageCost: number;
    surcharge: number;
    additional: number;
    adjustments: number;
    amountPaid: number;
    amountDue: number;
    status: 'paid' | 'partial' | 'not-paid';
}

export interface PayrollPeriodDto {
    sequence: number;
    /** @format date-time */
    start: string;
    /** @format date-time */
    end: string;
    cadence: 'WEEKLY' | 'BI-WEEKLY' | 'MONTHLY';
    configId: string;
    /** Mileage rate for this period */
    mileageRate: number;
}

export interface VisitFormStatusDto {
    formId: string;
    name: string;
    title:
        | '485-poc'
        | 'abn'
        | 'discharge-summary'
        | 'face-to-face'
        | 'hha-poc'
        | 'hha-supervisory'
        | 'hha-visit'
        | 'lvn-supervisory'
        | 'msw-assessment'
        | 'msw-follow-up'
        | 'oasis'
        | 'ot-discharge'
        | 'ot-eval'
        | 'ot-poc'
        | 'ot-re-eval'
        | 'ot-visit'
        | 'patient-choice'
        | 'patient-consent'
        | 'physician-order'
        | 'pt-discharge'
        | 'pt-eval'
        | 'pt-poc'
        | 'pt-re-eval'
        | 'pt-summary'
        | 'pt-visit'
        | 'pta-supervisory'
        | 'pta-visit'
        | 'route-sheet'
        | 'sixty-day-summary'
        | 'snn'
        | 'st-summary';
    status: 'DRAFT' | 'IN PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REVIEW' | 'REJECTED' | 'APPROVED';
}

export interface PayrollEmployeeVisitDto {
    payrollId: string;
    visitId: string;
    branchId: string;
    patientId: string;
    admissionId: string;
    patientName: string;
    employeeName: string;
    visitTypeId: string;
    visitType: string;
    type: 'standard' | 'adjustment';
    visitStatus: 'complete' | 'incomplete';
    forms: VisitFormStatusDto[];
    /** @format date */
    visitDate: string;
    mileage: number;
    mileageCost: number;
    surcharge: number;
    additional: number;
    hours: number;
    defaultCharge: number;
    payType: string;
    customCharge: number | null;
    paidCharge: number | null;
    paidPayType: string | null;
    adjustmentAmount: number | null;
    isPaid: boolean;
    amount: number;
    paidStatus: 'paid' | 'not-paid';
    paidDate: string | null;
    openAdjustmentId: string | null;
    hasOpenAdjustment: boolean;
    notes: string | null;
    /** @format date */
    effectiveDate: string | null;
}

export interface UpdateVisitPayrollDto {
    payrollIds: string[];
    status: 'paid' | 'not-paid';
    /**
     * Start date of the period (YYYY-MM-DD)
     * @example "2024-01-01"
     */
    periodFrom: string;
    /**
     * End date of the period (YYYY-MM-DD)
     * @example "2024-01-07"
     */
    periodTo: string;
}

export interface UpdateVisitChargeDto {
    /** @min 0 */
    customCharge: number | null;
}

export interface CreateVisitAdjustmentDto {
    /**
     * Signed adjustment amount in USD (as string)
     * @example "-25.00"
     */
    adjustmentAmount: string;
    /**
     * Effective date for the adjustment
     * @format date
     */
    effectiveDate?: string;
    /** Optional notes explaining why the adjustment was created */
    notes?: string;
}

export interface VisitAdjustmentDto {
    id: string;
    visitId: string;
    status: 'paid' | 'not-paid';
    adjustmentAmount: string | null;
    /** @format date */
    effectiveDate: string | null;
    notes: string | null;
    /** The payroll schedule this adjustment was paid */
    payrollScheduleId?: object | null;
}

export interface UpdateVisitAdjustmentDto {
    /**
     * Updated adjustment amount in USD (string)
     * @example "15.50"
     */
    adjustmentAmount?: string;
    /** Update adjustment notes */
    notes?: string;
}

export interface PayrollConfigDto {
    id: string;
    type: 'weekly' | 'bi-weekly' | 'monthly';
    /**
     * Mileage rate in dollars
     * @example "0.70"
     */
    mileageRate: string;
    /**
     * Effective from date
     * @format date
     */
    effectiveFrom: string;
    /**
     * Include visits within payroll period end date
     * @default false
     */
    payrollInclusive: boolean;
    createdBy: string;
    updatedBy: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
}

export interface UpdatePayrollConfigDto {
    type: 'weekly' | 'bi-weekly' | 'monthly';
    /**
     * Mileage rate in dollars (as string)
     * @example "0.70"
     */
    mileageRate: string;
    /**
     * Include visits within payroll period end date
     * @default false
     */
    payrollInclusive: boolean;
}

export interface PayrollScheduleDto {
    id: string;
    name: string;
    type: 'weekly' | 'bi-weekly' | 'monthly';
    /**
     * Mileage rate in dollars
     * @example "0.70"
     */
    mileageRate: string;
    /**
     * Schedule start date
     * @format date
     */
    scheduleStartDate: string;
    /**
     * Include visits within payroll period end date
     * @default false
     */
    payrollInclusive: boolean;
    /** Day of month when period ends (1-31, null for end of month) */
    periodEndDayOfMonth: string | null;
    /** Day of week when period ends (0-6, Sunday-Saturday) */
    periodEndDayOfWeek: string | null;
    /** Day of month when payroll is paid (1-31) */
    payrollDayOfMonth: string | null;
    /** Day of week when payroll is paid (0-6, Sunday-Saturday) */
    payrollDayOfWeek: string | null;
    /** Whether this schedule is currently active */
    isActive: boolean;
    /** Whether this schedule is currently the default */
    isCurrentDefault: boolean;
    /** Number of employees explicitly assigned to this schedule */
    assignedEmployeeCount: number;
    /** Number of employees assigned by default */
    defaultEmployeeCount: number;
}

export interface PayrollScheduleListMetaDto {
    /** Total number of active schedules */
    activeCount: number;
    /** Total number of inactive schedules */
    inactiveCount: number;
    /** Total number of schedules */
    totalCount: number;
}

export interface PayrollScheduleListResponseDto {
    schedules: PayrollScheduleDto[];
    meta: PayrollScheduleListMetaDto;
}

export interface CreatePayrollScheduleDto {
    name: string;
    type: 'weekly' | 'bi-weekly' | 'monthly';
    /**
     * Mileage rate in dollars (as string)
     * @example "0.70"
     */
    mileageRate: string;
    /**
     * Schedule start date
     * @format date
     */
    scheduleStartDate: string;
    /**
     * Include visits within payroll period end date
     * @default false
     */
    payrollInclusive: boolean;
    /** Day of month when period ends (1-31), null for end of month */
    periodEndDayOfMonth?: string | null;
    /** Day of week when period ends (0-6, Sunday-Saturday) */
    periodEndDayOfWeek?: string | null;
    /** Day of month when payroll is paid (1-31) */
    payrollDayOfMonth?: string | null;
    /** Day of week when payroll is paid (0-6, Sunday-Saturday) */
    payrollDayOfWeek?: string | null;
    /**
     * Whether to make this the new default schedule
     * @default false
     */
    makeDefault?: boolean;
}

export interface UpdatePayrollScheduleDto {
    name?: string;
    /**
     * Mileage rate in dollars (as string)
     * @example "0.70"
     */
    mileageRate?: string;
    /** Include visits within payroll period end date */
    payrollInclusive?: boolean;
    /** Day of month when period ends (1-31), null for end of month */
    periodEndDayOfMonth?: string | null;
    /** Day of week when period ends (0-6, Sunday-Saturday) */
    periodEndDayOfWeek?: string | null;
    /** Day of month when payroll is paid (1-31) */
    payrollDayOfMonth?: string | null;
    /** Day of week when payroll is paid (0-6, Sunday-Saturday) */
    payrollDayOfWeek?: string | null;
    /** Whether this schedule is active */
    isActive?: boolean;
    /** Whether this schedule is the default */
    isDefault?: boolean;
}

export interface DeactivatePayrollScheduleResponseDto {
    success: boolean;
    message: string;
    /** Number of employees reassigned to default schedule */
    employeesReassigned: number;
    /** ID of default schedule employees were reassigned to */
    defaultScheduleId: object | null;
}

export interface ReactivatePayrollScheduleResponseDto {
    success: boolean;
    message: string;
}

export interface PayrollPeriodV2Dto {
    sequence: number;
    /** @format date */
    start: string;
    /** @format date */
    end: string;
    /**
     * Date when employees will be paid
     * @format date
     */
    payrollDate: string;
    cadence: 'WEEKLY' | 'BI-WEEKLY' | 'MONTHLY';
    scheduleId: string;
    scheduleName: string;
    mileageRate: number;
    inclusive: boolean;
    /** Period status based on dates and closure */
    status: 'open' | 'pending' | 'closed';
    /** Whether this period can be modified */
    canModify: boolean;
    /** Whether this period was explicitly closed */
    isExplicitlyClosed: boolean | null;
}

export interface ClosePeriodDto {
    /**
     * Period start date
     * @format date
     */
    periodStart: string;
    /**
     * Period end date
     * @format date
     */
    periodEnd: string;
}

export interface EmployeeBranchDto {
    branchId: string;
    branchName: string;
    roleId: string;
    roleName: string;
}

export interface PayrollScheduleEmployeeDto {
    employeeId: string;
    employeeName: string;
    /** Whether employee is explicitly assigned (true) or using default schedule (false) */
    isExplicitlyAssigned: boolean;
    /**
     * Date when current assignment/default usage started
     * @format date
     */
    effectiveFrom: string;
    /**
     * Date when assignment ends (null for current)
     * @format date
     */
    effectiveTo: string | null;
    /** List of disciplines for this employee */
    disciplines: string[];
    /** List of branches with roles for this employee */
    branches: EmployeeBranchDto[];
}

export interface CreatePayrollEmployeeAssignmentDto {
    employeeIds: string[];
    /**
     * Date when assignment becomes effective
     * @format date
     */
    effectiveFrom: string;
}

export interface PayrollEmployeeAssignmentDto {
    id: string;
    scheduleId: string;
    scheduleName: string;
    employeeId: string;
    employeeName: string;
    /** @format date */
    effectiveFrom: string;
    /** @format date */
    effectiveTo: string | null;
}

export interface PayrollAvailableEmployeeDto {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    /** List of disciplines for this employee */
    disciplines: string[];
    /** List of branches with roles for this employee */
    branches: EmployeeBranchDto[];
    /** Whether employee is currently assigned to a payroll schedule */
    isAssigned: boolean;
}

export interface SaveVisitFormSupplyDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    supplyId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "3" */
    quantity: string;
}

export interface SaveVisitFormWoundDto {
    id?: string;
    formId: string;
    admissionWoundId: string;
    visitDate?: string;
    treated?: string;
    status?: string;
    depth?: string;
    length?: string;
    width?: string;
    tunneling?: string;
    tunnelingLocation?: string;
    undermining?: string;
    pressureUlcerStage?: string;
    woundEdges?: string;
    woundPain?: string;
    surroundingSkin?: string;
    drainageAmount?: string;
    drainageType?: string;
    odor?: string;
    woundBedGranulationPercentage?: string | null;
    woundBedSloughPercentage?: string | null;
    woundBedEscharPercentage?: string | null;
    woundBedEpithelializationPercentage?: string | null;
    drainsPresent?: string;
    surroundingTissue?: string;
    woundClosure?: string;
    dressingRemovedByDisc?: string[];
    dressingRemovedByOther?: string;
    technique?: string[];
    cleansedWith?: string;
    irrigatedWith?: string;
    treatmentApplied?: string;
    packedWith?: string;
    coveredWith?: string;
    securedWith?: string;
    toleratedWell?: string;
    comments?: string;
    infectionReportedMD?: boolean;
    newTreatmentOrder?: boolean;
}

export interface SaveAdmissionWoundDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formId: string;
    location: string;
    type: string;
}

export interface SaveAdmissionVaccinationDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    visitId?: string;
    type: string;
    typeBrand?: string;
    typeBrandOther?: string;
    receivedDate: string;
    lotNumber: string;
    site: string;
    administeredBy: string;
}

export interface SaveMedicationTeachingDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    medicationId: string;
    visitId?: string | null;
    type: string;
    notes?: string | null;
    date: string;
}

export interface SaveInfectionMedicationDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    infectionId: string;
    medicationId: string;
}

export interface SaveAdmissionMedicationDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    infectionId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    orderId?: string;
    name: string;
    code: string;
    dose: string;
    doseUnit: string;
    frequencyA: string;
    frequencyB: string;
    frequencyC?: string;
    /** @format date-time */
    startDate?: string;
    /** @format date-time */
    stopDate?: string;
    route: string;
    administeredBy: string;
    prescribingPhysician?: string;
    instructions?: string;
    sideEffects?: string;
    contraindications?: string;
    prn?: boolean;
    highRisk?: boolean;
    specialInstructions?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    diagnosisId?: string;
    sourceId?: string;
    sourceName?: string;
    /** @format date-time */
    inactivatedAt?: string | null;
    teachings?: SaveMedicationTeachingDto[];
    infections?: SaveInfectionMedicationDto[];
}

export interface DrugDetailsDto {
    purpose: string;
    adverseEffects: string;
    contraindications: string | null;
}

export interface AssignOrderDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    orderId: string;
}

export interface AssignOrderResultDto {
    entityType: 'medication' | 'problem' | 'goal' | 'task';
    entityId: string;
    previousOrderId?: string | null;
    orderId: string;
    cascadedEntityIds: string[];
}

export interface SaveFormOrderDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    formId: string;
    /** @format date-time */
    orderDate: string;
    /** @format date-time */
    sentDateSecondAttempt?: string | null;
    /** @format date-time */
    sentDateThirdAttempt?: string | null;
    /** @format date-time */
    sentDate?: string | null;
    /** @format date-time */
    receivedDate?: string | null;
    /** @format date-time */
    signedDate?: string | null;
}

export interface FormOrderDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    formId: string;
    orderNumber: string;
    physician?: string;
    physicianFax?: string;
    status: 'DRAFT' | 'QA' | 'READY' | 'SENT' | 'SIGNED' | 'CANCELLED' | 'CHANGES_REQUESTED';
    file?: FileDto;
    branchId: string;
    admissionId: string;
    /** @format date-time */
    orderDate: string;
    /** @format date-time */
    sentDateSecondAttempt?: string;
    /** @format date-time */
    sentDateThirdAttempt?: string;
    /** @format date-time */
    sentDate?: string;
    receivedDate?: string;
    signedDate?: string;
    patient: string;
    branch: string;
    formType: string;
}

export interface PartialSaveTaskDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemGoalId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitFormId?: string;
    title?: string;
    /** @format date-time */
    startDate?: string;
    type?: string;
    description?: string;
    orderId?: string;
    note?: string;
}

export interface PartialSaveGoalDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemId?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitFormId?: string;
    title?: string;
    discipline?: string;
    /** @format date-time */
    startDate?: string;
    duration?: number;
    orderId?: string;
    period?: string;
    extendedDuration?: number;
    extendedPeriod?: string;
    description?: string;
    note?: string;
    tasks?: PartialSaveTaskDto[];
}

export interface SaveProblemDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    visitId: string;
    title: string;
    /**
     * @format date-time
     * @example "2024-01-01"
     */
    startDate: string;
    /** @format date-time */
    endDate?: string;
    type: string;
    description: string;
    note?: string;
    orderId?: string;
    goals?: PartialSaveGoalDto[];
}

export interface SaveGoalDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitFormId: string;
    title: string;
    discipline: string;
    /** @format date-time */
    startDate: string;
    duration: number;
    orderId?: string;
    period: string;
    extendedDuration: number;
    extendedPeriod?: string;
    description?: string;
    note?: string;
    tasks?: PartialSaveTaskDto[];
}

export interface SaveTaskDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemGoalId: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitFormId: string;
    title: string;
    /** @format date-time */
    startDate: string;
    type: string;
    description?: string;
    orderId?: string;
    note?: string;
}

export interface SaveTaskLogDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    problemGoalTaskId: string;
    performed: string;
    resolved: string;
    note?: string;
}

export interface GoalSelectionDto {
    /**
     * The goal template ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    goalId: string;
    /**
     * Array of task IDs to include from this goal
     * @example ["ebef12f0-0b8e-11ef-a972-b57fdf832e72","ebef12f0-0b8e-11ef-a972-b57fdf832e73"]
     */
    tasks: string[];
}

export interface TemplateSelectionDto {
    /**
     * The template problem ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    problemId: string;
    /** Array of goals with their selected tasks */
    goals: GoalSelectionDto[];
}

export interface BulkAddFromTemplatesDto {
    /**
     * The visit ID to associate with the created problems/goals/tasks
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    visitId: string;
    /** Optional physician order ID to associate with the created problems/goals/tasks */
    orderId?: string;
    /** Array of template selections with nested goals and tasks */
    selections: TemplateSelectionDto[];
}

export interface SaveAdmissionIncidentDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id: string;
    notifiedPhysicianId?: string | null;
    notifiedUserId?: string | null;
    name: string;
    subject: string;
    nature: string;
    /** @format date-time */
    dateOfIncident: string;
    /** @format date-time */
    dateResolved?: string | null;
    place?: string | null;
    severity?: string | null;
    /** @format date-time */
    datePhysicianNotified?: string | null;
    /** @format date-time */
    dateSupervisorNotified?: string | null;
    outcomeDetails?: string | null;
    describe?: string | null;
    outcome?: string | null;
    recommendations?: string | null;
}

export interface SaveAdmissionInfectionDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    id?: string;
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    visitId: string;
    name: string;
    mdNotified: string;
    acquired: string;
    type: string;
    details: string[];
    cultureSource?: string | null;
    treatment?: string | null;
    /** @format date-time */
    cultureDate?: string | null;
    risks?: string | null;
    narrative?: string | null;
    notes?: string | null;
    /** @format date-time */
    logDate: string;
    /** @format date-time */
    infectionDate: string;
    /** @format date-time */
    resolvedDate?: string | null;
}

export interface AddPhysicianToAdmissionDto {
    physicianId: string;
    roles: string[];
    primary: boolean;
    overseePlanOfCare: boolean;
}

export interface UpdatePatientPhysicianDto {
    roles?: string[];
    primary?: boolean;
    overseePlanOfCare?: boolean;
}

export interface AddressDetailsDto {
    address: string;
    city: string;
    state: string;
    zipcode: string;
}

export interface EditPhysicianAddressDto {
    id?: string;
    phone: string;
    fax?: string;
    type: string;
    address: AddressDetailsDto;
}

export interface EditPhysicianDetailsDto {
    firstName?: string;
    lastName?: string;
    credential?: string;
    email?: string;
    addresses?: EditPhysicianAddressDto[];
}

export interface FormCmsDto {
    id: string;
    formId: string;
    branch: string;
    patient: string;
    episode: string;
    visitDate: string;
    daysPassed: number;
    insurance?: string;
    form: string;
    status: 'READY' | 'SENT' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
    correctionNumber: number;
    /** @format date-time */
    updatedAt: string;
}

export interface UpdateFormCmsDto {
    /** @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72" */
    formIds: string[];
    /** @example "SENT" */
    newStatus: string;
}

export interface SaveTemplateDto {
    id?: string;
    templateType:
        | 'problem'
        | 'goal'
        | 'task'
        | 'summary'
        | 'medication-purpose'
        | 'medication-side-effect'
        | 'physician-order-subject'
        | 'physician-order-description';
    title: string;
    description: string;
    discipline?: 'SN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW' | 'OTH' | null;
    days?: number;
    frequency?: string | null;
    type?: string | null;
}

export interface TemplateDto {
    id: string;
    templateType:
        | 'problem'
        | 'goal'
        | 'task'
        | 'summary'
        | 'medication-purpose'
        | 'medication-side-effect'
        | 'physician-order-subject'
        | 'physician-order-description';
    title: string;
    description: string;
    discipline?: 'SN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW' | 'OTH' | null;
    days?: number;
    frequency?: string;
    type?: string;
    links: TemplateDto[];
}

export interface TemplateTasksDto {
    id: string;
    title: string;
    description?: string;
    type?: string;
}

export interface TemplateGoalsDto {
    id: string;
    title: string;
    description?: string;
    tasks?: TemplateTasksDto[];
}

export interface TemplateProblemSummaryDto {
    id: string;
    title: string;
    description?: string;
    type?: string;
    discipline?: string;
    goalCount: number;
    taskCount: number;
    goals?: TemplateGoalsDto[];
}

export interface TemplateProblemListResponseDto {
    items: TemplateProblemSummaryDto[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    /** Available problem types for filtering */
    availableTypes: string[];
    /** Available disciplines for filtering */
    availableDisciplines: string[];
}

export interface LinkDto {
    fromId: string;
    toId: string;
}

export interface F2FComplianceReportDto {
    patient: string;
    branch: string;
    socDate: string;
    validDateRange: string;
    status: 'Compliant' | 'Non-Compliant' | 'Pending';
    encounterDate: string;
    provider: string;
    encounterType: string;
}

export interface RecertificationDischargeNeededDto {
    branch: string;
    patientName: string;
    episodePeriod: string;
    socDate: string;
    employeeWithDiscipline: string;
    lastVisit: string;
    /** Number of days since last visit or "N/A" */
    daysSince: number | string;
}

export interface UnduplicatedAdmissionDto {
    patientName: string;
    socDate: string;
    status: string;
    primaryDx: string;
    patientAddress: string;
    phoneNo: string;
    socClinician: string;
    mdSigning485: string;
    branch: string;
    admissionNumber: string;
}

export interface PatientDischargeHistoryDto {
    patientName: string;
    branchName: string;
    admissionNumber: string;
    socDate: string;
    dischargeDate: string;
    insurance: string;
    dischargeEmployee: string;
    dischargeReason: string;
    lengthOfStay: number;
}

export interface EpisodeEndingReportDto {
    branch: string;
    episodePeriod: string;
    soc: string;
    patientName: string;
    signedUser: string;
    assignedUser: string;
    doctor: string;
    doctorPhone: string;
    /** @format date-time */
    startDate: string;
    /** @format date-time */
    endDate: string;
}

export interface PatientCaregiverReportDto {
    branch: string;
    patient: string;
    soc: string;
    physician: string;
    sn: string;
    pt: string;
    pta: string;
    msw: string;
    hha: string;
    ot: string;
    cota: string;
    st: string;
}

export interface SaveCustomReportDto {
    name: string;
    type: string;
    config: object;
}

export interface CustomReportDto {
    id: string;
    userId: string;
    name: string;
    type: string;
    config: object;
}

export interface UserReportDto {
    customReports: CustomReportDto[];
    favoriteReports: string[];
}

export interface SaveUserFavoriteDto {
    reportId: string;
}

export interface ReportConfigDto {
    branchId: string;
    period: string;
    from: string;
    to: string;
    admissionStatus?: string;
}

export interface SaveReportDto {
    id?: string;
    type: string;
    config: ReportConfigDto;
    /** @format date-time */
    approvedAt?: string;
}

export interface ConfigDto {
    period: string;
    branchId: string;
    from: string;
    to: string;
    admissionStatus?: string;
}

export interface ReportApproveDto {
    id: string;
    userId: string;
    reportId: string;
    user: string;
    report: string;
    /** @format date-time */
    signedAt: string;
}

export interface ReportDto {
    id: string;
    type: string;
    config: ConfigDto;
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
    approvals: ReportApproveDto[];
    /** @format date-time */
    approvedAt?: string | null;
    /** @format date-time */
    revokedAt?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
    data: object[];
}

export interface ReportConfigurationDto {
    id: string;
    fyStartMonth: string;
    fyStartDay: string;
    minimumApproval: string;
}

export interface SaveReportConfigDto {
    fyStartMonth: string;
    fyStartDay: string;
    minimumApproval: string;
}

export interface AutocompleteResultDto {
    description: string;
    placeId: string;
}

export interface PlaceDetailsDto {
    streetAddress: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface CreateCustomMedicationDto {
    /** @example "Aspirin" */
    name: string;
    /** @example "325" */
    dose: string;
    /** @example "mg" */
    doseUnit: string;
    /** @example "Oral" */
    route: string;
}

export interface CustomMedicationDto {
    /** @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890" */
    id: string;
    /** @example "Aspirin" */
    name: string;
    /** @example "325" */
    dose: string;
    /** @example "mg" */
    doseUnit: string;
    /** @example "Oral" */
    route: string;
    /** @example true */
    active: boolean;
}

export interface UpdateCustomMedicationDto {
    /** @example "Aspirin" */
    name?: string;
    /** @example "325" */
    dose?: string;
    /** @example "mg" */
    doseUnit?: string;
    /** @example "Oral" */
    route?: string;
    /** @example true */
    active?: boolean;
}

export interface PublicCreateEnquiryDto {
    email: string;
    agencyName: string;
    patientCensus?: string;
    website?: string;
    turnstileToken?: string;
}

export interface GetAuditLogsParams {
    /**
     * Organization ID or "management" for anonymous events
     * @example "org-uuid-123"
     */
    organizationId: string;
    /**
     * Start datetime in ISO format
     * @example "2026-01-08T00:00:00Z"
     */
    startDate?: string;
    /**
     * End datetime in ISO format
     * @example "2026-01-08T23:59:59Z"
     */
    endDate?: string;
    /**
     * Filter by event name (partial match)
     * @example "auth.login"
     */
    eventName?: string;
    /**
     * Filter by status
     * @default "ALL"
     */
    status?: 'ALL' | 'SUCCESS' | 'FAILURE' | 'PENDING';
    /**
     * Filter by event type
     * @default "ALL"
     */
    type?: 'ALL' | 'SERVER' | 'CLIENT';
    /**
     * Filter by user ID
     * @example "user-uuid-123"
     */
    userId?: string;
    /**
     * Filter by the tenant the audit event pertains to (read from `details.organizationId`). Useful for management-DB events like `admin.llm-config.*` that scope to a single org.
     * @example "org-uuid-456"
     */
    targetOrganizationId?: string;
    /** Sort by field */
    sortBy?: 'startedAt' | 'eventName' | 'status' | 'durationMs';
    /** Sort order */
    sortOrder?: 'asc' | 'desc';
    /**
     * Page number (1-based)
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of records per page
     * @default 50
     * @example 50
     */
    pageSize?: number;
}

export interface GetAuditStatsParams {
    /**
     * Organization ID or "management" for anonymous events
     * @example "org-uuid-123"
     */
    organizationId: string;
    /**
     * Start datetime in ISO format
     * @example "2026-01-08T00:00:00Z"
     */
    startDate?: string;
    /**
     * End datetime in ISO format
     * @example "2026-01-08T23:59:59Z"
     */
    endDate?: string;
    /**
     * Filter by event name (partial match)
     * @example "auth.login"
     */
    eventName?: string;
    /**
     * Filter by status
     * @default "ALL"
     */
    status?: 'ALL' | 'SUCCESS' | 'FAILURE' | 'PENDING';
    /**
     * Filter by event type
     * @default "ALL"
     */
    type?: 'ALL' | 'SERVER' | 'CLIENT';
    /**
     * Filter by user ID
     * @example "user-uuid-123"
     */
    userId?: string;
    /**
     * Filter by the tenant the audit event pertains to (read from `details.organizationId`). Useful for management-DB events like `admin.llm-config.*` that scope to a single org.
     * @example "org-uuid-456"
     */
    targetOrganizationId?: string;
    /** Sort by field */
    sortBy?: 'startedAt' | 'eventName' | 'status' | 'durationMs';
    /** Sort order */
    sortOrder?: 'asc' | 'desc';
    /**
     * Page number (1-based)
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of records per page
     * @default 50
     * @example 50
     */
    pageSize?: number;
}

export interface SearchUsersParams {
    /**
     * Organization ID to search users in
     * @example "org-uuid-123"
     */
    organizationId: string;
    /**
     * Search term to filter users by name or email
     * @example "john"
     */
    query?: string;
}

export interface GetUsageHistoryParams {
    /** Inclusive start date in YYYY-MM-DD format (UTC) */
    startDate: string;
    /** Exclusive end date in YYYY-MM-DD format (UTC) */
    endDate: string;
    /** Filter to a specific feature type */
    featureType?: string;
    /** @default "DAY" */
    granularity?: 'DAY' | 'WEEK' | 'MONTH';
    orgId: string;
}

export interface ListRecentCallsParams {
    /** Filter by featureType */
    featureType?: string;
    /** Max rows to return; defaults to 50, capped at 200 */
    limit?: number;
    /**
     * "recent" orders by createdAt DESC; "cost-desc" surfaces the most expensive calls first
     * @default "recent"
     */
    sortBy?: 'recent' | 'cost-desc';
    orgId: string;
}

export interface GetParams1 {
    discipline?: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW';
    branchId: string;
}

export interface SearchDiagnosesParams {
    term: string;
}

export interface SearchMedicationsParams {
    term: string;
}

export interface GetForBranchParams {
    /**
     * Page number (1-indexed)
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of records per page
     * @default 50
     * @example 50
     */
    pageSize?: number;
    /**
     * Field to sort by
     * @example "name"
     */
    sortField?: string;
    /**
     * Sort direction
     * @example "asc"
     */
    sortDirection?: 'asc' | 'desc';
    /**
     * Filter by patient name (partial match)
     * @example "Smith"
     */
    name?: string;
    /**
     * Filter by patient statuses. If not provided, returns all statuses.
     * @example ["INTAKE","PENDING","ADMITTED"]
     */
    statuses?: string[];
    branchId: string;
    /**
     * Filter by date of birth (MM/DD/YYYY format)
     * @example "01/01/1982"
     */
    dob?: string;
    /**
     * Filter by episode number
     * @example 1
     */
    episodeNumber?: number;
    /**
     * Filter by admission number
     * @example 1
     */
    admissionNumber?: number;
    /**
     * Filter by start of care date (YYYY-MM-DD or AG Grid date string)
     * @example "2025-01-20"
     */
    socDate?: string;
    /**
     * AG Grid date filter type for socDate
     * @example "equals"
     */
    socDateType?: 'equals' | 'greaterThan' | 'lessThan' | 'inRange';
    /**
     * Upper bound for socDate inRange filter (YYYY-MM-DD or AG Grid date string)
     * @example "2025-12-31"
     */
    socDateTo?: string;
}

export interface GetParams3 {
    /**
     * Page number (1-indexed)
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of records per page
     * @default 50
     * @example 50
     */
    pageSize?: number;
    /**
     * Field to sort by
     * @example "name"
     */
    sortField?: string;
    /**
     * Sort direction
     * @example "asc"
     */
    sortDirection?: 'asc' | 'desc';
    /**
     * Filter by patient name (partial match)
     * @example "Smith"
     */
    name?: string;
    /**
     * Filter by patient statuses. If not provided, returns all statuses.
     * @example ["INTAKE","PENDING","ADMITTED"]
     */
    statuses?: string[];
    /**
     * Filter by specific branch ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    branchId?: string;
    /**
     * Filter by date of birth (MM/DD/YYYY format)
     * @example "01/01/1982"
     */
    dob?: string;
    /**
     * Filter by episode number
     * @example 1
     */
    episodeNumber?: number;
    /**
     * Filter by admission number
     * @example 1
     */
    admissionNumber?: number;
    /**
     * Filter by start of care date (YYYY-MM-DD or AG Grid date string)
     * @example "2025-01-20"
     */
    socDate?: string;
    /**
     * AG Grid date filter type for socDate
     * @example "equals"
     */
    socDateType?: 'equals' | 'greaterThan' | 'lessThan' | 'inRange';
    /**
     * Upper bound for socDate inRange filter (YYYY-MM-DD or AG Grid date string)
     * @example "2025-12-31"
     */
    socDateTo?: string;
}

export interface AddInsuranceParams {
    intermediary: 'stedi' | 'availity';
    branchId: string;
    admissionId: string;
}

export interface GetNewConfigFormDataParams {
    insuranceId?: string;
}

export interface ListParams2 {
    includeRevoked?: boolean;
    branchId: string;
    admissionId: string;
}

export interface DeleteParams1 {
    force?: boolean;
    branchId: string;
    admissionId: string;
    insuranceId: string;
    authId: string;
}

export interface SaveParams {
    submit: boolean;
    branchId: string;
    admissionId: string;
}

export interface GenerateClaimPdfParams {
    kind: 'ub04' | 'generic-invoice' | 'cms-1500';
    branchId: string;
    admissionId: string;
    id: string;
}

export interface GetHippsAuditDetailsParams {
    /** @example 2026 */
    year?: number;
    branchId: string;
    admissionId: string;
    visitId: string;
}

export interface UploadParams {
    orderId?: string;
    admissionId: string;
    branchId: string;
}

export interface InsuranceSearchParams {
    search: string;
    intermediary: 'stedi' | 'availity';
}

export interface ListParams5 {
    /**
     * Page number (1-indexed)
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of records per page
     * @default 50
     * @example 50
     */
    pageSize?: number;
    /**
     * Field to sort by
     * @example "visitDate"
     */
    sortField?: string;
    /**
     * Sort direction
     * @example "desc"
     */
    sortDirection?: 'asc' | 'desc';
    /**
     * Filter by QA statuses. If not provided, returns all statuses (SUBMITTED, REJECTED, APPROVED).
     * @example ["SUBMITTED","REJECTED","APPROVED"]
     */
    statuses?: string[];
    /**
     * Filter by patient name (partial match)
     * @example "Smith"
     */
    patientName?: string;
    /**
     * Filter by form name (partial match)
     * @example "OASIS"
     */
    formName?: string;
    /**
     * Filter by visit date from (YYYY-MM-DD format)
     * @example "2025-01-01"
     */
    visitDateFrom?: string;
    /**
     * Filter by visit date to (YYYY-MM-DD format)
     * @example "2025-12-31"
     */
    visitDateTo?: string;
    /**
     * Filter by branch ID
     * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
     */
    branchId?: string;
}

export interface GetCensusOverviewParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /** Number of days to include in the time period */
    days?: 7 | 30;
}

export interface GetDailyAverageCensusParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /** Number of days to include in the time period */
    days?: 7 | 30;
}

export interface GetCbsaReportParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Start date in YYYY-MM-DD format
     * @example "2024-01-01"
     */
    startDate: string;
    /**
     * End date in YYYY-MM-DD format
     * @example "2024-12-31"
     */
    endDate: string;
}

export interface GetAssessmentsStatusParams {
    /** View type - overdue or upcoming assessments */
    view: 'overdue' | 'upcoming';
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Array of clinician IDs to filter by (comma-separated)
     * @example "uuid1,uuid2"
     */
    clinicianIds?: string[];
    /** Assessment status filter */
    status?: 'incomplete' | 'submitted' | 'rejected';
    /**
     * Form ID to filter by specific form type
     * @example "uuid-string-here"
     */
    formId?: string;
    /**
     * Page number (1-based)
     * @min 1
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of items per page (1-100)
     * @min 1
     * @max 100
     * @default 25
     * @example 25
     */
    pageSize?: number;
}

export interface GetCliniciansParams {
    /**
     * Branch ID to filter clinicians for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Number of days to include in the time period (7 or 30)
     * @default 30
     * @example 30
     */
    days?: 7 | 30;
}

export interface GetAssessmentFormsParams {
    /** View type to filter forms for */
    view?: 'overdue' | 'upcoming' | 'all';
    /**
     * Branch ID to filter forms for
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Comma-separated clinician IDs to filter by
     * @example "uuid1,uuid2"
     */
    clinicianIds?: string[];
    /** Status filter */
    status?: 'incomplete' | 'submitted' | 'rejected';
}

export interface GetEpisodeManagementParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /** Number of days to look ahead */
    days?: 7 | 30;
    /**
     * Page number (1-based)
     * @min 1
     * @example 1
     */
    page?: number;
    /**
     * Number of items per page (1-100)
     * @min 1
     * @max 100
     * @example 25
     */
    pageSize?: number;
    /**
     * Filter by specific event type. If not provided, returns all types
     * @example "RECERTIFICATION"
     */
    eventType?: 'RECERTIFICATION' | 'DISCHARGE' | 'EPISODE_ENDING';
}

export interface GetTransfersParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Page number (1-based)
     * @min 1
     * @example 1
     */
    page?: number;
    /**
     * Number of items per page (1-100)
     * @min 1
     * @max 100
     * @example 25
     */
    pageSize?: number;
}

export interface GetAuthorizationExpirationsParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Filter type - ALL (overdue + upcoming), OVERDUE (within warning days), UPCOMING (will be overdue in 7 days), DISMISSED (dismissed warnings), REQUESTED (insurance requested)
     * @default "ALL"
     */
    filter?: 'ALL' | 'OVERDUE' | 'UPCOMING' | 'DISMISSED' | 'REQUESTED';
    /**
     * Page number (1-based)
     * @min 1
     * @default 1
     * @example 1
     */
    page?: number;
    /**
     * Number of items per page (1-100)
     * @min 1
     * @max 100
     * @default 25
     * @example 25
     */
    pageSize?: number;
    /** Filter by expiration state */
    state?: 'EXPIRED_NO_REAUTH' | 'EXPIRED_GAP' | 'EXPIRING_SOON_NO_REAUTH' | 'EXPIRING_SOON_REAUTH_EXISTS';
}

export interface ExportAuthorizationExpirationsExcelParams {
    /**
     * Branch ID to filter data for, or "all" for all accessible branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /** Filter type to export */
    filter?: 'ALL' | 'OVERDUE' | 'UPCOMING' | 'DISMISSED' | 'REQUESTED';
    /**
     * @min 1
     * @default 1
     */
    page?: number;
    /**
     * @min 1
     * @max 100
     * @default 25
     */
    pageSize?: number;
}

export interface GetDashboardParams {
    /**
     * Branch ID to filter data for, or "all" for all branches
     * @example "uuid-string-here"
     */
    branchId?: string;
}

export interface GetTodayVisitsParams {
    /**
     * Branch ID to filter, or "all" / omit for all accessible branches
     * @example "uuid-here"
     */
    branchId?: string;
    /**
     * Start of "today" range in UTC (inclusive)
     * @example "2026-03-16T05:00:00.000Z"
     */
    startUtc: string;
    /**
     * End of "today" range in UTC (exclusive)
     * @example "2026-03-17T04:00:00.000Z"
     */
    endUtc: string;
    /**
     * Page number (1-based)
     * @min 1
     * @default 1
     */
    page?: number;
    /**
     * Number of items per page
     * @min 1
     * @max 100
     * @default 10
     */
    pageSize?: number;
}

export interface GetOutstandingVisitsParams {
    /**
     * Branch ID to filter, or "all" / omit for all accessible branches
     * @example "uuid-here"
     */
    branchId?: string;
    /**
     * Start of clinician-local 'today' in UTC (inclusive). Visits with start < startUtc are considered outstanding.
     * @example "2026-03-16T05:00:00.000Z"
     */
    startUtc: string;
    /**
     * Page number (1-based)
     * @min 1
     * @default 1
     */
    page?: number;
    /**
     * Number of items per page
     * @min 1
     * @max 100
     * @default 10
     */
    pageSize?: number;
}

export interface GetRecentlySubmittedVisitsParams {
    /**
     * Branch ID to filter, or "all" / omit for all accessible branches
     * @example "uuid-here"
     */
    branchId?: string;
    /**
     * UTC lower-bound (inclusive) for MAX(submittedDate) per visit. Client computes this from the selected recency window in the user's local timezone.
     * @example "2026-03-17T07:00:00.000Z"
     */
    dateFrom: string;
    /**
     * Page number (1-based)
     * @min 1
     * @default 1
     */
    page?: number;
    /**
     * Number of items per page
     * @min 1
     * @max 100
     * @default 10
     */
    pageSize?: number;
}

export type MatchProtocolsError = CareProtocolMatchResponseDto;

export interface BulkAddFromProtocolsParams {
    orderId?: string;
    branchId: string;
    admissionId: string;
}

export type BulkAddFromProtocolsError = AdmissionPlanOfCareDto[];

export interface GetDashboardParams2 {
    /**
     * Branch ID to filter, or omit for all branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Range mode: WEEK (Mon–Sun) or ROLLING_7 (today + 6 days)
     * @default "WEEK"
     */
    rangeMode?: 'WEEK' | 'ROLLING_7';
    /**
     * Anchor date in YYYY-MM-DD format
     * @example "2026-02-16"
     */
    anchorDate?: string;
    /**
     * Metric type: visits or units
     * @default "visits"
     */
    metric?: 'visits' | 'units';
    /**
     * Comma-separated discipline codes to filter by (e.g. "SN,RN")
     * @example "SN,RN"
     */
    discipline?: string;
}

export interface GetNurseVisitsParams {
    /**
     * Branch ID to filter, or omit for all branches
     * @example "uuid-string-here"
     */
    branchId?: string;
    /**
     * Range mode: WEEK (Mon–Sun) or ROLLING_7 (today + 6 days)
     * @default "WEEK"
     */
    rangeMode?: 'WEEK' | 'ROLLING_7';
    /**
     * Anchor date in YYYY-MM-DD format
     * @example "2026-02-16"
     */
    anchorDate?: string;
    /**
     * Metric type: visits or units
     * @default "visits"
     */
    metric?: 'visits' | 'units';
    /**
     * Comma-separated discipline codes to filter by (e.g. "SN,RN")
     * @example "SN,RN"
     */
    discipline?: string;
    userId: string;
}

export interface GetAlertsParams {
    alertType?: 'all' | 'missing' | 'expired' | 'expiring' | 'rejected';
    page?: string;
    limit?: string;
}

export interface GetStaffDirectoryParams {
    status?: 'compliant' | 'non-compliant';
    search?: string;
    page?: string;
    limit?: string;
    sortField?: string;
    sortDirection?: 'asc' | 'desc';
}

export interface GetAuditLogParams {
    staffId: string;
    documentTypeId: string;
    action: string;
    actorId: string;
    dateFrom: string;
    dateTo: string;
    page: string;
    limit: string;
}

export interface ListDocumentTypesParams {
    status: string;
}

export interface GetDocumentsParams {
    documentTypeId: string;
    status: string;
    isCustom: string;
    staffId: string;
}

export interface GetQuotaStatusParams {
    formId: string;
    branchId: string;
    admissionId: string;
}

export interface FindActiveParams {
    formId: string;
    branchId: string;
    admissionId: string;
}

export interface PhysicianSearchParams {
    npiNumber?: string;
    firstName?: string;
    lastName?: string;
    state?: string;
    city?: string;
    specialty?: string;
    limit?: number;
    page?: number;
}

export interface ListParams10 {
    /**
     * Period start date
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * Period end date (inclusive)
     * @format date
     * @example "2025-09-12"
     */
    to: string;
}

export interface ExportExcelParams {
    /**
     * Start date of the payroll period
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * End date of the payroll period
     * @format date
     * @example "2025-09-12"
     */
    to: string;
}

export interface ListEmployeeVisitsParams {
    /** @format date */
    from: string;
    /** @format date */
    to: string;
    employeeId: string;
}

export interface ListSchedulesParams {
    /** Filter by active status. Omit to return all schedules. */
    isActive?: boolean;
}

export interface GetSchedulePayrollParams {
    /**
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * @format date
     * @example "2025-09-12"
     */
    to: string;
    scheduleId: string;
}

export interface ExportSchedulePayrollExcelParams {
    /**
     * Start date of the payroll period
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * End date of the payroll period
     * @format date
     * @example "2025-09-12"
     */
    to: string;
    scheduleId: string;
}

export interface GetScheduleEmployeeVisitsParams {
    from: string;
    to: string;
    scheduleId: string;
    employeeId: string;
}

export interface DeleteParams6 {
    visitId: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface GenerateWoundsPdfParams {
    /** @example "wounds" */
    type: 'wounds';
    /** @example "unresolved" */
    mode: 'all' | 'unresolved' | 'resolved';
    branchId: string;
    episodeId: string;
    admissionId: string;
}

export interface DeleteParams8 {
    visitId: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface DeleteParams10 {
    visitId: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface InactivateParams {
    orderId?: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface ActivateParams {
    orderId?: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface GeneratePdfParams {
    /** @example "medications" */
    type: 'medications' | 'medications-details' | 'drug-to-drug' | 'drug-to-drug-summary';
    /** @example "active" */
    mode: 'all' | 'active' | 'inactive';
    date?: string | null;
    branchId: string;
    episodeId: string;
    admissionId: string;
}

export interface ListParams14 {
    visitId: string;
    branchId: string;
    admissionId: string;
}

export interface DeleteParams12 {
    visitId: string;
    orderId?: string;
    branchId: string;
    admissionId: string;
    id: string;
    type: string;
}

export interface BulkAddFromTemplatesParams {
    orderId?: string;
    branchId: string;
    admissionId: string;
}

export interface DeleteParams15 {
    visitId: string;
    id: string;
    branchId: string;
    admissionId: string;
}

export interface FindAllParams6 {
    /** Filter by template type (goal, task, problem, etc.) */
    templateType?: string;
    /** Filter by discipline (SN, PT, OT, ST) */
    discipline?: string;
    /** Filter to templates linked from a specific problem template (by template ID) */
    problemTemplateId?: string;
    /** Goal title used with problemTemplateId to find tasks linked to a matching goal template */
    goalTitle?: string;
}

export type FindAllError = TemplateDto[];

export interface GetTemplateProblemListParams {
    /** Search query to filter by title or description */
    search?: string;
    /** Filter by problem type */
    type?: string;
    /** Filter by discipline (SN, PT, OT, ST) */
    discipline?: string;
    /**
     * Page number (1-indexed)
     * @default 1
     */
    page?: number;
    /**
     * Number of items per page
     * @default 20
     */
    limit?: number;
}

export type GetTemplateProblemListError = TemplateProblemListResponseDto;

export interface ExportExcelParams2 {
    /** @example "infections" */
    type: string;
    /** @example "b3df1346-6c46-4161-a50f-4b3bc9805617" */
    branchId: string;
    /**
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * @format date
     * @example "2025-09-12"
     */
    to: string;
    admissionStatus?: string;
    id?: string;
}

export interface FindAllParams8 {
    /** @example "infections" */
    type: string;
    /** @example "b3df1346-6c46-4161-a50f-4b3bc9805617" */
    branchId: string;
    /**
     * @format date
     * @example "2025-08-30"
     */
    from: string;
    /**
     * @format date
     * @example "2025-09-12"
     */
    to: string;
    /** @example "ADMITTED" */
    admissionStatus?: string | null;
}

export interface AutocompleteParams {
    input: string;
}

export namespace Organization {
    /**
     * No description
     * @tags Organization
     * @name Create
     * @request POST:/api/v1/organization
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateOrganizationDto;
        export type RequestHeaders = {};
        export type ResponseBody = JobDto;
    }

    /**
     * No description
     * @tags Organization
     * @name Get
     * @request GET:/api/v1/organization
     */
    export namespace Get {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = OrganizationListItemDto[];
    }

    /**
     * No description
     * @tags Organization
     * @name GetOne
     * @request GET:/api/v1/organization/{id}
     */
    export namespace GetOne {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = OrganizationDto;
    }

    /**
     * No description
     * @tags Organization
     * @name Deactivate
     * @request PATCH:/api/v1/organization/{id}/deactivate
     */
    export namespace Deactivate {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = DeactivateOrganizationDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Organization
     * @name Reactivate
     * @request PATCH:/api/v1/organization/{id}/reactivate
     */
    export namespace Reactivate {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Jobs {
    /**
     * No description
     * @tags Jobs
     * @name GetStatus
     * @request GET:/api/v1/jobs/{jobId}/status
     */
    export namespace GetStatus {
        export type RequestParams = {
            jobId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = JobStatusDto;
    }
}

export namespace AdminFeatureFlags {
    /**
     * @description Returns all feature flags from enums with their current states and organization-specific overrides. Includes flags that don't yet exist in the database.
     * @tags Admin Feature Flags
     * @name ListAll
     * @summary List all feature flags with organization states
     * @request GET:/api/admin/feature-flag
     */
    export namespace ListAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FeatureFlagListResponseDto;
    }

    /**
     * @description Updates the global status of a feature flag. Creates the flag record if it doesn't exist in the database yet.
     * @tags Admin Feature Flags
     * @name SetGlobal
     * @summary Update global feature flag status
     * @request PUT:/api/admin/feature-flag/{key}
     */
    export namespace SetGlobal {
        export type RequestParams = {
            /** Feature flag key from enum */
            key:
                | 'example-feature-flag'
                | 'report-feature-flag'
                | 'dashboard'
                | 'insurance-authorizations'
                | 'grouper-0120206'
                | 'scheduling-dashboard'
                | 'clinical-dashboard'
                | 'intake-dashboard';
        };
        export type RequestQuery = {};
        export type RequestBody = SetGlobalStatusDto;
        export type RequestHeaders = {};
        export type ResponseBody = FeatureFlagListItemDto;
    }

    /**
     * @description Updates the state for a specific organization. Only works with organization-scoped flags. Creates the flag record if it doesn't exist.
     * @tags Admin Feature Flags
     * @name SetOrg
     * @summary Update organization-specific feature flag state
     * @request PUT:/api/admin/feature-flag/{key}/organization/{orgId}
     */
    export namespace SetOrg {
        export type RequestParams = {
            /** Organization feature flag key from enum */
            key:
                | 'example-feature-flag'
                | 'report-feature-flag'
                | 'dashboard'
                | 'insurance-authorizations'
                | 'grouper-0120206'
                | 'scheduling-dashboard'
                | 'clinical-dashboard'
                | 'intake-dashboard';
            /**
             * Organization ID
             * @format uuid
             * @example "550e8400-e29b-41d4-a716-446655440000"
             */
            orgId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SetOrgStateDto;
        export type RequestHeaders = {};
        export type ResponseBody = {
            /** @format uuid */
            organizationId?: string;
            state?: 'enabled' | 'disabled' | 'inherit';
        };
    }
}

export namespace AdminAuditLogs {
    /**
     * @description Retrieves audit logs with pagination and filtering. Can query both organization-specific logs and anonymous events (using "management" as organizationId). Supports filtering by date range, event name, status, and user ID.
     * @tags Admin Audit Logs
     * @name GetAuditLogs
     * @summary Get paginated audit logs
     * @request GET:/api/admin/audit
     */
    export namespace GetAuditLogs {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Organization ID or "management" for anonymous events
             * @example "org-uuid-123"
             */
            organizationId: string;
            /**
             * Start datetime in ISO format
             * @example "2026-01-08T00:00:00Z"
             */
            startDate?: string;
            /**
             * End datetime in ISO format
             * @example "2026-01-08T23:59:59Z"
             */
            endDate?: string;
            /**
             * Filter by event name (partial match)
             * @example "auth.login"
             */
            eventName?: string;
            /**
             * Filter by status
             * @default "ALL"
             */
            status?: 'ALL' | 'SUCCESS' | 'FAILURE' | 'PENDING';
            /**
             * Filter by event type
             * @default "ALL"
             */
            type?: 'ALL' | 'SERVER' | 'CLIENT';
            /**
             * Filter by user ID
             * @example "user-uuid-123"
             */
            userId?: string;
            /**
             * Filter by the tenant the audit event pertains to (read from `details.organizationId`). Useful for management-DB events like `admin.llm-config.*` that scope to a single org.
             * @example "org-uuid-456"
             */
            targetOrganizationId?: string;
            /** Sort by field */
            sortBy?: 'startedAt' | 'eventName' | 'status' | 'durationMs';
            /** Sort order */
            sortOrder?: 'asc' | 'desc';
            /**
             * Page number (1-based)
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of records per page
             * @default 50
             * @example 50
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuditLogResponseDto;
    }

    /**
     * @description Retrieves aggregated statistics for audit logs including: total event count, status breakdown, top event types, and time series data. Respects the same filters as the main audit log endpoint.
     * @tags Admin Audit Logs
     * @name GetAuditStats
     * @summary Get audit log statistics
     * @request GET:/api/admin/audit/stats
     */
    export namespace GetAuditStats {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Organization ID or "management" for anonymous events
             * @example "org-uuid-123"
             */
            organizationId: string;
            /**
             * Start datetime in ISO format
             * @example "2026-01-08T00:00:00Z"
             */
            startDate?: string;
            /**
             * End datetime in ISO format
             * @example "2026-01-08T23:59:59Z"
             */
            endDate?: string;
            /**
             * Filter by event name (partial match)
             * @example "auth.login"
             */
            eventName?: string;
            /**
             * Filter by status
             * @default "ALL"
             */
            status?: 'ALL' | 'SUCCESS' | 'FAILURE' | 'PENDING';
            /**
             * Filter by event type
             * @default "ALL"
             */
            type?: 'ALL' | 'SERVER' | 'CLIENT';
            /**
             * Filter by user ID
             * @example "user-uuid-123"
             */
            userId?: string;
            /**
             * Filter by the tenant the audit event pertains to (read from `details.organizationId`). Useful for management-DB events like `admin.llm-config.*` that scope to a single org.
             * @example "org-uuid-456"
             */
            targetOrganizationId?: string;
            /** Sort by field */
            sortBy?: 'startedAt' | 'eventName' | 'status' | 'durationMs';
            /** Sort order */
            sortOrder?: 'asc' | 'desc';
            /**
             * Page number (1-based)
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of records per page
             * @default 50
             * @example 50
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuditStatsDto;
    }

    /**
     * @description Search users by first name, last name, or email within an organization for audit log filtering
     * @tags Admin Audit Logs
     * @name SearchUsers
     * @summary Search users for filtering
     * @request GET:/api/admin/audit/users/search
     */
    export namespace SearchUsers {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Organization ID to search users in
             * @example "org-uuid-123"
             */
            organizationId: string;
            /**
             * Search term to filter users by name or email
             * @example "john"
             */
            query?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserSearchResultDto[];
    }
}

export namespace Enquiry {
    /**
     * No description
     * @tags Enquiry
     * @name List
     * @request GET:/api/v1/admin/enquiry
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = EnquiryDto[];
    }

    /**
     * No description
     * @tags Enquiry
     * @name Create
     * @request POST:/api/v1/enquiry
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = PublicCreateEnquiryDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdminLlmConfig {
    /**
     * No description
     * @tags Admin LLM Config
     * @name ListFeatureRegistry
     * @summary List feature types registered by the backend
     * @request GET:/api/v1/admin/llm-config/features
     */
    export namespace ListFeatureRegistry {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FeatureRegistryEntryDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name ListOrgStatuses
     * @summary Per-org rollup health for the org list page
     * @request GET:/api/v1/admin/llm-config/org-statuses
     */
    export namespace ListOrgStatuses {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = OrgFeatureHealthDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name ListPricing
     * @summary List LLM model pricing rows (current + history)
     * @request GET:/api/v1/admin/llm-config/pricing
     */
    export namespace ListPricing {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PricingEntryDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name ListConfigs
     * @summary List feature configs for an org
     * @request GET:/api/v1/admin/llm-config/{orgId}
     */
    export namespace ListConfigs {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LlmFeatureConfigDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name UpsertConfig
     * @summary Create or update a feature config
     * @request PUT:/api/v1/admin/llm-config/{orgId}/{featureType}
     */
    export namespace UpsertConfig {
        export type RequestParams = {
            orgId: string;
            featureType: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpsertLlmConfigBodyDto;
        export type RequestHeaders = {};
        export type ResponseBody = LlmFeatureConfigDto;
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name DeleteConfig
     * @summary Delete a feature config (disables feature for org)
     * @request DELETE:/api/v1/admin/llm-config/{orgId}/{featureType}
     */
    export namespace DeleteConfig {
        export type RequestParams = {
            orgId: string;
            featureType: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name GetUsageSummary
     * @summary Get current usage bucket summary
     * @request GET:/api/v1/admin/llm-config/{orgId}/usage
     */
    export namespace GetUsageSummary {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UsageSummaryDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name GetUsageHistory
     * @summary Get historical usage aggregated by date range and granularity
     * @request GET:/api/v1/admin/llm-config/{orgId}/usage/history
     */
    export namespace GetUsageHistory {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {
            /** Inclusive start date in YYYY-MM-DD format (UTC) */
            startDate: string;
            /** Exclusive end date in YYYY-MM-DD format (UTC) */
            endDate: string;
            /** Filter to a specific feature type */
            featureType?: string;
            /** @default "DAY" */
            granularity?: 'DAY' | 'WEEK' | 'MONTH';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UsageHistoryPointDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name ListRecentCalls
     * @summary List recent LLM calls for an org, optionally filtered by featureType
     * @request GET:/api/v1/admin/llm-config/{orgId}/calls
     */
    export namespace ListRecentCalls {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {
            /** Filter by featureType */
            featureType?: string;
            /** Max rows to return; defaults to 50, capped at 200 */
            limit?: number;
            /**
             * "recent" orders by createdAt DESC; "cost-desc" surfaces the most expensive calls first
             * @default "recent"
             */
            sortBy?: 'recent' | 'cost-desc';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LlmCallSummaryDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name ListSublimits
     * @summary List sub-limit configs for an org
     * @request GET:/api/v1/admin/llm-config/{orgId}/sublimits
     */
    export namespace ListSublimits {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LlmSublimitConfigDto[];
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name UpsertSublimit
     * @summary Upsert a sub-limit config row keyed by (org, feature, attributeKey)
     * @request PUT:/api/v1/admin/llm-config/{orgId}/{featureType}/sublimit/{attributeKey}
     */
    export namespace UpsertSublimit {
        export type RequestParams = {
            orgId: string;
            featureType: string;
            attributeKey: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpsertSublimitBodyDto;
        export type RequestHeaders = {};
        export type ResponseBody = LlmSublimitConfigDto;
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name DeleteSublimit
     * @summary Delete a sub-limit config row (cap stops applying immediately)
     * @request DELETE:/api/v1/admin/llm-config/{orgId}/{featureType}/sublimit/{attributeKey}
     */
    export namespace DeleteSublimit {
        export type RequestParams = {
            orgId: string;
            featureType: string;
            attributeKey: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admin LLM Config
     * @name GetSublimitUsage
     * @summary Top-N attribute consumers per (feature, attributeKey) for an org
     * @request GET:/api/v1/admin/llm-config/{orgId}/sublimit-usage
     */
    export namespace GetSublimitUsage {
        export type RequestParams = {
            orgId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SublimitUsageDto[];
    }
}

export namespace Staff {
    /**
     * No description
     * @tags staff
     * @name FindOne
     * @request GET:/api/v1/staff/{staffId}
     */
    export namespace FindOne {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = StaffDto;
    }

    /**
     * No description
     * @tags staff
     * @name Get
     * @request GET:/api/v1/branch/{branchId}/staff
     */
    export namespace Get {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {
            discipline?: 'SN' | 'RN' | 'LPN' | 'LVN' | 'CNA' | 'HHA' | 'CHHA' | 'PT' | 'PTA' | 'OT' | 'OTA' | 'ST' | 'MSW';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = StaffDto[];
    }
}

export namespace ReferenceData {
    /**
     * No description
     * @tags ReferenceData
     * @name GetDemographicData
     * @request GET:/api/v1/reference-data/demographic
     */
    export namespace GetDemographicData {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = DemographicDataDto;
    }

    /**
     * No description
     * @tags ReferenceData
     * @name SearchDiagnoses
     * @request GET:/api/v1/reference-data/diagnoses
     */
    export namespace SearchDiagnoses {
        export type RequestParams = {};
        export type RequestQuery = {
            term: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SearchDiagnosisDataDto[];
    }

    /**
     * No description
     * @tags ReferenceData
     * @name SearchMedications
     * @request GET:/api/v1/reference-data/medications
     */
    export namespace SearchMedications {
        export type RequestParams = {};
        export type RequestQuery = {
            term: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SearchMedicationResponseDto[];
    }

    /**
     * No description
     * @tags ReferenceData
     * @name GetSupplyData
     * @request GET:/api/v1/reference-data/supplies
     */
    export namespace GetSupplyData {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SupplyDto[];
    }
}

export namespace Patient {
    /**
     * No description
     * @tags patient
     * @name Create
     * @request POST:/api/v1/branch/{branchId}/patient
     */
    export namespace Create {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreatePatientDto | ExistingPatientDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDto;
    }

    /**
     * No description
     * @tags patient
     * @name GetForBranch
     * @request GET:/api/v1/branch/{branchId}/patient
     */
    export namespace GetForBranch {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {
            /**
             * Page number (1-indexed)
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of records per page
             * @default 50
             * @example 50
             */
            pageSize?: number;
            /**
             * Field to sort by
             * @example "name"
             */
            sortField?: string;
            /**
             * Sort direction
             * @example "asc"
             */
            sortDirection?: 'asc' | 'desc';
            /**
             * Filter by patient name (partial match)
             * @example "Smith"
             */
            name?: string;
            /**
             * Filter by patient statuses. If not provided, returns all statuses.
             * @example ["INTAKE","PENDING","ADMITTED"]
             */
            statuses?: string[];
            /**
             * Filter by specific branch ID
             * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
             */
            branchId?: string;
            /**
             * Filter by date of birth (MM/DD/YYYY format)
             * @example "01/01/1982"
             */
            dob?: string;
            /**
             * Filter by episode number
             * @example 1
             */
            episodeNumber?: number;
            /**
             * Filter by admission number
             * @example 1
             */
            admissionNumber?: number;
            /**
             * Filter by start of care date (YYYY-MM-DD or AG Grid date string)
             * @example "2025-01-20"
             */
            socDate?: string;
            /**
             * AG Grid date filter type for socDate
             * @example "equals"
             */
            socDateType?: 'equals' | 'greaterThan' | 'lessThan' | 'inRange';
            /**
             * Upper bound for socDate inRange filter (YYYY-MM-DD or AG Grid date string)
             * @example "2025-12-31"
             */
            socDateTo?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PatientListResponseDto;
    }

    /**
     * No description
     * @tags patient
     * @name Update
     * @request PUT:/api/v1/branch/{branchId}/patient/{patientId}
     */
    export namespace Update {
        export type RequestParams = {
            patientId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdatePatientDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionPatientDto;
    }

    /**
     * No description
     * @tags patient
     * @name Get
     * @request GET:/api/v1/patient
     */
    export namespace Get {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Page number (1-indexed)
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of records per page
             * @default 50
             * @example 50
             */
            pageSize?: number;
            /**
             * Field to sort by
             * @example "name"
             */
            sortField?: string;
            /**
             * Sort direction
             * @example "asc"
             */
            sortDirection?: 'asc' | 'desc';
            /**
             * Filter by patient name (partial match)
             * @example "Smith"
             */
            name?: string;
            /**
             * Filter by patient statuses. If not provided, returns all statuses.
             * @example ["INTAKE","PENDING","ADMITTED"]
             */
            statuses?: string[];
            /**
             * Filter by specific branch ID
             * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
             */
            branchId?: string;
            /**
             * Filter by date of birth (MM/DD/YYYY format)
             * @example "01/01/1982"
             */
            dob?: string;
            /**
             * Filter by episode number
             * @example 1
             */
            episodeNumber?: number;
            /**
             * Filter by admission number
             * @example 1
             */
            admissionNumber?: number;
            /**
             * Filter by start of care date (YYYY-MM-DD or AG Grid date string)
             * @example "2025-01-20"
             */
            socDate?: string;
            /**
             * AG Grid date filter type for socDate
             * @example "equals"
             */
            socDateType?: 'equals' | 'greaterThan' | 'lessThan' | 'inRange';
            /**
             * Upper bound for socDate inRange filter (YYYY-MM-DD or AG Grid date string)
             * @example "2025-12-31"
             */
            socDateTo?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PatientListResponseDto;
    }

    /**
     * No description
     * @tags patient
     * @name GenerateAuthReleasePdf
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/auth-release-pdf
     */
    export namespace GenerateAuthReleasePdf {
        export type RequestParams = {
            formId: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags patient
     * @name GenerateProfilePdf
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/profile-pdf
     */
    export namespace GenerateProfilePdf {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Communication {
    /**
     * No description
     * @tags Communication
     * @name List
     * @request GET:/api/v1/communication/branch/{branchId}/admission/{admissionId}
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto[];
    }

    /**
     * No description
     * @tags Communication
     * @name Create
     * @request POST:/api/v1/communication/branch/{branchId}/admission/{admissionId}
     */
    export namespace Create {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateCommunicationNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Get
     * @request GET:/api/v1/communication/branch/{branchId}/{id}
     */
    export namespace Get {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Update
     * @request PUT:/api/v1/communication/branch/{branchId}/{id}
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateCommunicationNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Delete
     * @request DELETE:/api/v1/communication/branch/{branchId}/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Communication
     * @name Submit
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/submit
     */
    export namespace Submit {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SubmitCommunicationNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Approve
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/approve
     */
    export namespace Approve {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name RequestChanges
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/request-changes
     */
    export namespace RequestChanges {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = RequestChangesDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Resubmit
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/resubmit
     */
    export namespace Resubmit {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateCommunicationNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Reassign
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/reassign
     */
    export namespace Reassign {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ReassignCommunicationNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Archive
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/archive
     */
    export namespace Archive {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name Restore
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/restore
     */
    export namespace Restore {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name ConfirmVerbalOrder
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/confirm
     */
    export namespace ConfirmVerbalOrder {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ConfirmVerbalOrderDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }

    /**
     * No description
     * @tags Communication
     * @name LinkOrder
     * @request POST:/api/v1/communication/branch/{branchId}/{id}/link-order
     */
    export namespace LinkOrder {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = LinkOrderDto;
        export type RequestHeaders = {};
        export type ResponseBody = CommunicationNoteDto;
    }
}

export namespace PatientDemographics {
    /**
     * No description
     * @tags PatientDemographics
     * @name Update
     * @request PATCH:/api/v1/branch/{branchId}/patient/{patientId}/demographics
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            patientId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateDemographicsDto;
        export type RequestHeaders = {};
        export type ResponseBody = DemographicsDto;
    }
}

export namespace PatientAdmissionDiagnosis {
    /**
     * No description
     * @tags PatientAdmissionDiagnosis
     * @name Update
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/diagnosis
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateDiagnosisDto[];
        export type RequestHeaders = {};
        export type ResponseBody = DiagnosisDto[];
    }
}

export namespace PatientAdmissionReferral {
    /**
     * No description
     * @tags PatientAdmissionReferral
     * @name Update
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/referral
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateReferralDto;
        export type RequestHeaders = {};
        export type ResponseBody = ReferralDto;
    }
}

export namespace AdmissionInsurance {
    /**
     * No description
     * @tags AdmissionInsurance
     * @name AddInsurance
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurance
     */
    export namespace AddInsurance {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            intermediary: 'stedi' | 'availity';
        };
        export type RequestBody = CreateInsuranceDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionInsuranceDto;
    }

    /**
     * No description
     * @tags AdmissionInsurance
     * @name DeleteInsurance
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{id}
     */
    export namespace DeleteInsurance {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionInsurance
     * @name MakePrimary
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{id}/primary
     */
    export namespace MakePrimary {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionInsurance
     * @name CheckEligibility
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{insuranceId}/eligibility-check
     */
    export namespace CheckEligibility {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            insuranceId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = EligibilityDto;
    }

    /**
     * No description
     * @tags AdmissionInsurance
     * @name UpdateEligibility
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{insuranceId}/eligibility
     */
    export namespace UpdateEligibility {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            insuranceId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateEligibilityDto;
        export type RequestHeaders = {};
        export type ResponseBody = EligibilityDto;
    }
}

export namespace Stedi {
    /**
     * No description
     * @tags stedi
     * @name GetInboxTransaction
     * @request GET:/api/v1/inbox-transaction/branch/{branchId}/transaction/{transactionId}/year/{year}
     */
    export namespace GetInboxTransaction {
        export type RequestParams = {
            branchId: string;
            transactionId: string;
            year: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SingleInboxTransactionDto;
    }

    /**
     * No description
     * @tags stedi
     * @name GetInboxTransactions
     * @request GET:/api/v1/inbox-transactions
     */
    export namespace GetInboxTransactions {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InboxTransactionsDto;
    }
}

export namespace Insurance {
    /**
     * No description
     * @tags Insurance
     * @name GetNewConfigFormData
     * @request GET:/api/v1/config/form
     */
    export namespace GetNewConfigFormData {
        export type RequestParams = {};
        export type RequestQuery = {
            insuranceId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigFormDataDto;
    }

    /**
     * No description
     * @tags Insurance
     * @name GetConfigFormData
     * @request GET:/api/v1/config/{id}/form
     */
    export namespace GetConfigFormData {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigFormDataDto;
    }

    /**
     * No description
     * @tags Insurance
     * @name GetConfigContractHistory
     * @request GET:/api/v1/config/{id}/contract-history
     */
    export namespace GetConfigContractHistory {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigContractHistoryItemDto[];
    }

    /**
     * No description
     * @tags Insurance
     * @name GetConfig
     * @request GET:/api/v1/config/{id}
     */
    export namespace GetConfig {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigDto;
    }

    /**
     * No description
     * @tags Insurance
     * @name DeleteConfig
     * @request DELETE:/api/v1/config/{id}
     */
    export namespace DeleteConfig {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Insurance
     * @name SaveConfig
     * @request POST:/api/v1/config
     */
    export namespace SaveConfig {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveInsuranceConfigDto;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigDto;
    }

    /**
     * No description
     * @tags Insurance
     * @name ListConfigs
     * @request GET:/api/v1/configs
     */
    export namespace ListConfigs {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceConfigListItemDto[];
    }

    /**
     * No description
     * @tags Insurance
     * @name DismissPendingPayer
     * @request DELETE:/api/v1/pending/{insuranceId}
     */
    export namespace DismissPendingPayer {
        export type RequestParams = {
            insuranceId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags insurance
     * @name InsuranceSearch
     * @request GET:/api/v1/insurance/search
     */
    export namespace InsuranceSearch {
        export type RequestParams = {};
        export type RequestQuery = {
            search: string;
            intermediary: 'stedi' | 'availity';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = InsuranceProviderDto[];
    }
}

export namespace Visit {
    /**
     * No description
     * @tags Visit
     * @name GetVisits
     * @request GET:/api/v1/visit
     */
    export namespace GetVisits {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name GetPatientsForVisit
     * @request GET:/api/v1/branch/{branchId}/visit/patient
     */
    export namespace GetPatientsForVisit {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PatientDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name GetEpisodeVisits
     * @request GET:/api/v1/branch/{branchId}/episode/{episodeId}
     */
    export namespace GetEpisodeVisits {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name CreateVisitsForEpisode
     * @request POST:/api/v1/branch/{branchId}/episode/{episodeId}/visit
     */
    export namespace CreateVisitsForEpisode {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateVisitDto[];
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name CreateVisitsForAdmission
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit
     */
    export namespace CreateVisitsForAdmission {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateVisitDto[];
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name CreateVisitsForPatient
     * @request POST:/api/v1/branch/{branchId}/patient/{patientId}/visit
     */
    export namespace CreateVisitsForPatient {
        export type RequestParams = {
            branchId: string;
            patientId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateVisitDto[];
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name UpdateVisits
     * @request PATCH:/api/v1/branch/{branchId}/episode/{episodeId}/visit/{id}
     */
    export namespace UpdateVisits {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto;
    }

    /**
     * No description
     * @tags Visit
     * @name DeleteVisit
     * @request DELETE:/api/v1/branch/{branchId}/episode/{episodeId}/visit/{id}
     */
    export namespace DeleteVisit {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Visit
     * @name GetPatientVisits
     * @request GET:/api/v2/visit
     */
    export namespace GetPatientVisits {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitSummaryDto[];
    }

    /**
     * No description
     * @tags Visit
     * @name GetVisitDetails
     * @request GET:/api/v2/branch/{branchId}/visit/{id}
     */
    export namespace GetVisitDetails {
        export type RequestParams = {
            id: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitDto;
    }
}

export namespace UpcomingVisit {
    /**
     * No description
     * @tags UpcomingVisit
     * @name Get
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/upcoming-visits
     */
    export namespace Get {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UpcomingVisitDto[];
    }
}

export namespace InsuranceAuthorization {
    /**
     * No description
     * @tags InsuranceAuthorization
     * @name List
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            includeRevoked?: boolean;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuthorizationDetailsDto[];
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name Create
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/{insuranceId}/authorizations
     */
    export namespace Create {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            insuranceId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateAuthorizationDto;
        export type RequestHeaders = {};
        export type ResponseBody = AuthorizationDetailsDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/{insuranceId}/authorizations/{authId}
     */
    export namespace Delete {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            insuranceId: string;
            authId: string;
        };
        export type RequestQuery = {
            force?: boolean;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name PreviewLink
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/link/preview
     */
    export namespace PreviewLink {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            authId: string;
            visitId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LinkImpactDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name LinkVisit
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/link
     */
    export namespace LinkVisit {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            authId: string;
            visitId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LinkVisitDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name PreviewUnlink
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/unlink/preview
     */
    export namespace PreviewUnlink {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            visitId: string;
            authId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LinkImpactDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name UnlinkVisit
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/unlink
     */
    export namespace UnlinkVisit {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            visitId: string;
            authId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LinkVisitDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name DismissAuthorization
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/dismiss
     */
    export namespace DismissAuthorization {
        export type RequestParams = {
            authId: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateAuthorizationDismissalDto;
        export type RequestHeaders = {};
        export type ResponseBody = AuthorizationDismissalDto;
    }

    /**
     * No description
     * @tags InsuranceAuthorization
     * @name UndismissAuthorization
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/dismiss
     */
    export namespace UndismissAuthorization {
        export type RequestParams = {
            authId: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace InsuranceAuthorizationCompliance {
    /**
     * No description
     * @tags InsuranceAuthorizationCompliance
     * @name GetInsuranceAuthCompliance
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/authorizations/compliance
     */
    export namespace GetInsuranceAuthCompliance {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = EvaluateComplianceDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceResultDto[];
    }

    /**
     * No description
     * @tags InsuranceAuthorizationCompliance
     * @name GetInsuranceAuthComplianceSummary
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/authorizations/compliance/summary
     */
    export namespace GetInsuranceAuthComplianceSummary {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuthorizationComplianceDto;
    }
}

export namespace PatientOverview {
    /**
     * No description
     * @tags PatientOverview
     * @name Get
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/overview
     */
    export namespace Get {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = OverviewPatientDto;
    }
}

export namespace VisitForm {
    /**
     * No description
     * @tags VisitForm
     * @name Save
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            submit: boolean;
        };
        export type RequestBody = SaveVisitFormDto;
        export type RequestHeaders = {};
        export type ResponseBody = SaveVisitFormResponseDto;
    }

    /**
     * No description
     * @tags VisitForm
     * @name List
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormDto[];
    }

    /**
     * No description
     * @tags VisitForm
     * @name UpdateStatus
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/status
     */
    export namespace UpdateStatus {
        export type RequestParams = {
            branchId: string;
            formId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateFormStatusDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags VisitForm
     * @name EnterDocumentation
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/enter-documentation
     */
    export namespace EnterDocumentation {
        export type RequestParams = {
            branchId: string;
            formId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags VisitForm
     * @name SaveCarryForwardSection
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/carry-forward-section
     */
    export namespace SaveCarryForwardSection {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveCarryForwardSectionDto;
        export type RequestHeaders = {};
        export type ResponseBody = SaveVisitFormResponseDto;
    }

    /**
     * No description
     * @tags VisitForm
     * @name DeleteDraft
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}
     */
    export namespace DeleteDraft {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags VisitForm
     * @name Get
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{id}
     */
    export namespace Get {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormDto;
    }

    /**
     * No description
     * @tags VisitForm
     * @name FormNotes
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/notes
     */
    export namespace FormNotes {
        export type RequestParams = {
            formId: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormNotesDto[];
    }

    /**
     * No description
     * @tags VisitForm
     * @name SaveNote
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/notes
     */
    export namespace SaveNote {
        export type RequestParams = {
            branchId: string;
            formId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveFormNotesDto;
        export type RequestHeaders = {};
        export type ResponseBody = SaveFormNotesDto[];
    }

    /**
     * No description
     * @tags VisitForm
     * @name Amend
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/amend
     */
    export namespace Amend {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateFormAmendDto;
        export type RequestHeaders = {};
        export type ResponseBody = FormAmendDto;
    }

    /**
     * No description
     * @tags VisitForm
     * @name GetDraftPhysicianOrder
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/physician-order/draft
     */
    export namespace GetDraftPhysicianOrder {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            visitId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormDto;
    }

    /**
     * No description
     * @tags VisitForm
     * @name CreatePhysicianOrder
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/physician-order
     */
    export namespace CreatePhysicianOrder {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            visitId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormDto;
    }
}

export namespace Oasis {
    /**
     * No description
     * @tags Oasis
     * @name GenerateXml
     * @request GET:/api/v1/oasis/branch/{branchId}/form/{formId}
     */
    export namespace GenerateXml {
        export type RequestParams = {
            branchId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Billing {
    /**
     * No description
     * @tags billing
     * @name Get
     * @request GET:/api/v1/billing/claim/inbox/{name}
     */
    export namespace Get {
        export type RequestParams = {
            name: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BillingDto;
    }

    /**
     * No description
     * @tags billing
     * @name GetClaims
     * @request GET:/api/v1/billing/claim
     */
    export namespace GetClaims {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ClaimDto[];
    }

    /**
     * No description
     * @tags billing
     * @name GetSentClaims
     * @request GET:/api/v1/billing/claim/sent
     */
    export namespace GetSentClaims {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ClaimSentDto[];
    }

    /**
     * No description
     * @tags billing
     * @name GetClaim
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}
     */
    export namespace GetClaim {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ClaimDetailsDto[];
    }

    /**
     * No description
     * @tags billing
     * @name DeleteClaim
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}
     */
    export namespace DeleteClaim {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name GenerateClaimPdf
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/pdf
     */
    export namespace GenerateClaimPdf {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {
            kind: 'ub04' | 'generic-invoice' | 'cms-1500';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name GetPatientClaims
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim
     */
    export namespace GetPatientClaims {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ClaimDto[];
    }

    /**
     * No description
     * @tags billing
     * @name GetSentClaim
     * @request GET:/api/v1/billing/claim/{claimId}/sent
     */
    export namespace GetSentClaim {
        export type RequestParams = {
            claimId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ClaimSentDetailsDto[];
    }

    /**
     * No description
     * @tags billing
     * @name AddOccurrenceCode
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/occurrence-code
     */
    export namespace AddOccurrenceCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateOccurrenceCode;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name RemoveOccurrenceCode
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/occurrence-code/{id}
     */
    export namespace RemoveOccurrenceCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name AddConditionCode
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/condition-code
     */
    export namespace AddConditionCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateConditionCode;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name RemoveConditionCode
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/condition-code/{id}
     */
    export namespace RemoveConditionCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name AddValueCode
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/visit-code
     */
    export namespace AddValueCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateValueCodeDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name RemoveValueCode
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/visit-code/{id}
     */
    export namespace RemoveValueCode {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name RemoveService
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/service/{id}
     */
    export namespace RemoveService {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name AddService
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/service/{id}
     */
    export namespace AddService {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name UpdateAdmissionDetails
     * @request PATCH:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/admission
     */
    export namespace UpdateAdmissionDetails {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateAdmissionDetailsDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name UpdateClaimRemarks
     * @request PATCH:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/remarks
     */
    export namespace UpdateClaimRemarks {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            claimId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateClaimRemarksDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name SubmitClaims
     * @request PUT:/api/v1/billing/claim/submit
     */
    export namespace SubmitClaims {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SubmitClaimDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name SubmitClaim
     * @request PUT:/api/v1/branch/{branchId}/billing/claim/{id}/submit
     */
    export namespace SubmitClaim {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name CancelClaim
     * @request POST:/api/v1/branch/{branchId}/billing/claim/{id}/cancel
     */
    export namespace CancelClaim {
        export type RequestParams = {
            branchId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags billing
     * @name CreateSingleClaim
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/create-draft
     */
    export namespace CreateSingleClaim {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CreateSingleClaimDto;
    }

    /**
     * No description
     * @tags billing
     * @name EditClaimDetails
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/edit-claim-details
     */
    export namespace EditClaimDetails {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = EditClaimDetailsDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Hipps {
    /**
     * No description
     * @tags hipps
     * @name GetHippsAuditDetails
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/hipps-audit
     */
    export namespace GetHippsAuditDetails {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            visitId: string;
        };
        export type RequestQuery = {
            /** @example 2026 */
            year?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = HippsAuditDetailsDto;
    }
}

export namespace Admission {
    /**
     * No description
     * @tags Admission
     * @name Get
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}
     */
    export namespace Get {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDto;
    }

    /**
     * No description
     * @tags Admission
     * @name SubmitIntake
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}
     */
    export namespace SubmitIntake {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDto;
    }

    /**
     * No description
     * @tags Admission
     * @name Upload
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload
     */
    export namespace Upload {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {
            orderId?: string;
        };
        export type RequestBody = {
            files?: File[];
            metadata?: {
                title?: string;
                notes?: string;
            }[];
        };
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name UploadRequest
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload-request
     */
    export namespace UploadRequest {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = FileUploadRequestDto[];
        export type RequestHeaders = {};
        export type ResponseBody = FileUploadResponseDto[];
    }

    /**
     * No description
     * @tags Admission
     * @name UploadRequestConfirm
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload-request/confirm
     */
    export namespace UploadRequestConfirm {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = FileUploadConfirmRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name UpdateFile
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/file/{id}
     */
    export namespace UpdateFile {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = FileMetadataDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name DeleteFile
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/file/{id}
     */
    export namespace DeleteFile {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name GetFiles
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/file
     */
    export namespace GetFiles {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FileDto[];
    }

    /**
     * No description
     * @tags Admission
     * @name GetDocumentRequests
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/document-request
     */
    export namespace GetDocumentRequests {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDocumentRequestDto[];
    }

    /**
     * No description
     * @tags Admission
     * @name CreateDocumentRequest
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/document-request
     */
    export namespace CreateDocumentRequest {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateDocumentRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDocumentRequestDto;
    }

    /**
     * No description
     * @tags Admission
     * @name FulfillDocumentRequest
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/fulfill
     */
    export namespace FulfillDocumentRequest {
        export type RequestParams = {
            admissionId: string;
            requestId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = FulfillDocumentRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDocumentRequestDto;
    }

    /**
     * No description
     * @tags Admission
     * @name CancelDocumentRequest
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/cancel
     */
    export namespace CancelDocumentRequest {
        export type RequestParams = {
            admissionId: string;
            requestId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name UnfulfillDocumentRequest
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/unfulfill
     */
    export namespace UnfulfillDocumentRequest {
        export type RequestParams = {
            admissionId: string;
            requestId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name GetDocumentNotes
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/note
     */
    export namespace GetDocumentNotes {
        export type RequestParams = {
            admissionId: string;
            requestId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDocumentNoteDto[];
    }

    /**
     * No description
     * @tags Admission
     * @name CreateDocumentNote
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/note
     */
    export namespace CreateDocumentNote {
        export type RequestParams = {
            admissionId: string;
            requestId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateDocumentNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionDocumentNoteDto;
    }

    /**
     * No description
     * @tags Admission
     * @name NonAdmit
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/non-admit
     */
    export namespace NonAdmit {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name RevertNonAdmit
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/revert-non-admit
     */
    export namespace RevertNonAdmit {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Admission
     * @name GetAdmissionNotes
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note
     */
    export namespace GetAdmissionNotes {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionNoteDto[];
    }

    /**
     * No description
     * @tags Admission
     * @name CreateAdmissionNote
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note
     */
    export namespace CreateAdmissionNote {
        export type RequestParams = {
            admissionId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateAdmissionNoteDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionNoteDto;
    }
}

export namespace Qa {
    /**
     * No description
     * @tags Qa
     * @name List
     * @request GET:/api/v1/qa
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Page number (1-indexed)
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of records per page
             * @default 50
             * @example 50
             */
            pageSize?: number;
            /**
             * Field to sort by
             * @example "visitDate"
             */
            sortField?: string;
            /**
             * Sort direction
             * @example "desc"
             */
            sortDirection?: 'asc' | 'desc';
            /**
             * Filter by QA statuses. If not provided, returns all statuses (SUBMITTED, REJECTED, APPROVED).
             * @example ["SUBMITTED","REJECTED","APPROVED"]
             */
            statuses?: string[];
            /**
             * Filter by patient name (partial match)
             * @example "Smith"
             */
            patientName?: string;
            /**
             * Filter by form name (partial match)
             * @example "OASIS"
             */
            formName?: string;
            /**
             * Filter by visit date from (YYYY-MM-DD format)
             * @example "2025-01-01"
             */
            visitDateFrom?: string;
            /**
             * Filter by visit date to (YYYY-MM-DD format)
             * @example "2025-12-31"
             */
            visitDateTo?: string;
            /**
             * Filter by branch ID
             * @example "ebef12f0-0b8e-11ef-a972-b57fdf832e72"
             */
            branchId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = QaListResponseDto;
    }
}

export namespace Logging {
    /**
     * No description
     * @tags Logging
     * @name LogError
     * @request POST:/api/log/error
     */
    export namespace LogError {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = LogErrorDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace FeatureFlags {
    /**
     * @description Returns all feature flags with their evaluated boolean values for the current organization context.
     * @tags Feature Flags
     * @name ListForOrg
     * @summary Get evaluated feature flags for current organization
     * @request GET:/api/feature-flag
     */
    export namespace ListForOrg {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FeatureFlagEvaluationListDto;
    }
}

export namespace Dashboard {
    /**
     * No description
     * @tags dashboard
     * @name GetCensusOverview
     * @request GET:/api/v1/dashboard/census-overview
     */
    export namespace GetCensusOverview {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /** Number of days to include in the time period */
            days?: 7 | 30;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CensusOverviewDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetDailyAverageCensus
     * @request GET:/api/v1/dashboard/daily-average-census
     */
    export namespace GetDailyAverageCensus {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /** Number of days to include in the time period */
            days?: 7 | 30;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = DailyAverageCensusDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetCbsaReport
     * @request GET:/api/v1/dashboard/cbsa-report
     */
    export namespace GetCbsaReport {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Start date in YYYY-MM-DD format
             * @example "2024-01-01"
             */
            startDate: string;
            /**
             * End date in YYYY-MM-DD format
             * @example "2024-12-31"
             */
            endDate: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CbsaReportDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetAssessmentsStatus
     * @request GET:/api/v1/dashboard/assessments-status
     */
    export namespace GetAssessmentsStatus {
        export type RequestParams = {};
        export type RequestQuery = {
            /** View type - overdue or upcoming assessments */
            view: 'overdue' | 'upcoming';
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Array of clinician IDs to filter by (comma-separated)
             * @example "uuid1,uuid2"
             */
            clinicianIds?: string[];
            /** Assessment status filter */
            status?: 'incomplete' | 'submitted' | 'rejected';
            /**
             * Form ID to filter by specific form type
             * @example "uuid-string-here"
             */
            formId?: string;
            /**
             * Page number (1-based)
             * @min 1
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of items per page (1-100)
             * @min 1
             * @max 100
             * @default 25
             * @example 25
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AssessmentsStatusResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetClinicians
     * @request GET:/api/v1/dashboard/clinicians
     */
    export namespace GetClinicians {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter clinicians for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Number of days to include in the time period (7 or 30)
             * @default 30
             * @example 30
             */
            days?: 7 | 30;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CliniciansResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetAssessmentForms
     * @request GET:/api/v1/dashboard/assessment-forms
     */
    export namespace GetAssessmentForms {
        export type RequestParams = {};
        export type RequestQuery = {
            /** View type to filter forms for */
            view?: 'overdue' | 'upcoming' | 'all';
            /**
             * Branch ID to filter forms for
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Comma-separated clinician IDs to filter by
             * @example "uuid1,uuid2"
             */
            clinicianIds?: string[];
            /** Status filter */
            status?: 'incomplete' | 'submitted' | 'rejected';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AssessmentFormsResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetEpisodeManagement
     * @request GET:/api/v1/dashboard/episode-management
     */
    export namespace GetEpisodeManagement {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /** Number of days to look ahead */
            days?: 7 | 30;
            /**
             * Page number (1-based)
             * @min 1
             * @example 1
             */
            page?: number;
            /**
             * Number of items per page (1-100)
             * @min 1
             * @max 100
             * @example 25
             */
            pageSize?: number;
            /**
             * Filter by specific event type. If not provided, returns all types
             * @example "RECERTIFICATION"
             */
            eventType?: 'RECERTIFICATION' | 'DISCHARGE' | 'EPISODE_ENDING';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = EpisodeManagementResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetTransfers
     * @request GET:/api/v1/dashboard/transfers
     */
    export namespace GetTransfers {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Page number (1-based)
             * @min 1
             * @example 1
             */
            page?: number;
            /**
             * Number of items per page (1-100)
             * @min 1
             * @max 100
             * @example 25
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = TransferResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name GetAuthorizationExpirations
     * @request GET:/api/v1/dashboard/authorization-expirations
     */
    export namespace GetAuthorizationExpirations {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Filter type - ALL (overdue + upcoming), OVERDUE (within warning days), UPCOMING (will be overdue in 7 days), DISMISSED (dismissed warnings), REQUESTED (insurance requested)
             * @default "ALL"
             */
            filter?: 'ALL' | 'OVERDUE' | 'UPCOMING' | 'DISMISSED' | 'REQUESTED';
            /**
             * Page number (1-based)
             * @min 1
             * @default 1
             * @example 1
             */
            page?: number;
            /**
             * Number of items per page (1-100)
             * @min 1
             * @max 100
             * @default 25
             * @example 25
             */
            pageSize?: number;
            /** Filter by expiration state */
            state?: 'EXPIRED_NO_REAUTH' | 'EXPIRED_GAP' | 'EXPIRING_SOON_NO_REAUTH' | 'EXPIRING_SOON_REAUTH_EXISTS';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuthorizationExpirationResponseDto;
    }

    /**
     * No description
     * @tags dashboard
     * @name ExportAuthorizationExpirationsExcel
     * @request GET:/api/v1/dashboard/authorization-expirations/export/excel
     */
    export namespace ExportAuthorizationExpirationsExcel {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all accessible branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /** Filter type to export */
            filter?: 'ALL' | 'OVERDUE' | 'UPCOMING' | 'DISMISSED' | 'REQUESTED';
            /**
             * @min 1
             * @default 1
             */
            page?: number;
            /**
             * @min 1
             * @max 100
             * @default 25
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace QaDashboard {
    /**
     * No description
     * @tags QA Dashboard
     * @name GetDashboard
     * @request GET:/api/v1/qa-dashboard
     */
    export namespace GetDashboard {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter data for, or "all" for all branches
             * @example "uuid-string-here"
             */
            branchId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = QaDashboardDto;
    }
}

export namespace ClinicalDashboard {
    /**
     * No description
     * @tags Clinical Dashboard
     * @name GetTodayVisits
     * @request GET:/api/v1/clinical-dashboard/today-visits
     */
    export namespace GetTodayVisits {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter, or "all" / omit for all accessible branches
             * @example "uuid-here"
             */
            branchId?: string;
            /**
             * Start of "today" range in UTC (inclusive)
             * @example "2026-03-16T05:00:00.000Z"
             */
            startUtc: string;
            /**
             * End of "today" range in UTC (exclusive)
             * @example "2026-03-17T04:00:00.000Z"
             */
            endUtc: string;
            /**
             * Page number (1-based)
             * @min 1
             * @default 1
             */
            page?: number;
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 10
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = TodayVisitsResponseDto;
    }

    /**
     * No description
     * @tags Clinical Dashboard
     * @name GetOutstandingVisits
     * @request GET:/api/v1/clinical-dashboard/outstanding-visits
     */
    export namespace GetOutstandingVisits {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter, or "all" / omit for all accessible branches
             * @example "uuid-here"
             */
            branchId?: string;
            /**
             * Start of clinician-local 'today' in UTC (inclusive). Visits with start < startUtc are considered outstanding.
             * @example "2026-03-16T05:00:00.000Z"
             */
            startUtc: string;
            /**
             * Page number (1-based)
             * @min 1
             * @default 1
             */
            page?: number;
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 10
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = OutstandingVisitsResponseDto;
    }

    /**
     * No description
     * @tags Clinical Dashboard
     * @name GetRecentlySubmittedVisits
     * @request GET:/api/v1/clinical-dashboard/recently-submitted-visits
     */
    export namespace GetRecentlySubmittedVisits {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter, or "all" / omit for all accessible branches
             * @example "uuid-here"
             */
            branchId?: string;
            /**
             * UTC lower-bound (inclusive) for MAX(submittedDate) per visit. Client computes this from the selected recency window in the user's local timezone.
             * @example "2026-03-17T07:00:00.000Z"
             */
            dateFrom: string;
            /**
             * Page number (1-based)
             * @min 1
             * @default 1
             */
            page?: number;
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 10
             */
            pageSize?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = RecentlySubmittedVisitsResponseDto;
    }

    /**
     * No description
     * @tags Clinical Dashboard
     * @name GetVisitDetail
     * @request GET:/api/v1/clinical-dashboard/branch/{branchId}/visit/{visitId}
     */
    export namespace GetVisitDetail {
        export type RequestParams = {
            branchId: string;
            visitId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitDetailDto;
    }
}

export namespace Intake {
    /**
     * @description Search for existing patients by SSN (exact match) or by lastName + dateOfBirth (fuzzy match) to prevent duplicate patient creation
     * @tags Intake
     * @name FindMatches
     * @summary Find potential patient matches for intake
     * @request POST:/api/intake/match
     */
    export namespace FindMatches {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = IntakeMatchRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = IntakeMatchCandidateDto[];
    }
}

export namespace PatientAdmissions {
    /**
     * No description
     * @tags Patient Admissions
     * @name GetPatientAdmissions
     * @summary Get all admissions for a patient
     * @request GET:/api/patient/{patientId}/admissions
     */
    export namespace GetPatientAdmissions {
        export type RequestParams = {
            /** Patient ID */
            patientId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PatientAdmissionSummaryDto[];
    }
}

export namespace AuditClientEvents {
    /**
     * @description Accepts a batch of client-side navigation events and logs them to the audit trail
     * @tags Audit - Client Events
     * @name BatchLogClientEvents
     * @summary Batch log client-side events
     * @request POST:/api/v1/audit/client-events
     */
    export namespace BatchLogClientEvents {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = BatchClientEventsDto;
        export type RequestHeaders = {};
        export type ResponseBody = BatchClientEventsResponseDto;
    }
}

export namespace CareProtocol {
    /**
     * No description
     * @tags Care Protocol
     * @name MatchProtocols
     * @summary Find care protocols matching patient ICD-10 codes
     * @request POST:/api/v1/branches/{branchId}/admissions/{admissionId}/care-protocol/match
     */
    export namespace MatchProtocols {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = MatchProtocolsDto;
        export type RequestHeaders = {};
        export type ResponseBody = any;
    }

    /**
     * No description
     * @tags Care Protocol
     * @name BulkAddFromProtocols
     * @summary Add care protocol problems to admission plan of care
     * @request POST:/api/v1/branches/{branchId}/admissions/{admissionId}/care-protocol/bulk-add
     */
    export namespace BulkAddFromProtocols {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            orderId?: string;
        };
        export type RequestBody = BulkAddFromProtocolsDto;
        export type RequestHeaders = {};
        export type ResponseBody = any;
    }
}

export namespace SchedulingDashboard {
    /**
     * No description
     * @tags Scheduling Dashboard
     * @name GetDashboard
     * @request GET:/api/v1/scheduling-dashboard
     */
    export namespace GetDashboard {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Branch ID to filter, or omit for all branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Range mode: WEEK (Mon–Sun) or ROLLING_7 (today + 6 days)
             * @default "WEEK"
             */
            rangeMode?: 'WEEK' | 'ROLLING_7';
            /**
             * Anchor date in YYYY-MM-DD format
             * @example "2026-02-16"
             */
            anchorDate?: string;
            /**
             * Metric type: visits or units
             * @default "visits"
             */
            metric?: 'visits' | 'units';
            /**
             * Comma-separated discipline codes to filter by (e.g. "SN,RN")
             * @example "SN,RN"
             */
            discipline?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SchedulingDashboardDto;
    }

    /**
     * No description
     * @tags Scheduling Dashboard
     * @name GetNurseVisits
     * @request GET:/api/v1/scheduling-dashboard/nurse/{userId}/visits
     */
    export namespace GetNurseVisits {
        export type RequestParams = {
            userId: string;
        };
        export type RequestQuery = {
            /**
             * Branch ID to filter, or omit for all branches
             * @example "uuid-string-here"
             */
            branchId?: string;
            /**
             * Range mode: WEEK (Mon–Sun) or ROLLING_7 (today + 6 days)
             * @default "WEEK"
             */
            rangeMode?: 'WEEK' | 'ROLLING_7';
            /**
             * Anchor date in YYYY-MM-DD format
             * @example "2026-02-16"
             */
            anchorDate?: string;
            /**
             * Metric type: visits or units
             * @default "visits"
             */
            metric?: 'visits' | 'units';
            /**
             * Comma-separated discipline codes to filter by (e.g. "SN,RN")
             * @example "SN,RN"
             */
            discipline?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NurseVisitsDto;
    }

    /**
     * No description
     * @tags Scheduling Dashboard
     * @name GetReassignmentCandidates
     * @request POST:/api/v1/scheduling-dashboard/reassignment-candidates
     */
    export namespace GetReassignmentCandidates {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = ReassignmentCandidatesRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = ReassignmentCandidatesResponseDto;
    }

    /**
     * No description
     * @tags Scheduling Dashboard
     * @name ReassignVisits
     * @request POST:/api/v1/scheduling-dashboard/reassign-visits
     */
    export namespace ReassignVisits {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = ReassignVisitsRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = ReassignVisitsResultDto;
    }
}

export namespace Compliance {
    /**
     * No description
     * @tags compliance
     * @name GetDashboard
     * @request GET:/api/v1/compliance/dashboard
     */
    export namespace GetDashboard {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDashboardDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetAlerts
     * @request GET:/api/v1/compliance/alerts
     */
    export namespace GetAlerts {
        export type RequestParams = {};
        export type RequestQuery = {
            alertType?: 'all' | 'missing' | 'expired' | 'expiring' | 'rejected';
            page?: string;
            limit?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceAlertPageDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetPendingReviewCount
     * @request GET:/api/v1/compliance/pending-review-count
     */
    export namespace GetPendingReviewCount {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = {
            pendingReviewCount: number;
        };
    }

    /**
     * No description
     * @tags compliance
     * @name GetStaffDirectory
     * @request GET:/api/v1/compliance/staff
     */
    export namespace GetStaffDirectory {
        export type RequestParams = {};
        export type RequestQuery = {
            status?: 'compliant' | 'non-compliant';
            search?: string;
            page?: string;
            limit?: string;
            sortField?: string;
            sortDirection?: 'asc' | 'desc';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = StaffComplianceListDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetStaffSummary
     * @request GET:/api/v1/compliance/staff/{staffId}/summary
     */
    export namespace GetStaffSummary {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceSummaryDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetStaffApplicableTypes
     * @request GET:/api/v1/compliance/staff/{staffId}/applicable-types
     */
    export namespace GetStaffApplicableTypes {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ApplicableDocumentTypeDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name GetMyComplianceSummary
     * @request GET:/api/v1/compliance/my/summary
     */
    export namespace GetMyComplianceSummary {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceSummaryDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetMyApplicableTypes
     * @request GET:/api/v1/compliance/my/applicable-types
     */
    export namespace GetMyApplicableTypes {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ApplicableDocumentTypeDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name GetMyProfile
     * @request GET:/api/v1/compliance/my/profile
     */
    export namespace GetMyProfile {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = MyProfileDto;
    }

    /**
     * No description
     * @tags compliance
     * @name UpdateMyProfile
     * @request PATCH:/api/v1/compliance/my/profile
     */
    export namespace UpdateMyProfile {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = UpdateMyProfileDto;
        export type RequestHeaders = {};
        export type ResponseBody = MyProfileDto;
    }

    /**
     * No description
     * @tags compliance
     * @name GetAuditLog
     * @request GET:/api/v1/compliance/audit-log
     */
    export namespace GetAuditLog {
        export type RequestParams = {};
        export type RequestQuery = {
            staffId: string;
            documentTypeId: string;
            action: string;
            actorId: string;
            dateFrom: string;
            dateTo: string;
            page: string;
            limit: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AuditLogListDto;
    }

    /**
     * No description
     * @tags compliance
     * @name ListDocumentTypes
     * @request GET:/api/v1/compliance/document-types
     */
    export namespace ListDocumentTypes {
        export type RequestParams = {};
        export type RequestQuery = {
            status: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name CreateDocumentType
     * @request POST:/api/v1/compliance/document-types
     */
    export namespace CreateDocumentType {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateComplianceDocumentTypeDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeDto;
    }

    /**
     * No description
     * @tags compliance
     * @name UpdateDocumentType
     * @request PUT:/api/v1/compliance/document-types/{id}
     */
    export namespace UpdateDocumentType {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateComplianceDocumentTypeDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeDto;
    }

    /**
     * No description
     * @tags compliance
     * @name ArchiveDocumentType
     * @request PATCH:/api/v1/compliance/document-types/{id}/archive
     */
    export namespace ArchiveDocumentType {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags compliance
     * @name UnarchiveDocumentType
     * @request PATCH:/api/v1/compliance/document-types/{id}/unarchive
     */
    export namespace UnarchiveDocumentType {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags compliance
     * @name ListRules
     * @request GET:/api/v1/compliance/document-types/{id}/rules
     */
    export namespace ListRules {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeRuleDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name AddRule
     * @request POST:/api/v1/compliance/document-types/{id}/rules
     */
    export namespace AddRule {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateComplianceDocumentTypeRuleDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeRuleDto;
    }

    /**
     * No description
     * @tags compliance
     * @name UpdateRule
     * @request PUT:/api/v1/compliance/document-types/{id}/rules/{ruleId}
     */
    export namespace UpdateRule {
        export type RequestParams = {
            id: string;
            ruleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateComplianceDocumentTypeRuleDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceDocumentTypeRuleDto;
    }

    /**
     * No description
     * @tags compliance
     * @name RemoveRule
     * @request DELETE:/api/v1/compliance/document-types/{id}/rules/{ruleId}
     */
    export namespace RemoveRule {
        export type RequestParams = {
            id: string;
            ruleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags compliance
     * @name GetDocuments
     * @request GET:/api/v1/compliance/staff/{staffId}/documents
     */
    export namespace GetDocuments {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {
            documentTypeId: string;
            status: string;
            isCustom: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceEmployeeDocumentDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name UploadDocument
     * @request POST:/api/v1/compliance/staff/{staffId}/documents
     */
    export namespace UploadDocument {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = string;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceEmployeeDocumentDto;
    }

    /**
     * No description
     * @tags compliance
     * @name RequestUpload
     * @request POST:/api/v1/compliance/staff/{staffId}/documents/upload-request
     */
    export namespace RequestUpload {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ComplianceUploadRequestItemDto[];
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceUploadResponseItemDto[];
    }

    /**
     * No description
     * @tags compliance
     * @name ConfirmUpload
     * @request POST:/api/v1/compliance/staff/{staffId}/documents/upload-confirm
     */
    export namespace ConfirmUpload {
        export type RequestParams = {
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ComplianceUploadConfirmDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags compliance
     * @name GetDocument
     * @request GET:/api/v1/compliance/staff/{staffId}/documents/{docId}
     */
    export namespace GetDocument {
        export type RequestParams = {
            docId: string;
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceEmployeeDocumentDto;
    }

    /**
     * No description
     * @tags compliance
     * @name CancelDocument
     * @request DELETE:/api/v1/compliance/staff/{staffId}/documents/{docId}
     */
    export namespace CancelDocument {
        export type RequestParams = {
            staffId: string;
            docId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags compliance
     * @name GetDownloadUrl
     * @request GET:/api/v1/compliance/staff/{staffId}/documents/{docId}/download
     */
    export namespace GetDownloadUrl {
        export type RequestParams = {
            docId: string;
            staffId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = {
            url: string;
        };
    }

    /**
     * No description
     * @tags compliance
     * @name ApproveDocument
     * @request PATCH:/api/v1/compliance/staff/{staffId}/documents/{docId}/approve
     */
    export namespace ApproveDocument {
        export type RequestParams = {
            staffId: string;
            docId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceEmployeeDocumentDto;
    }

    /**
     * No description
     * @tags compliance
     * @name RejectDocument
     * @request PATCH:/api/v1/compliance/staff/{staffId}/documents/{docId}/reject
     */
    export namespace RejectDocument {
        export type RequestParams = {
            staffId: string;
            docId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = RejectComplianceDocumentDto;
        export type RequestHeaders = {};
        export type ResponseBody = ComplianceEmployeeDocumentDto;
    }
}

export namespace NoteSummary {
    /**
     * No description
     * @tags NoteSummary
     * @name Create
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary
     */
    export namespace Create {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = NoteSummaryInputDto;
        export type RequestHeaders = {
            'idempotency-key': string;
        };
        export type ResponseBody = NoteSummaryCreatedDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name List
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryJobListDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name ListAvailableModels
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/models
     */
    export namespace ListAvailableModels {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryAvailableModelsDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name GetQuotaStatus
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/quota-status
     */
    export namespace GetQuotaStatus {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            formId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryQuotaStatusDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name FindActive
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/active
     */
    export namespace FindActive {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            formId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryActiveDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name Acknowledge
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/acknowledge
     */
    export namespace Acknowledge {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            jobId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = NoteSummaryAcknowledgeDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name GetStatus
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/status
     */
    export namespace GetStatus {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            jobId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryStatusDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name GetResult
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/result
     */
    export namespace GetResult {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            jobId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryResultDto;
    }

    /**
     * No description
     * @tags NoteSummary
     * @name Cancel
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/cancel
     */
    export namespace Cancel {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            jobId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = NoteSummaryStatusDto;
    }
}

export namespace LlmFeatures {
    /**
     * No description
     * @tags LLM Features
     * @name GetStatus
     * @summary Get feature status for the caller's active organization
     * @request GET:/api/v1/llm-features/{featureType}/status
     */
    export namespace GetStatus {
        export type RequestParams = {
            featureType: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FeatureStatusDto;
    }
}

export namespace Authentication {
    /**
     * No description
     * @tags Authentication
     * @name Login
     * @request POST:/api/v1/auth/login
     */
    export namespace Login {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = LoginRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = LoginResponseDto;
    }

    /**
     * No description
     * @tags Authentication
     * @name Selector
     * @request POST:/api/v1/auth/selector
     */
    export namespace Selector {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = OrgSelectorRequestDto;
        export type RequestHeaders = {};
        export type ResponseBody = LoginResponseDto;
    }

    /**
     * No description
     * @tags Authentication
     * @name Authenticated
     * @request GET:/api/v1/auth/authenticated
     */
    export namespace Authenticated {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = LoginResponseDto;
    }

    /**
     * No description
     * @tags Authentication
     * @name Logout
     * @request DELETE:/api/v1/auth/logout
     */
    export namespace Logout {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Authentication
     * @name ForgotPassword
     * @request POST:/api/v1/auth/forgot-password
     */
    export namespace ForgotPassword {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = ForgotPasswordDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Authentication
     * @name ChangePassword
     * @request PUT:/api/v1/auth/password
     */
    export namespace ChangePassword {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = ChangePasswordDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace User {
    /**
     * No description
     * @tags User
     * @name Create
     * @request POST:/api/v1/user
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateUserDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags User
     * @name FindAll
     * @request GET:/api/v1/user
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserDto[];
    }

    /**
     * No description
     * @tags User
     * @name Update
     * @request PATCH:/api/v1/user/{userId}
     */
    export namespace Update {
        export type RequestParams = {
            userId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateUserDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags User
     * @name Find
     * @request GET:/api/v1/user/{userId}
     */
    export namespace Find {
        export type RequestParams = {
            userId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserDto;
    }

    /**
     * No description
     * @tags User
     * @name FindAllUsersForSelection
     * @request GET:/api/v1/user/all
     */
    export namespace FindAllUsersForSelection {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserEmailDto[];
    }

    /**
     * No description
     * @tags User
     * @name FindAdminUsers
     * @request GET:/api/v1/user/admin
     */
    export namespace FindAdminUsers {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdminUserDto[];
    }

    /**
     * No description
     * @tags User
     * @name CreateAdminUser
     * @request POST:/api/v1/user/admin
     */
    export namespace CreateAdminUser {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateAdminUserDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdminUserDto;
    }

    /**
     * No description
     * @tags User
     * @name UpdateAdminUser
     * @request PATCH:/api/v1/user/admin/{userId}
     */
    export namespace UpdateAdminUser {
        export type RequestParams = {
            userId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateAdminUserDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdminUserDto;
    }

    /**
     * No description
     * @tags User
     * @name FindAdminUser
     * @request GET:/api/v1/user/admin/{userId}
     */
    export namespace FindAdminUser {
        export type RequestParams = {
            userId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdminUserDto;
    }

    /**
     * No description
     * @tags User
     * @name FindAllCompany
     * @request GET:/api/v1/user/company/{companyId}
     */
    export namespace FindAllCompany {
        export type RequestParams = {
            companyId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserDto[];
    }

    /**
     * No description
     * @tags User
     * @name FindAllBranch
     * @request GET:/api/v1/user/branch/{branchId}
     */
    export namespace FindAllBranch {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserDto[];
    }
}

export namespace Company {
    /**
     * No description
     * @tags Company
     * @name FindAll
     * @request GET:/api/v1/company
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CompanyDto[];
    }

    /**
     * No description
     * @tags Company
     * @name Create
     * @request POST:/api/v1/company
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateCompanyDto;
        export type RequestHeaders = {};
        export type ResponseBody = CompanyDto;
    }

    /**
     * No description
     * @tags Company
     * @name FindOne
     * @request GET:/api/v1/company/{id}
     */
    export namespace FindOne {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CompanyDto;
    }

    /**
     * No description
     * @tags Company
     * @name Update
     * @request PATCH:/api/v1/company/{id}
     */
    export namespace Update {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateCompanyDto;
        export type RequestHeaders = {};
        export type ResponseBody = CompanyDto;
    }
}

export namespace Branch {
    /**
     * No description
     * @tags branch
     * @name FindOne
     * @request GET:/api/v1/branch/{branchId}
     */
    export namespace FindOne {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BranchDto;
    }

    /**
     * No description
     * @tags branch
     * @name Update
     * @request PATCH:/api/v1/company/{companyId}/branch/{branchId}
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            companyId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateBranchDto;
        export type RequestHeaders = {};
        export type ResponseBody = BranchDto;
    }

    /**
     * No description
     * @tags branch
     * @name Create
     * @request POST:/api/v1/company/{companyId}/branch
     */
    export namespace Create {
        export type RequestParams = {
            companyId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateBranchDto;
        export type RequestHeaders = {};
        export type ResponseBody = BranchDto;
    }
}

export namespace Role {
    /**
     * No description
     * @tags Role
     * @name FindAll
     * @request GET:/api/v1/role
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = RoleDto[];
    }
}

export namespace Physician {
    /**
     * No description
     * @tags Physician
     * @name PhysicianSearch
     * @request GET:/api/v1/physician/search
     */
    export namespace PhysicianSearch {
        export type RequestParams = {};
        export type RequestQuery = {
            npiNumber?: string;
            firstName?: string;
            lastName?: string;
            state?: string;
            city?: string;
            specialty?: string;
            limit?: number;
            page?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = SearchPhysicianDto;
    }

    /**
     * No description
     * @tags Physician
     * @name Create
     * @request POST:/api/v1/physician
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreatePhysicianDto;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }

    /**
     * No description
     * @tags Physician
     * @name List
     * @request GET:/api/v1/physician
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto[];
    }

    /**
     * No description
     * @tags Physician
     * @name Get
     * @request GET:/api/v1/physician/{id}
     */
    export namespace Get {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }

    /**
     * No description
     * @tags Physician
     * @name Edit
     * @request PATCH:/api/v1/physician/{id}
     */
    export namespace Edit {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdatePhysicianDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Physician
     * @name EditPhysicianDetails
     * @request PATCH:/api/v1/physician/{physicianId}/details
     */
    export namespace EditPhysicianDetails {
        export type RequestParams = {
            physicianId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = EditPhysicianDetailsDto;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }
}

export namespace PatientContact {
    /**
     * No description
     * @tags PatientContact
     * @name Save
     * @request POST:/api/v1/branchId/{branchId}/patientId/{patientId}/contact
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            patientId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreatePatientContactDto;
        export type RequestHeaders = {};
        export type ResponseBody = PatientContactDto;
    }
}

export namespace PatientSupport {
    /**
     * No description
     * @tags PatientSupport
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/support
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SavePatientSupportDto;
        export type RequestHeaders = {};
        export type ResponseBody = PatientSupportDto;
    }
}

export namespace PatientCaregiver {
    /**
     * No description
     * @tags PatientCaregiver
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/patient/{patientId}/caregiver
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            patientId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveCaregiverDto;
        export type RequestHeaders = {};
        export type ResponseBody = PatientCaregiverDto;
    }

    /**
     * No description
     * @tags PatientCaregiver
     * @name Update
     * @request PUT:/api/v1/branch/{branchId}/patient/{patientId}/caregiver/{caregiverId}
     */
    export namespace Update {
        export type RequestParams = {
            branchId: string;
            patientId: string;
            caregiverId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveCaregiverDto;
        export type RequestHeaders = {};
        export type ResponseBody = PatientCaregiverDto;
    }
}

export namespace PatientAllergyRisk {
    /**
     * No description
     * @tags PatientAllergyRisk
     * @name Save
     * @request POST:/api/v1/allergy-risk
     */
    export namespace Save {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreatePatientAllergyRiskDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionProvider {
    /**
     * No description
     * @tags admission-provider
     * @name Save
     * @request PUT:/api/v1/provider/branch/{branchId}/admission/{admissionId}
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionProviderDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Pharmacy {
    /**
     * No description
     * @tags Pharmacy
     * @name Create
     * @request POST:/api/v1/pharmacy
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SavePharmacyDto;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto;
    }

    /**
     * No description
     * @tags Pharmacy
     * @name List
     * @request GET:/api/v1/pharmacy
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto[];
    }

    /**
     * No description
     * @tags Pharmacy
     * @name Edit
     * @request PATCH:/api/v1/pharmacy/{id}
     */
    export namespace Edit {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SavePharmacyDto;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto;
    }

    /**
     * No description
     * @tags Pharmacy
     * @name Get
     * @request GET:/api/v1/pharmacy/{id}
     */
    export namespace Get {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto;
    }
}

export namespace PatientPharmacy {
    /**
     * No description
     * @tags PatientPharmacy
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SavePatientPharmacyDto;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto;
    }

    /**
     * No description
     * @tags PatientPharmacy
     * @name SetPrimary
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy/{pharmacyId}/primary
     */
    export namespace SetPrimary {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            pharmacyId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PharmacyDto;
    }

    /**
     * No description
     * @tags PatientPharmacy
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy/{pharmacyId}
     */
    export namespace Delete {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            pharmacyId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace VisitType {
    /**
     * No description
     * @tags visit-type
     * @name Create
     * @request POST:/api/v1/visit-type
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateVisitTypeDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitTypeDto;
    }

    /**
     * No description
     * @tags visit-type
     * @name FindAll
     * @request GET:/api/v1/visit-type
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitTypeDto[];
    }

    /**
     * No description
     * @tags visit-type
     * @name FindOne
     * @request GET:/api/v1/visit-type/{id}
     */
    export namespace FindOne {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = VisitTypeDto;
    }

    /**
     * No description
     * @tags visit-type
     * @name Update
     * @request PATCH:/api/v1/visit-type/{id}
     */
    export namespace Update {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitTypeDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitTypeDto;
    }

    /**
     * No description
     * @tags visit-type
     * @name RevenueCodes
     * @request GET:/api/v1/revenue-codes
     */
    export namespace RevenueCodes {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = RevenueCodeDto[];
    }

    /**
     * No description
     * @tags visit-type
     * @name ServiceCodes
     * @request GET:/api/v1/service-codes
     */
    export namespace ServiceCodes {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ServiceCodeDto[];
    }
}

export namespace Form {
    /**
     * No description
     * @tags Form
     * @name FindAll
     * @request GET:/api/v1/form
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormDto[];
    }

    /**
     * No description
     * @tags Form
     * @name FindOne
     * @request GET:/api/v1/form/{id}
     */
    export namespace FindOne {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormDto;
    }
}

export namespace Payroll {
    /**
     * No description
     * @tags payroll
     * @name List
     * @request GET:/api/v1/payroll
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Period start date
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * Period end date (inclusive)
             * @format date
             * @example "2025-09-12"
             */
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollDto[];
    }

    /**
     * No description
     * @tags payroll
     * @name UpdateVisitPayroll
     * @summary Update payroll paid status for selected visits in a period
     * @request PUT:/api/v1/payroll
     */
    export namespace UpdateVisitPayroll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitPayrollDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payroll
     * @name ListPeriods
     * @summary List payroll periods up to current + next
     * @request GET:/api/v1/payroll/periods
     */
    export namespace ListPeriods {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollPeriodDto[];
    }

    /**
     * No description
     * @tags payroll
     * @name ExportExcel
     * @summary Export payroll data as Excel spreadsheet
     * @request GET:/api/v1/payroll/export/excel
     */
    export namespace ExportExcel {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Start date of the payroll period
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * End date of the payroll period
             * @format date
             * @example "2025-09-12"
             */
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payroll
     * @name ListEmployeeVisits
     * @summary List visits for an employee within a payroll period
     * @request GET:/api/v1/payroll/employee/{employeeId}
     */
    export namespace ListEmployeeVisits {
        export type RequestParams = {
            employeeId: string;
        };
        export type RequestQuery = {
            /** @format date */
            from: string;
            /** @format date */
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollEmployeeVisitDto[];
    }

    /**
     * No description
     * @tags payroll
     * @name UpdateVisitCharge
     * @request PUT:/api/v1/payroll/visits/{payrollId}/charge
     */
    export namespace UpdateVisitCharge {
        export type RequestParams = {
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitChargeDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payroll
     * @name CreateVisitAdjustment
     * @summary Create a payroll adjustment record for a visit
     * @request POST:/api/v1/payroll/visits/{payrollId}/adjustments
     */
    export namespace CreateVisitAdjustment {
        export type RequestParams = {
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateVisitAdjustmentDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitAdjustmentDto;
    }

    /**
     * No description
     * @tags payroll
     * @name UpdateVisitAdjustment
     * @summary Update an existing payroll adjustment
     * @request PUT:/api/v1/payroll/visits/{payrollId}/adjustments
     */
    export namespace UpdateVisitAdjustment {
        export type RequestParams = {
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitAdjustmentDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payroll
     * @name GetConfig
     * @summary Get current payroll configuration
     * @request GET:/api/v1/payroll/config
     */
    export namespace GetConfig {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollConfigDto;
    }

    /**
     * No description
     * @tags payroll
     * @name UpdateConfig
     * @summary Update payroll configuration
     * @request PUT:/api/v1/payroll/config
     */
    export namespace UpdateConfig {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = UpdatePayrollConfigDto;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollConfigDto;
    }
}

export namespace PayrollV2 {
    /**
     * No description
     * @tags payrollV2
     * @name ListSchedules
     * @summary List all payroll schedules for the organization with filtering
     * @request GET:/api/v2/payroll/schedules
     */
    export namespace ListSchedules {
        export type RequestParams = {};
        export type RequestQuery = {
            /** Filter by active status. Omit to return all schedules. */
            isActive?: boolean;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleListResponseDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name CreateSchedule
     * @summary Create a new payroll schedule
     * @request POST:/api/v2/payroll/schedules
     */
    export namespace CreateSchedule {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreatePayrollScheduleDto;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetCurrentDefaultSchedule
     * @summary Get the current default payroll schedule
     * @request GET:/api/v2/payroll/schedules/current-default
     */
    export namespace GetCurrentDefaultSchedule {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetSchedule
     * @summary Get a specific payroll schedule
     * @request GET:/api/v2/payroll/schedules/{scheduleId}
     */
    export namespace GetSchedule {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name UpdateSchedule
     * @summary Update a payroll schedule
     * @request PUT:/api/v2/payroll/schedules/{scheduleId}
     */
    export namespace UpdateSchedule {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdatePayrollScheduleDto;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name DeactivateSchedule
     * @summary Deactivate a payroll schedule and reassign employees to default
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/deactivate
     */
    export namespace DeactivateSchedule {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = DeactivatePayrollScheduleResponseDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name ReactivateSchedule
     * @summary Reactivate a deactivated payroll schedule
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/reactivate
     */
    export namespace ReactivateSchedule {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ReactivatePayrollScheduleResponseDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetSchedulePeriods
     * @summary Get payroll periods for a specific schedule
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/periods
     */
    export namespace GetSchedulePeriods {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollPeriodV2Dto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetOpenPeriods
     * @summary Get all open/pending periods for a schedule
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/periods/open
     */
    export namespace GetOpenPeriods {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollPeriodV2Dto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name ClosePeriod
     * @summary Explicitly close a payroll period
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/periods/close
     */
    export namespace ClosePeriod {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ClosePeriodDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name ReopenPeriod
     * @summary Reopen a closed payroll period
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/periods/reopen
     */
    export namespace ReopenPeriod {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = ClosePeriodDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetSchedulePayroll
     * @summary Get payroll data for a specific schedule and period
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/payroll
     */
    export namespace GetSchedulePayroll {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {
            /**
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * @format date
             * @example "2025-09-12"
             */
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollDto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name ExportSchedulePayrollExcel
     * @summary Export payroll data for a specific schedule and period as Excel file
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/export/excel
     */
    export namespace ExportSchedulePayrollExcel {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {
            /**
             * Start date of the payroll period
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * End date of the payroll period
             * @format date
             * @example "2025-09-12"
             */
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetScheduleEmployees
     * @summary Get employees assigned to a payroll schedule
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/employees
     */
    export namespace GetScheduleEmployees {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollScheduleEmployeeDto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name AssignEmployeeToSchedule
     * @summary Assign an employee to a payroll schedule
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/employees
     */
    export namespace AssignEmployeeToSchedule {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreatePayrollEmployeeAssignmentDto;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollEmployeeAssignmentDto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name EndEmployeeAssignment
     * @summary End an employee assignment to a payroll schedule
     * @request DELETE:/api/v2/payroll/schedules/{scheduleId}/employees/{employeeId}
     */
    export namespace EndEmployeeAssignment {
        export type RequestParams = {
            scheduleId: string;
            employeeId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetAvailableEmployees
     * @summary Get all employees available for payroll assignment
     * @request GET:/api/v2/payroll/available-employees
     */
    export namespace GetAvailableEmployees {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollAvailableEmployeeDto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name GetScheduleEmployeeVisits
     * @summary Get detailed visit data for an employee within a schedule and period
     * @request GET:/api/v2/payroll/schedules/{scheduleId}/employee/{employeeId}
     */
    export namespace GetScheduleEmployeeVisits {
        export type RequestParams = {
            scheduleId: string;
            employeeId: string;
        };
        export type RequestQuery = {
            from: string;
            to: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PayrollEmployeeVisitDto[];
    }

    /**
     * No description
     * @tags payrollV2
     * @name UpdateVisitPayrollStatus
     * @summary Update payroll status for multiple visit payroll records within a schedule
     * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/bulk-status
     */
    export namespace UpdateVisitPayrollStatus {
        export type RequestParams = {
            scheduleId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitPayrollDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name CreateVisitAdjustment
     * @summary Create a payroll adjustment record for a visit within a schedule
     * @request POST:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/adjustments
     */
    export namespace CreateVisitAdjustment {
        export type RequestParams = {
            scheduleId: string;
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = CreateVisitAdjustmentDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitAdjustmentDto;
    }

    /**
     * No description
     * @tags payrollV2
     * @name UpdateVisitAdjustment
     * @summary Update an existing payroll adjustment within a schedule
     * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/adjustments
     */
    export namespace UpdateVisitAdjustment {
        export type RequestParams = {
            scheduleId: string;
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitAdjustmentDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags payrollV2
     * @name UpdateVisitCharge
     * @summary Update the custom charge for a visit payroll record within a schedule
     * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/charge
     */
    export namespace UpdateVisitCharge {
        export type RequestParams = {
            scheduleId: string;
            payrollId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateVisitChargeDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace VisitFormSupply {
    /**
     * No description
     * @tags VisitFormSupply
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/supplies
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveVisitFormSupplyDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormSupplyDto;
    }

    /**
     * No description
     * @tags VisitFormSupply
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/supplies/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace VisitFormWound {
    /**
     * No description
     * @tags VisitFormWound
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/wounds
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveVisitFormWoundDto;
        export type RequestHeaders = {};
        export type ResponseBody = VisitFormWoundDto;
    }

    /**
     * No description
     * @tags VisitFormWound
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/wounds/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionWound {
    /**
     * No description
     * @tags AdmissionWound
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/wounds
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionWoundDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionWound
     * @name List
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/wounds
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionWoundDto[];
    }

    /**
     * No description
     * @tags AdmissionWound
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/wounds/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            visitId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionWound
     * @name GenerateWoundsPdf
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/wounds/episode/{episodeId}/pdf
     */
    export namespace GenerateWoundsPdf {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            /** @example "wounds" */
            type: 'wounds';
            /** @example "unresolved" */
            mode: 'all' | 'unresolved' | 'resolved';
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionVaccination {
    /**
     * No description
     * @tags AdmissionVaccination
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/vaccinations
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionVaccinationDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionVaccinationDto;
    }

    /**
     * No description
     * @tags AdmissionVaccination
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/vaccinations/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            visitId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionMedication {
    /**
     * No description
     * @tags AdmissionMedication
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionMedicationDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionMedicationDto;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name SaveFromInfection
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/infections/{id}
     */
    export namespace SaveFromInfection {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionMedicationDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionMedicationDto;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            visitId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name Inactivate
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/inactivate/{id}
     */
    export namespace Inactivate {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            orderId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name Activate
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/activate/{id}
     */
    export namespace Activate {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            orderId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name Remove
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/infection/{infectionId}
     */
    export namespace Remove {
        export type RequestParams = {
            id: string;
            infectionId: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name SaveTeaching
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/teachings
     */
    export namespace SaveTeaching {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveMedicationTeachingDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionMedicationDto;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name DeleteTeaching
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/teachings/{teachingId}/forms/{formId}
     */
    export namespace DeleteTeaching {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
            id: string;
            teachingId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionMedicationDto;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name GeneratePdf
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/medications/episode/{episodeId}/pdf
     */
    export namespace GeneratePdf {
        export type RequestParams = {
            branchId: string;
            episodeId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            /** @example "medications" */
            type: 'medications' | 'medications-details' | 'drug-to-drug' | 'drug-to-drug-summary';
            /** @example "active" */
            mode: 'all' | 'active' | 'inactive';
            date?: string | null;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name GetDrugDetails
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/medications/details/{drugbankId}
     */
    export namespace GetDrugDetails {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            drugbankId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = DrugDetailsDto;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name ApproveMedications
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/form/{formId}/approve
     */
    export namespace ApproveMedications {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionMedication
     * @name AssignOrder
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/assign-order
     */
    export namespace AssignOrder {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = AssignOrderDto;
        export type RequestHeaders = {};
        export type ResponseBody = AssignOrderResultDto;
    }
}

export namespace FormOrder {
    /**
     * No description
     * @tags FormOrder
     * @name Save
     * @request POST:/api/v1/form-order/branch/{branchId}
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveFormOrderDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags FormOrder
     * @name List
     * @request GET:/api/v1/form-order
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormOrderDto[];
    }

    /**
     * No description
     * @tags FormOrder
     * @name ListByAdmission
     * @request GET:/api/v1/form-order/branch/{branchId}/admission/{admissionId}
     */
    export namespace ListByAdmission {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormOrderDto[];
    }

    /**
     * No description
     * @tags FormOrder
     * @name ListEligible
     * @request GET:/api/v1/form-order/branch/{branchId}/admission/{admissionId}/eligible
     */
    export namespace ListEligible {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormOrderDto[];
    }

    /**
     * No description
     * @tags FormOrder
     * @name GeneratePdf
     * @request GET:/api/v1/form-order/branch/{branchId}/form/{formId}
     */
    export namespace GeneratePdf {
        export type RequestParams = {
            formId: string;
            branchId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags FormOrder
     * @name Reset
     * @request GET:/api/v1/form-order/branch/{branchId}/order/{orderId}
     */
    export namespace Reset {
        export type RequestParams = {
            branchId: string;
            orderId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags FormOrder
     * @name SendEfax
     * @request POST:/api/v1/form-order/branch/{branchId}/order/{orderId}/fax/send
     */
    export namespace SendEfax {
        export type RequestParams = {
            branchId: string;
            orderId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionPlanOfCare {
    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name SaveProblem
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/problem
     */
    export namespace SaveProblem {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveProblemDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name SaveGoal
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/goal
     */
    export namespace SaveGoal {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveGoalDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionProblemGoalDto;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name SaveTask
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/task
     */
    export namespace SaveTask {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveTaskDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name SaveTaskLog
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/form/{formId}/task-log
     */
    export namespace SaveTaskLog {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            formId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveTaskLogDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name List
     * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care
     */
    export namespace List {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            visitId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionPlanOfCareDto[];
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name AssignOrder
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/{type}/{id}/assign-order
     */
    export namespace AssignOrder {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            type: string;
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = AssignOrderDto;
        export type RequestHeaders = {};
        export type ResponseBody = AssignOrderResultDto;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/{type}/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            id: string;
            type: string;
        };
        export type RequestQuery = {
            visitId: string;
            orderId?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags AdmissionPlanOfCare
     * @name BulkAddFromTemplates
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/bulk-from-templates
     */
    export namespace BulkAddFromTemplates {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            orderId?: string;
        };
        export type RequestBody = BulkAddFromTemplatesDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionPlanOfCareDto[];
    }
}

export namespace AdmissionIncident {
    /**
     * No description
     * @tags AdmissionIncident
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/incident
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionIncidentDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionIncidentDto;
    }

    /**
     * No description
     * @tags AdmissionIncident
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/incidents/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace AdmissionInfection {
    /**
     * No description
     * @tags AdmissionInfection
     * @name Save
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/infections
     */
    export namespace Save {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = SaveAdmissionInfectionDto;
        export type RequestHeaders = {};
        export type ResponseBody = AdmissionInfectionDto;
    }

    /**
     * No description
     * @tags AdmissionInfection
     * @name Delete
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/infections/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {
            visitId: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace PatientPhysician {
    /**
     * No description
     * @tags PatientPhysician
     * @name AddPhysician
     * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/physician
     */
    export namespace AddPhysician {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = AddPhysicianToAdmissionDto;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }

    /**
     * No description
     * @tags PatientPhysician
     * @name UpdatePhysician
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}
     */
    export namespace UpdatePhysician {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            physicianId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdatePatientPhysicianDto;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }

    /**
     * No description
     * @tags PatientPhysician
     * @name RemovePhysician
     * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}
     */
    export namespace RemovePhysician {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            physicianId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags PatientPhysician
     * @name ReplacePhysician
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}/replace
     */
    export namespace ReplacePhysician {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            physicianId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = AddPhysicianToAdmissionDto;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }

    /**
     * No description
     * @tags PatientPhysician
     * @name SetPrimary
     * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}/primary
     */
    export namespace SetPrimary {
        export type RequestParams = {
            branchId: string;
            admissionId: string;
            physicianId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PhysicianDto;
    }
}

export namespace FormCms {
    /**
     * No description
     * @tags FormCms
     * @name Download
     * @request POST:/api/v1/form-cms
     */
    export namespace Download {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = string[];
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags FormCms
     * @name FindAll
     * @request GET:/api/v1/form-cms
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = FormCmsDto[];
    }

    /**
     * No description
     * @tags FormCms
     * @name UpdateStatus
     * @request PATCH:/api/v1/form-cms
     */
    export namespace UpdateStatus {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = UpdateFormCmsDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Template {
    /**
     * No description
     * @tags Template
     * @name Save
     * @request POST:/api/v1/template
     */
    export namespace Save {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveTemplateDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Template
     * @name FindAll
     * @request GET:/api/v1/template
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {
            /** Filter by template type (goal, task, problem, etc.) */
            templateType?: string;
            /** Filter by discipline (SN, PT, OT, ST) */
            discipline?: string;
            /** Filter to templates linked from a specific problem template (by template ID) */
            problemTemplateId?: string;
            /** Goal title used with problemTemplateId to find tasks linked to a matching goal template */
            goalTitle?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = any;
    }

    /**
     * No description
     * @tags Template
     * @name GetTemplateProblemList
     * @request GET:/api/v1/template/problems
     */
    export namespace GetTemplateProblemList {
        export type RequestParams = {};
        export type RequestQuery = {
            /** Search query to filter by title or description */
            search?: string;
            /** Filter by problem type */
            type?: string;
            /** Filter by discipline (SN, PT, OT, ST) */
            discipline?: string;
            /**
             * Page number (1-indexed)
             * @default 1
             */
            page?: number;
            /**
             * Number of items per page
             * @default 20
             */
            limit?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = any;
    }

    /**
     * No description
     * @tags Template
     * @name AddLink
     * @request POST:/api/v1/template/link
     */
    export namespace AddLink {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = LinkDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Template
     * @name Delete
     * @request DELETE:/api/v1/template/{id}
     */
    export namespace Delete {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Template
     * @name RemoveLink
     * @request DELETE:/api/v1/template/link/{fromId}/{toId}
     */
    export namespace RemoveLink {
        export type RequestParams = {
            fromId: string;
            toId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export namespace Report {
    /**
     * No description
     * @tags Report
     * @name ExportExcel
     * @summary Export report data as Excel spreadsheet
     * @request GET:/api/v1/report/export/excel/{id}
     */
    export namespace ExportExcel {
        export type RequestParams = {
            id?: string;
        };
        export type RequestQuery = {
            /** @example "infections" */
            type: string;
            /** @example "b3df1346-6c46-4161-a50f-4b3bc9805617" */
            branchId: string;
            /**
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * @format date
             * @example "2025-09-12"
             */
            to: string;
            admissionStatus?: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name FindAll
     * @request GET:/api/v1/report
     */
    export namespace FindAll {
        export type RequestParams = {};
        export type RequestQuery = {
            /** @example "infections" */
            type: string;
            /** @example "b3df1346-6c46-4161-a50f-4b3bc9805617" */
            branchId: string;
            /**
             * @format date
             * @example "2025-08-30"
             */
            from: string;
            /**
             * @format date
             * @example "2025-09-12"
             */
            to: string;
            /** @example "ADMITTED" */
            admissionStatus?: string | null;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name SaveCustomReport
     * @request POST:/api/v1/report/custom
     */
    export namespace SaveCustomReport {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveCustomReportDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name GetUserReports
     * @request GET:/api/v1/report/custom
     */
    export namespace GetUserReports {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = UserReportDto;
    }

    /**
     * No description
     * @tags Report
     * @name DeleteCustomReport
     * @request DELETE:/api/v1/report/custom/{id}
     */
    export namespace DeleteCustomReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name SaveUserFavorite
     * @request POST:/api/v1/report/user-favorite
     */
    export namespace SaveUserFavorite {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveUserFavoriteDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name SaveReport
     * @request POST:/api/v1/report/report
     */
    export namespace SaveReport {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveReportDto;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name GetApprovedReports
     * @request GET:/api/v1/report/approved-reports
     */
    export namespace GetApprovedReports {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ReportDto[];
    }

    /**
     * No description
     * @tags Report
     * @name GetReports
     * @request GET:/api/v1/report/reports
     */
    export namespace GetReports {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ReportDto[];
    }

    /**
     * No description
     * @tags Report
     * @name GetReport
     * @request GET:/api/v1/report/report/{id}
     */
    export namespace GetReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ReportDto;
    }

    /**
     * No description
     * @tags Report
     * @name DeleteReport
     * @request DELETE:/api/v1/report/report/{id}
     */
    export namespace DeleteReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name ApproveReport
     * @request POST:/api/v1/report/approve-report/{id}
     */
    export namespace ApproveReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name RemoveUserApproveReport
     * @request DELETE:/api/v1/report/remove-approve-report/{id}
     */
    export namespace RemoveUserApproveReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name LockReport
     * @request POST:/api/v1/report/lock-report/{id}
     */
    export namespace LockReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name RevokeReport
     * @request POST:/api/v1/report/revoke-report/{id}
     */
    export namespace RevokeReport {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }

    /**
     * No description
     * @tags Report
     * @name GetConfig
     * @request GET:/api/v1/report/config
     */
    export namespace GetConfig {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = ReportConfigurationDto;
    }

    /**
     * No description
     * @tags Report
     * @name SaveConfig
     * @request POST:/api/v1/report/config
     */
    export namespace SaveConfig {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = SaveReportConfigDto;
        export type RequestHeaders = {};
        export type ResponseBody = ReportConfigurationDto;
    }
}

export namespace GoogleMaps {
    /**
     * No description
     * @tags Google Maps
     * @name Autocomplete
     * @request GET:/api/v1/google-maps/autocomplete
     */
    export namespace Autocomplete {
        export type RequestParams = {};
        export type RequestQuery = {
            input: string;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = AutocompleteResultDto[];
    }

    /**
     * No description
     * @tags Google Maps
     * @name PlaceDetails
     * @request GET:/api/v1/google-maps/place/{placeId}
     */
    export namespace PlaceDetails {
        export type RequestParams = {
            placeId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = PlaceDetailsDto;
    }
}

export namespace CustomMedication {
    /**
     * No description
     * @tags custom-medication
     * @name Create
     * @request POST:/api/v1/custom-medication
     */
    export namespace Create {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = CreateCustomMedicationDto;
        export type RequestHeaders = {};
        export type ResponseBody = CustomMedicationDto;
    }

    /**
     * No description
     * @tags custom-medication
     * @name List
     * @request GET:/api/v1/custom-medication
     */
    export namespace List {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CustomMedicationDto[];
    }

    /**
     * No description
     * @tags custom-medication
     * @name Get
     * @request GET:/api/v1/custom-medication/{id}
     */
    export namespace Get {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = CustomMedicationDto;
    }

    /**
     * No description
     * @tags custom-medication
     * @name Update
     * @request PATCH:/api/v1/custom-medication/{id}
     */
    export namespace Update {
        export type RequestParams = {
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = UpdateCustomMedicationDto;
        export type RequestHeaders = {};
        export type ResponseBody = CustomMedicationDto;
    }
}

export namespace LocalJanitor {
    /**
     * No description
     * @tags LocalJanitor
     * @name RunCycle
     * @request POST:/api/dev/janitor/run
     */
    export namespace RunCycle {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = void;
    }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];

                if (Array.isArray(property) && property.every((p) => p instanceof Blob)) {
                    property.forEach((prop) => formData.append(key, prop));
                } else {
                    formData.append(
                        key,
                        property instanceof Blob
                            ? property
                            : typeof property === 'object' && property !== null
                              ? JSON.stringify(property)
                              : `${property}`,
                    );
                }
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    };

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title Musa EHR
 * @version 1.0
 * @contact
 *
 * The Musa EHR API documentation.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    organization = {
        /**
         * No description
         *
         * @tags Organization
         * @name Create
         * @request POST:/api/v1/organization
         */
        create: (data: CreateOrganizationDto, params: RequestParams = {}) =>
            this.request<JobDto, any>({
                path: `/api/v1/organization`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Organization
         * @name Get
         * @request GET:/api/v1/organization
         */
        get: (params: RequestParams = {}) =>
            this.request<OrganizationListItemDto[], any>({
                path: `/api/v1/organization`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Organization
         * @name GetOne
         * @request GET:/api/v1/organization/{id}
         */
        getOne: (id: string, params: RequestParams = {}) =>
            this.request<OrganizationDto, any>({
                path: `/api/v1/organization/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Organization
         * @name Deactivate
         * @request PATCH:/api/v1/organization/{id}/deactivate
         */
        deactivate: (id: string, data: DeactivateOrganizationDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/organization/${id}/deactivate`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Organization
         * @name Reactivate
         * @request PATCH:/api/v1/organization/{id}/reactivate
         */
        reactivate: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/organization/${id}/reactivate`,
                method: 'PATCH',
                ...params,
            }),
    };
    jobs = {
        /**
         * No description
         *
         * @tags Jobs
         * @name GetStatus
         * @request GET:/api/v1/jobs/{jobId}/status
         */
        getStatus: (jobId: string, params: RequestParams = {}) =>
            this.request<JobStatusDto, any>({
                path: `/api/v1/jobs/${jobId}/status`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    adminFeatureFlags = {
        /**
         * @description Returns all feature flags from enums with their current states and organization-specific overrides. Includes flags that don't yet exist in the database.
         *
         * @tags Admin Feature Flags
         * @name ListAll
         * @summary List all feature flags with organization states
         * @request GET:/api/admin/feature-flag
         */
        listAll: (params: RequestParams = {}) =>
            this.request<FeatureFlagListResponseDto, any>({
                path: `/api/admin/feature-flag`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Updates the global status of a feature flag. Creates the flag record if it doesn't exist in the database yet.
         *
         * @tags Admin Feature Flags
         * @name SetGlobal
         * @summary Update global feature flag status
         * @request PUT:/api/admin/feature-flag/{key}
         */
        setGlobal: (
            key:
                | 'example-feature-flag'
                | 'report-feature-flag'
                | 'dashboard'
                | 'insurance-authorizations'
                | 'grouper-0120206'
                | 'scheduling-dashboard'
                | 'clinical-dashboard'
                | 'intake-dashboard',
            data: SetGlobalStatusDto,
            params: RequestParams = {},
        ) =>
            this.request<FeatureFlagListItemDto, void>({
                path: `/api/admin/feature-flag/${key}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description Updates the state for a specific organization. Only works with organization-scoped flags. Creates the flag record if it doesn't exist.
         *
         * @tags Admin Feature Flags
         * @name SetOrg
         * @summary Update organization-specific feature flag state
         * @request PUT:/api/admin/feature-flag/{key}/organization/{orgId}
         */
        setOrg: (
            key:
                | 'example-feature-flag'
                | 'report-feature-flag'
                | 'dashboard'
                | 'insurance-authorizations'
                | 'grouper-0120206'
                | 'scheduling-dashboard'
                | 'clinical-dashboard'
                | 'intake-dashboard',
            orgId: string,
            data: SetOrgStateDto,
            params: RequestParams = {},
        ) =>
            this.request<
                {
                    /** @format uuid */
                    organizationId?: string;
                    state?: 'enabled' | 'disabled' | 'inherit';
                },
                void
            >({
                path: `/api/admin/feature-flag/${key}/organization/${orgId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    adminAuditLogs = {
        /**
         * @description Retrieves audit logs with pagination and filtering. Can query both organization-specific logs and anonymous events (using "management" as organizationId). Supports filtering by date range, event name, status, and user ID.
         *
         * @tags Admin Audit Logs
         * @name GetAuditLogs
         * @summary Get paginated audit logs
         * @request GET:/api/admin/audit
         */
        getAuditLogs: (query: GetAuditLogsParams, params: RequestParams = {}) =>
            this.request<AuditLogResponseDto, void>({
                path: `/api/admin/audit`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * @description Retrieves aggregated statistics for audit logs including: total event count, status breakdown, top event types, and time series data. Respects the same filters as the main audit log endpoint.
         *
         * @tags Admin Audit Logs
         * @name GetAuditStats
         * @summary Get audit log statistics
         * @request GET:/api/admin/audit/stats
         */
        getAuditStats: (query: GetAuditStatsParams, params: RequestParams = {}) =>
            this.request<AuditStatsDto, void>({
                path: `/api/admin/audit/stats`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * @description Search users by first name, last name, or email within an organization for audit log filtering
         *
         * @tags Admin Audit Logs
         * @name SearchUsers
         * @summary Search users for filtering
         * @request GET:/api/admin/audit/users/search
         */
        searchUsers: (query: SearchUsersParams, params: RequestParams = {}) =>
            this.request<UserSearchResultDto[], void>({
                path: `/api/admin/audit/users/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    enquiry = {
        /**
         * No description
         *
         * @tags Enquiry
         * @name List
         * @request GET:/api/v1/admin/enquiry
         */
        list: (params: RequestParams = {}) =>
            this.request<EnquiryDto[], any>({
                path: `/api/v1/admin/enquiry`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Enquiry
         * @name Create
         * @request POST:/api/v1/enquiry
         */
        create: (data: PublicCreateEnquiryDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/enquiry`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    adminLlmConfig = {
        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListFeatureRegistry
         * @summary List feature types registered by the backend
         * @request GET:/api/v1/admin/llm-config/features
         */
        listFeatureRegistry: (params: RequestParams = {}) =>
            this.request<FeatureRegistryEntryDto[], any>({
                path: `/api/v1/admin/llm-config/features`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListOrgStatuses
         * @summary Per-org rollup health for the org list page
         * @request GET:/api/v1/admin/llm-config/org-statuses
         */
        listOrgStatuses: (params: RequestParams = {}) =>
            this.request<OrgFeatureHealthDto[], any>({
                path: `/api/v1/admin/llm-config/org-statuses`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListPricing
         * @summary List LLM model pricing rows (current + history)
         * @request GET:/api/v1/admin/llm-config/pricing
         */
        listPricing: (params: RequestParams = {}) =>
            this.request<PricingEntryDto[], any>({
                path: `/api/v1/admin/llm-config/pricing`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListConfigs
         * @summary List feature configs for an org
         * @request GET:/api/v1/admin/llm-config/{orgId}
         */
        listConfigs: (orgId: string, params: RequestParams = {}) =>
            this.request<LlmFeatureConfigDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name UpsertConfig
         * @summary Create or update a feature config
         * @request PUT:/api/v1/admin/llm-config/{orgId}/{featureType}
         */
        upsertConfig: (orgId: string, featureType: string, data: UpsertLlmConfigBodyDto, params: RequestParams = {}) =>
            this.request<LlmFeatureConfigDto, any>({
                path: `/api/v1/admin/llm-config/${orgId}/${featureType}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name DeleteConfig
         * @summary Delete a feature config (disables feature for org)
         * @request DELETE:/api/v1/admin/llm-config/{orgId}/{featureType}
         */
        deleteConfig: (orgId: string, featureType: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/admin/llm-config/${orgId}/${featureType}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name GetUsageSummary
         * @summary Get current usage bucket summary
         * @request GET:/api/v1/admin/llm-config/{orgId}/usage
         */
        getUsageSummary: (orgId: string, params: RequestParams = {}) =>
            this.request<UsageSummaryDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}/usage`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name GetUsageHistory
         * @summary Get historical usage aggregated by date range and granularity
         * @request GET:/api/v1/admin/llm-config/{orgId}/usage/history
         */
        getUsageHistory: ({ orgId, ...query }: GetUsageHistoryParams, params: RequestParams = {}) =>
            this.request<UsageHistoryPointDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}/usage/history`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListRecentCalls
         * @summary List recent LLM calls for an org, optionally filtered by featureType
         * @request GET:/api/v1/admin/llm-config/{orgId}/calls
         */
        listRecentCalls: ({ orgId, ...query }: ListRecentCallsParams, params: RequestParams = {}) =>
            this.request<LlmCallSummaryDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}/calls`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name ListSublimits
         * @summary List sub-limit configs for an org
         * @request GET:/api/v1/admin/llm-config/{orgId}/sublimits
         */
        listSublimits: (orgId: string, params: RequestParams = {}) =>
            this.request<LlmSublimitConfigDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}/sublimits`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name UpsertSublimit
         * @summary Upsert a sub-limit config row keyed by (org, feature, attributeKey)
         * @request PUT:/api/v1/admin/llm-config/{orgId}/{featureType}/sublimit/{attributeKey}
         */
        upsertSublimit: (
            orgId: string,
            featureType: string,
            attributeKey: string,
            data: UpsertSublimitBodyDto,
            params: RequestParams = {},
        ) =>
            this.request<LlmSublimitConfigDto, any>({
                path: `/api/v1/admin/llm-config/${orgId}/${featureType}/sublimit/${attributeKey}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name DeleteSublimit
         * @summary Delete a sub-limit config row (cap stops applying immediately)
         * @request DELETE:/api/v1/admin/llm-config/{orgId}/{featureType}/sublimit/{attributeKey}
         */
        deleteSublimit: (orgId: string, featureType: string, attributeKey: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/admin/llm-config/${orgId}/${featureType}/sublimit/${attributeKey}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admin LLM Config
         * @name GetSublimitUsage
         * @summary Top-N attribute consumers per (feature, attributeKey) for an org
         * @request GET:/api/v1/admin/llm-config/{orgId}/sublimit-usage
         */
        getSublimitUsage: (orgId: string, params: RequestParams = {}) =>
            this.request<SublimitUsageDto[], any>({
                path: `/api/v1/admin/llm-config/${orgId}/sublimit-usage`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    staff = {
        /**
         * No description
         *
         * @tags staff
         * @name FindOne
         * @request GET:/api/v1/staff/{staffId}
         */
        findOne: (staffId: string, params: RequestParams = {}) =>
            this.request<StaffDto, any>({
                path: `/api/v1/staff/${staffId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags staff
         * @name Get
         * @request GET:/api/v1/branch/{branchId}/staff
         */
        get: ({ branchId, ...query }: GetParams1, params: RequestParams = {}) =>
            this.request<StaffDto[], any>({
                path: `/api/v1/branch/${branchId}/staff`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    referenceData = {
        /**
         * No description
         *
         * @tags ReferenceData
         * @name GetDemographicData
         * @request GET:/api/v1/reference-data/demographic
         */
        getDemographicData: (params: RequestParams = {}) =>
            this.request<DemographicDataDto, any>({
                path: `/api/v1/reference-data/demographic`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ReferenceData
         * @name SearchDiagnoses
         * @request GET:/api/v1/reference-data/diagnoses
         */
        searchDiagnoses: (query: SearchDiagnosesParams, params: RequestParams = {}) =>
            this.request<SearchDiagnosisDataDto[], any>({
                path: `/api/v1/reference-data/diagnoses`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ReferenceData
         * @name SearchMedications
         * @request GET:/api/v1/reference-data/medications
         */
        searchMedications: (query: SearchMedicationsParams, params: RequestParams = {}) =>
            this.request<SearchMedicationResponseDto[], any>({
                path: `/api/v1/reference-data/medications`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ReferenceData
         * @name GetSupplyData
         * @request GET:/api/v1/reference-data/supplies
         */
        getSupplyData: (params: RequestParams = {}) =>
            this.request<SupplyDto[], any>({
                path: `/api/v1/reference-data/supplies`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    patient = {
        /**
         * No description
         *
         * @tags patient
         * @name Create
         * @request POST:/api/v1/branch/{branchId}/patient
         */
        create: (branchId: string, data: CreatePatientDto | ExistingPatientDto, params: RequestParams = {}) =>
            this.request<AdmissionDto, any>({
                path: `/api/v1/branch/${branchId}/patient`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags patient
         * @name GetForBranch
         * @request GET:/api/v1/branch/{branchId}/patient
         */
        getForBranch: ({ branchId, ...query }: GetForBranchParams, params: RequestParams = {}) =>
            this.request<PatientListResponseDto, any>({
                path: `/api/v1/branch/${branchId}/patient`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags patient
         * @name Update
         * @request PUT:/api/v1/branch/{branchId}/patient/{patientId}
         */
        update: (patientId: string, branchId: string, data: UpdatePatientDto, params: RequestParams = {}) =>
            this.request<AdmissionPatientDto, any>({
                path: `/api/v1/branch/${branchId}/patient/${patientId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags patient
         * @name Get
         * @request GET:/api/v1/patient
         */
        get: (query: GetParams3, params: RequestParams = {}) =>
            this.request<PatientListResponseDto, any>({
                path: `/api/v1/patient`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags patient
         * @name GenerateAuthReleasePdf
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/auth-release-pdf
         */
        generateAuthReleasePDF: (formId: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/form/${formId}/auth-release-pdf`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags patient
         * @name GenerateProfilePdf
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/profile-pdf
         */
        generateProfilePdf: (admissionId: string, branchId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/profile-pdf`,
                method: 'GET',
                ...params,
            }),
    };
    communication = {
        /**
         * No description
         *
         * @tags Communication
         * @name List
         * @request GET:/api/v1/communication/branch/{branchId}/admission/{admissionId}
         */
        list: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto[], any>({
                path: `/api/v1/communication/branch/${branchId}/admission/${admissionId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Create
         * @request POST:/api/v1/communication/branch/{branchId}/admission/{admissionId}
         */
        create: (branchId: string, admissionId: string, data: CreateCommunicationNoteDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/admission/${admissionId}`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Get
         * @request GET:/api/v1/communication/branch/{branchId}/{id}
         */
        get: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Update
         * @request PUT:/api/v1/communication/branch/{branchId}/{id}
         */
        update: (branchId: string, id: string, data: CreateCommunicationNoteDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Delete
         * @request DELETE:/api/v1/communication/branch/{branchId}/{id}
         */
        delete: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Submit
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/submit
         */
        submit: (branchId: string, id: string, data: SubmitCommunicationNoteDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/submit`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Approve
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/approve
         */
        approve: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/approve`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name RequestChanges
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/request-changes
         */
        requestChanges: (branchId: string, id: string, data: RequestChangesDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/request-changes`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Resubmit
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/resubmit
         */
        resubmit: (branchId: string, id: string, data: CreateCommunicationNoteDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/resubmit`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Reassign
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/reassign
         */
        reassign: (branchId: string, id: string, data: ReassignCommunicationNoteDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/reassign`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Archive
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/archive
         */
        archive: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/archive`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name Restore
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/restore
         */
        restore: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/restore`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name ConfirmVerbalOrder
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/confirm
         */
        confirmVerbalOrder: (branchId: string, id: string, data: ConfirmVerbalOrderDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Communication
         * @name LinkOrder
         * @request POST:/api/v1/communication/branch/{branchId}/{id}/link-order
         */
        linkOrder: (branchId: string, id: string, data: LinkOrderDto, params: RequestParams = {}) =>
            this.request<CommunicationNoteDto, any>({
                path: `/api/v1/communication/branch/${branchId}/${id}/link-order`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientDemographics = {
        /**
         * No description
         *
         * @tags PatientDemographics
         * @name Update
         * @request PATCH:/api/v1/branch/{branchId}/patient/{patientId}/demographics
         */
        update: (branchId: string, patientId: string, data: UpdateDemographicsDto, params: RequestParams = {}) =>
            this.request<DemographicsDto, any>({
                path: `/api/v1/branch/${branchId}/patient/${patientId}/demographics`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientAdmissionDiagnosis = {
        /**
         * No description
         *
         * @tags PatientAdmissionDiagnosis
         * @name Update
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/diagnosis
         */
        update: (branchId: string, admissionId: string, data: UpdateDiagnosisDto[], params: RequestParams = {}) =>
            this.request<DiagnosisDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/diagnosis`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientAdmissionReferral = {
        /**
         * No description
         *
         * @tags PatientAdmissionReferral
         * @name Update
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/referral
         */
        update: (branchId: string, admissionId: string, data: UpdateReferralDto, params: RequestParams = {}) =>
            this.request<ReferralDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/referral`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    admissionInsurance = {
        /**
         * No description
         *
         * @tags AdmissionInsurance
         * @name AddInsurance
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurance
         */
        addInsurance: ({ branchId, admissionId, ...query }: AddInsuranceParams, data: CreateInsuranceDto, params: RequestParams = {}) =>
            this.request<AdmissionInsuranceDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurance`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionInsurance
         * @name DeleteInsurance
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{id}
         */
        deleteInsurance: (branchId: string, admissionId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurance/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionInsurance
         * @name MakePrimary
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{id}/primary
         */
        makePrimary: (branchId: string, admissionId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurance/${id}/primary`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionInsurance
         * @name CheckEligibility
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{insuranceId}/eligibility-check
         */
        checkEligibility: (branchId: string, admissionId: string, insuranceId: string, params: RequestParams = {}) =>
            this.request<EligibilityDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurance/${insuranceId}/eligibility-check`,
                method: 'PUT',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionInsurance
         * @name UpdateEligibility
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/insurance/{insuranceId}/eligibility
         */
        updateEligibility: (
            branchId: string,
            admissionId: string,
            insuranceId: string,
            data: UpdateEligibilityDto,
            params: RequestParams = {},
        ) =>
            this.request<EligibilityDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurance/${insuranceId}/eligibility`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    stedi = {
        /**
         * No description
         *
         * @tags stedi
         * @name GetInboxTransaction
         * @request GET:/api/v1/inbox-transaction/branch/{branchId}/transaction/{transactionId}/year/{year}
         */
        getInboxTransaction: (branchId: string, transactionId: string, year: string, params: RequestParams = {}) =>
            this.request<SingleInboxTransactionDto, any>({
                path: `/api/v1/inbox-transaction/branch/${branchId}/transaction/${transactionId}/year/${year}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags stedi
         * @name GetInboxTransactions
         * @request GET:/api/v1/inbox-transactions
         */
        getInboxTransactions: (params: RequestParams = {}) =>
            this.request<InboxTransactionsDto, any>({
                path: `/api/v1/inbox-transactions`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    insurance = {
        /**
         * No description
         *
         * @tags Insurance
         * @name GetNewConfigFormData
         * @request GET:/api/v1/config/form
         */
        getNewConfigFormData: (query: GetNewConfigFormDataParams, params: RequestParams = {}) =>
            this.request<InsuranceConfigFormDataDto, any>({
                path: `/api/v1/config/form`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name GetConfigFormData
         * @request GET:/api/v1/config/{id}/form
         */
        getConfigFormData: (id: string, params: RequestParams = {}) =>
            this.request<InsuranceConfigFormDataDto, any>({
                path: `/api/v1/config/${id}/form`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name GetConfigContractHistory
         * @request GET:/api/v1/config/{id}/contract-history
         */
        getConfigContractHistory: (id: string, params: RequestParams = {}) =>
            this.request<InsuranceConfigContractHistoryItemDto[], any>({
                path: `/api/v1/config/${id}/contract-history`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name GetConfig
         * @request GET:/api/v1/config/{id}
         */
        getConfig: (id: string, params: RequestParams = {}) =>
            this.request<InsuranceConfigDto, any>({
                path: `/api/v1/config/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name DeleteConfig
         * @request DELETE:/api/v1/config/{id}
         */
        deleteConfig: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/config/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name SaveConfig
         * @request POST:/api/v1/config
         */
        saveConfig: (data: SaveInsuranceConfigDto, params: RequestParams = {}) =>
            this.request<InsuranceConfigDto, any>({
                path: `/api/v1/config`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name ListConfigs
         * @request GET:/api/v1/configs
         */
        listConfigs: (params: RequestParams = {}) =>
            this.request<InsuranceConfigListItemDto[], any>({
                path: `/api/v1/configs`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Insurance
         * @name DismissPendingPayer
         * @request DELETE:/api/v1/pending/{insuranceId}
         */
        dismissPendingPayer: (insuranceId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/pending/${insuranceId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags insurance
         * @name InsuranceSearch
         * @request GET:/api/v1/insurance/search
         */
        insuranceSearch: (query: InsuranceSearchParams, params: RequestParams = {}) =>
            this.request<InsuranceProviderDto[], any>({
                path: `/api/v1/insurance/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    visit = {
        /**
         * No description
         *
         * @tags Visit
         * @name GetVisits
         * @request GET:/api/v1/visit
         */
        getVisits: (params: RequestParams = {}) =>
            this.request<VisitDto[], any>({
                path: `/api/v1/visit`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name GetPatientsForVisit
         * @request GET:/api/v1/branch/{branchId}/visit/patient
         */
        getPatientsForVisit: (branchId: string, params: RequestParams = {}) =>
            this.request<PatientDto[], any>({
                path: `/api/v1/branch/${branchId}/visit/patient`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name GetEpisodeVisits
         * @request GET:/api/v1/branch/{branchId}/episode/{episodeId}
         */
        getEpisodeVisits: (branchId: string, episodeId: string, params: RequestParams = {}) =>
            this.request<VisitDto[], any>({
                path: `/api/v1/branch/${branchId}/episode/${episodeId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name CreateVisitsForEpisode
         * @request POST:/api/v1/branch/{branchId}/episode/{episodeId}/visit
         */
        createVisitsForEpisode: (branchId: string, episodeId: string, data: CreateVisitDto[], params: RequestParams = {}) =>
            this.request<VisitDto[], any>({
                path: `/api/v1/branch/${branchId}/episode/${episodeId}/visit`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name CreateVisitsForAdmission
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit
         */
        createVisitsForAdmission: (branchId: string, admissionId: string, data: CreateVisitDto[], params: RequestParams = {}) =>
            this.request<VisitDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name CreateVisitsForPatient
         * @request POST:/api/v1/branch/{branchId}/patient/{patientId}/visit
         */
        createVisitsForPatient: (branchId: string, patientId: string, data: CreateVisitDto[], params: RequestParams = {}) =>
            this.request<VisitDto[], any>({
                path: `/api/v1/branch/${branchId}/patient/${patientId}/visit`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name UpdateVisits
         * @request PATCH:/api/v1/branch/{branchId}/episode/{episodeId}/visit/{id}
         */
        updateVisits: (branchId: string, episodeId: string, id: string, data: UpdateVisitDto, params: RequestParams = {}) =>
            this.request<VisitDto, any>({
                path: `/api/v1/branch/${branchId}/episode/${episodeId}/visit/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name DeleteVisit
         * @request DELETE:/api/v1/branch/{branchId}/episode/{episodeId}/visit/{id}
         */
        deleteVisit: (branchId: string, episodeId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/episode/${episodeId}/visit/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name GetPatientVisits
         * @request GET:/api/v2/visit
         */
        getPatientVisits: (params: RequestParams = {}) =>
            this.request<VisitSummaryDto[], any>({
                path: `/api/v2/visit`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Visit
         * @name GetVisitDetails
         * @request GET:/api/v2/branch/{branchId}/visit/{id}
         */
        getVisitDetails: (id: string, branchId: string, params: RequestParams = {}) =>
            this.request<VisitDto, any>({
                path: `/api/v2/branch/${branchId}/visit/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    upcomingVisit = {
        /**
         * No description
         *
         * @tags UpcomingVisit
         * @name Get
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/upcoming-visits
         */
        get: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<UpcomingVisitDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/upcoming-visits`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    insuranceAuthorization = {
        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name List
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations
         */
        list: ({ branchId, admissionId, ...query }: ListParams2, params: RequestParams = {}) =>
            this.request<AuthorizationDetailsDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name Create
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/{insuranceId}/authorizations
         */
        create: (branchId: string, admissionId: string, insuranceId: string, data: CreateAuthorizationDto, params: RequestParams = {}) =>
            this.request<AuthorizationDetailsDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/${insuranceId}/authorizations`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/{insuranceId}/authorizations/{authId}
         */
        delete: ({ branchId, admissionId, insuranceId, authId, ...query }: DeleteParams1, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/${insuranceId}/authorizations/${authId}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name PreviewLink
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/link/preview
         */
        previewLink: (branchId: string, admissionId: string, authId: string, visitId: string, params: RequestParams = {}) =>
            this.request<LinkImpactDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/visits/${visitId}/link/preview`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name LinkVisit
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/link
         */
        linkVisit: (branchId: string, admissionId: string, authId: string, visitId: string, params: RequestParams = {}) =>
            this.request<LinkVisitDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/visits/${visitId}/link`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name PreviewUnlink
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/unlink/preview
         */
        previewUnlink: (branchId: string, admissionId: string, visitId: string, authId: string, params: RequestParams = {}) =>
            this.request<LinkImpactDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/visits/${visitId}/unlink/preview`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name UnlinkVisit
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/visits/{visitId}/unlink
         */
        unlinkVisit: (branchId: string, admissionId: string, visitId: string, authId: string, params: RequestParams = {}) =>
            this.request<LinkVisitDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/visits/${visitId}/unlink`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name DismissAuthorization
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/dismiss
         */
        dismissAuthorization: (
            authId: string,
            branchId: string,
            admissionId: string,
            data: CreateAuthorizationDismissalDto,
            params: RequestParams = {},
        ) =>
            this.request<AuthorizationDismissalDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/dismiss`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorization
         * @name UndismissAuthorization
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/insurances/authorizations/{authId}/dismiss
         */
        undismissAuthorization: (authId: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/insurances/authorizations/${authId}/dismiss`,
                method: 'DELETE',
                ...params,
            }),
    };
    insuranceAuthorizationCompliance = {
        /**
         * No description
         *
         * @tags InsuranceAuthorizationCompliance
         * @name GetInsuranceAuthCompliance
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/authorizations/compliance
         */
        getInsuranceAuthCompliance: (branchId: string, admissionId: string, data: EvaluateComplianceDto, params: RequestParams = {}) =>
            this.request<ComplianceResultDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/authorizations/compliance`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InsuranceAuthorizationCompliance
         * @name GetInsuranceAuthComplianceSummary
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/authorizations/compliance/summary
         */
        getInsuranceAuthComplianceSummary: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<AuthorizationComplianceDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/authorizations/compliance/summary`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    patientOverview = {
        /**
         * No description
         *
         * @tags PatientOverview
         * @name Get
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/overview
         */
        get: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<OverviewPatientDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/overview`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    visitForm = {
        /**
         * No description
         *
         * @tags VisitForm
         * @name Save
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form
         */
        save: ({ branchId, admissionId, ...query }: SaveParams, data: SaveVisitFormDto, params: RequestParams = {}) =>
            this.request<SaveVisitFormResponseDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form`,
                method: 'PUT',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name List
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form
         */
        list: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<VisitFormDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name UpdateStatus
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/status
         */
        updateStatus: (branchId: string, formId: string, admissionId: string, data: UpdateFormStatusDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/status`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name EnterDocumentation
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/enter-documentation
         */
        enterDocumentation: (branchId: string, formId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/enter-documentation`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name SaveCarryForwardSection
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/carry-forward-section
         */
        saveCarryForwardSection: (
            branchId: string,
            admissionId: string,
            formId: string,
            data: SaveCarryForwardSectionDto,
            params: RequestParams = {},
        ) =>
            this.request<SaveVisitFormResponseDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/carry-forward-section`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name DeleteDraft
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}
         */
        deleteDraft: (branchId: string, admissionId: string, formId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name Get
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{id}
         */
        get: (id: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<VisitFormDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name FormNotes
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/notes
         */
        formNotes: (formId: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<FormNotesDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/notes`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name SaveNote
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/notes
         */
        saveNote: (branchId: string, formId: string, admissionId: string, data: SaveFormNotesDto, params: RequestParams = {}) =>
            this.request<SaveFormNotesDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/notes`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name Amend
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit-form/{formId}/amend
         */
        amend: (branchId: string, admissionId: string, formId: string, data: CreateFormAmendDto, params: RequestParams = {}) =>
            this.request<FormAmendDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit-form/${formId}/amend`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name GetDraftPhysicianOrder
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/physician-order/draft
         */
        getDraftPhysicianOrder: (branchId: string, admissionId: string, visitId: string, params: RequestParams = {}) =>
            this.request<VisitFormDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit/${visitId}/physician-order/draft`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitForm
         * @name CreatePhysicianOrder
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/physician-order
         */
        createPhysicianOrder: (branchId: string, admissionId: string, visitId: string, params: RequestParams = {}) =>
            this.request<VisitFormDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit/${visitId}/physician-order`,
                method: 'POST',
                format: 'json',
                ...params,
            }),
    };
    oasis = {
        /**
         * No description
         *
         * @tags Oasis
         * @name GenerateXml
         * @request GET:/api/v1/oasis/branch/{branchId}/form/{formId}
         */
        generateXML: (branchId: string, formId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/oasis/branch/${branchId}/form/${formId}`,
                method: 'GET',
                ...params,
            }),
    };
    billing = {
        /**
         * No description
         *
         * @tags billing
         * @name Get
         * @request GET:/api/v1/billing/claim/inbox/{name}
         */
        get: (name: string, params: RequestParams = {}) =>
            this.request<BillingDto, any>({
                path: `/api/v1/billing/claim/inbox/${name}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GetClaims
         * @request GET:/api/v1/billing/claim
         */
        getClaims: (params: RequestParams = {}) =>
            this.request<ClaimDto[], any>({
                path: `/api/v1/billing/claim`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GetSentClaims
         * @request GET:/api/v1/billing/claim/sent
         */
        getSentClaims: (params: RequestParams = {}) =>
            this.request<ClaimSentDto[], any>({
                path: `/api/v1/billing/claim/sent`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GetClaim
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}
         */
        getClaim: (branchId: string, admissionId: string, id: string, params: RequestParams = {}) =>
            this.request<ClaimDetailsDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name DeleteClaim
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}
         */
        deleteClaim: (branchId: string, admissionId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GenerateClaimPdf
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/pdf
         */
        generateClaimPdf: ({ branchId, admissionId, id, ...query }: GenerateClaimPdfParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${id}/pdf`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GetPatientClaims
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim
         */
        getPatientClaims: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<ClaimDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name GetSentClaim
         * @request GET:/api/v1/billing/claim/{claimId}/sent
         */
        getSentClaim: (claimId: string, params: RequestParams = {}) =>
            this.request<ClaimSentDetailsDto[], any>({
                path: `/api/v1/billing/claim/${claimId}/sent`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name AddOccurrenceCode
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/occurrence-code
         */
        addOccurrenceCode: (
            branchId: string,
            admissionId: string,
            claimId: string,
            data: CreateOccurrenceCode,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/occurrence-code`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name RemoveOccurrenceCode
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/occurrence-code/{id}
         */
        removeOccurrenceCode: (branchId: string, admissionId: string, claimId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/occurrence-code/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name AddConditionCode
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/condition-code
         */
        addConditionCode: (branchId: string, admissionId: string, id: string, data: CreateConditionCode, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${id}/condition-code`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name RemoveConditionCode
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/condition-code/{id}
         */
        removeConditionCode: (branchId: string, admissionId: string, claimId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/condition-code/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name AddValueCode
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{id}/visit-code
         */
        addValueCode: (branchId: string, admissionId: string, id: string, data: CreateValueCodeDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${id}/visit-code`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name RemoveValueCode
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/visit-code/{id}
         */
        removeValueCode: (branchId: string, admissionId: string, claimId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/visit-code/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name RemoveService
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/service/{id}
         */
        removeService: (branchId: string, admissionId: string, claimId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/service/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name AddService
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/service/{id}
         */
        addService: (branchId: string, admissionId: string, claimId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/service/${id}`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name UpdateAdmissionDetails
         * @request PATCH:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/admission
         */
        updateAdmissionDetails: (
            branchId: string,
            admissionId: string,
            claimId: string,
            data: UpdateAdmissionDetailsDto,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/admission`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name UpdateClaimRemarks
         * @request PATCH:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/{claimId}/remarks
         */
        updateClaimRemarks: (
            branchId: string,
            admissionId: string,
            claimId: string,
            data: UpdateClaimRemarksDto,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/${claimId}/remarks`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name SubmitClaims
         * @request PUT:/api/v1/billing/claim/submit
         */
        submitClaims: (data: SubmitClaimDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/billing/claim/submit`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name SubmitClaim
         * @request PUT:/api/v1/branch/{branchId}/billing/claim/{id}/submit
         */
        submitClaim: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/billing/claim/${id}/submit`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name CancelClaim
         * @request POST:/api/v1/branch/{branchId}/billing/claim/{id}/cancel
         */
        cancelClaim: (branchId: string, id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/billing/claim/${id}/cancel`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name CreateSingleClaim
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/create-draft
         */
        createSingleClaim: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<CreateSingleClaimDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/create-draft`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name EditClaimDetails
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/billing/claim/edit-claim-details
         */
        editClaimDetails: (branchId: string, admissionId: string, data: EditClaimDetailsDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/billing/claim/edit-claim-details`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    hipps = {
        /**
         * No description
         *
         * @tags hipps
         * @name GetHippsAuditDetails
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/visit/{visitId}/hipps-audit
         */
        getHippsAuditDetails: ({ branchId, admissionId, visitId, ...query }: GetHippsAuditDetailsParams, params: RequestParams = {}) =>
            this.request<HippsAuditDetailsDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/visit/${visitId}/hipps-audit`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    admission = {
        /**
         * No description
         *
         * @tags Admission
         * @name Get
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}
         */
        get: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<AdmissionDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name SubmitIntake
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}
         */
        submitIntake: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<AdmissionDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}`,
                method: 'PUT',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name Upload
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload
         */
        upload: (
            { admissionId, branchId, ...query }: UploadParams,
            data: {
                files?: File[];
                metadata?: {
                    title?: string;
                    notes?: string;
                }[];
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file/upload`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name UploadRequest
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload-request
         */
        uploadRequest: (branchId: string, admissionId: string, data: FileUploadRequestDto[], params: RequestParams = {}) =>
            this.request<FileUploadResponseDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file/upload-request`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name UploadRequestConfirm
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/file/upload-request/confirm
         */
        uploadRequestConfirm: (branchId: string, admissionId: string, data: FileUploadConfirmRequestDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file/upload-request/confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name UpdateFile
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/file/{id}
         */
        updateFile: (id: string, branchId: string, admissionId: string, data: FileMetadataDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file/${id}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name DeleteFile
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/file/{id}
         */
        deleteFile: (id: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name GetFiles
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/file
         */
        getFiles: (admissionId: string, branchId: string, params: RequestParams = {}) =>
            this.request<FileDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/file`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name GetDocumentRequests
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/document-request
         */
        getDocumentRequests: (admissionId: string, branchId: string, params: RequestParams = {}) =>
            this.request<AdmissionDocumentRequestDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name CreateDocumentRequest
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/document-request
         */
        createDocumentRequest: (admissionId: string, branchId: string, data: CreateDocumentRequestDto, params: RequestParams = {}) =>
            this.request<AdmissionDocumentRequestDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name FulfillDocumentRequest
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/fulfill
         */
        fulfillDocumentRequest: (
            admissionId: string,
            requestId: string,
            branchId: string,
            data: FulfillDocumentRequestDto,
            params: RequestParams = {},
        ) =>
            this.request<AdmissionDocumentRequestDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request/${requestId}/fulfill`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name CancelDocumentRequest
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/cancel
         */
        cancelDocumentRequest: (admissionId: string, requestId: string, branchId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request/${requestId}/cancel`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name UnfulfillDocumentRequest
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/unfulfill
         */
        unfulfillDocumentRequest: (admissionId: string, requestId: string, branchId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request/${requestId}/unfulfill`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name GetDocumentNotes
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/note
         */
        getDocumentNotes: (admissionId: string, requestId: string, branchId: string, params: RequestParams = {}) =>
            this.request<AdmissionDocumentNoteDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request/${requestId}/note`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name CreateDocumentNote
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/document-request/{requestId}/note
         */
        createDocumentNote: (
            admissionId: string,
            requestId: string,
            branchId: string,
            data: CreateDocumentNoteDto,
            params: RequestParams = {},
        ) =>
            this.request<AdmissionDocumentNoteDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/document-request/${requestId}/note`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name NonAdmit
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/non-admit
         */
        nonAdmit: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/non-admit`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name RevertNonAdmit
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/revert-non-admit
         */
        revertNonAdmit: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/revert-non-admit`,
                method: 'PUT',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name GetAdmissionNotes
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note
         */
        getAdmissionNotes: (admissionId: string, branchId: string, params: RequestParams = {}) =>
            this.request<AdmissionNoteDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Admission
         * @name CreateAdmissionNote
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note
         */
        createAdmissionNote: (admissionId: string, branchId: string, data: CreateAdmissionNoteDto, params: RequestParams = {}) =>
            this.request<AdmissionNoteDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    qa = {
        /**
         * No description
         *
         * @tags Qa
         * @name List
         * @request GET:/api/v1/qa
         */
        list: (query: ListParams5, params: RequestParams = {}) =>
            this.request<QaListResponseDto, any>({
                path: `/api/v1/qa`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    logging = {
        /**
         * No description
         *
         * @tags Logging
         * @name LogError
         * @request POST:/api/log/error
         */
        logError: (data: LogErrorDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/log/error`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    featureFlags = {
        /**
         * @description Returns all feature flags with their evaluated boolean values for the current organization context.
         *
         * @tags Feature Flags
         * @name ListForOrg
         * @summary Get evaluated feature flags for current organization
         * @request GET:/api/feature-flag
         */
        listForOrg: (params: RequestParams = {}) =>
            this.request<FeatureFlagEvaluationListDto, any>({
                path: `/api/feature-flag`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    dashboard = {
        /**
         * No description
         *
         * @tags dashboard
         * @name GetCensusOverview
         * @request GET:/api/v1/dashboard/census-overview
         */
        getCensusOverview: (query: GetCensusOverviewParams, params: RequestParams = {}) =>
            this.request<CensusOverviewDto, any>({
                path: `/api/v1/dashboard/census-overview`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetDailyAverageCensus
         * @request GET:/api/v1/dashboard/daily-average-census
         */
        getDailyAverageCensus: (query: GetDailyAverageCensusParams, params: RequestParams = {}) =>
            this.request<DailyAverageCensusDto, any>({
                path: `/api/v1/dashboard/daily-average-census`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetCbsaReport
         * @request GET:/api/v1/dashboard/cbsa-report
         */
        getCbsaReport: (query: GetCbsaReportParams, params: RequestParams = {}) =>
            this.request<CbsaReportDto, any>({
                path: `/api/v1/dashboard/cbsa-report`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetAssessmentsStatus
         * @request GET:/api/v1/dashboard/assessments-status
         */
        getAssessmentsStatus: (query: GetAssessmentsStatusParams, params: RequestParams = {}) =>
            this.request<AssessmentsStatusResponseDto, any>({
                path: `/api/v1/dashboard/assessments-status`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetClinicians
         * @request GET:/api/v1/dashboard/clinicians
         */
        getClinicians: (query: GetCliniciansParams, params: RequestParams = {}) =>
            this.request<CliniciansResponseDto, any>({
                path: `/api/v1/dashboard/clinicians`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetAssessmentForms
         * @request GET:/api/v1/dashboard/assessment-forms
         */
        getAssessmentForms: (query: GetAssessmentFormsParams, params: RequestParams = {}) =>
            this.request<AssessmentFormsResponseDto, any>({
                path: `/api/v1/dashboard/assessment-forms`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetEpisodeManagement
         * @request GET:/api/v1/dashboard/episode-management
         */
        getEpisodeManagement: (query: GetEpisodeManagementParams, params: RequestParams = {}) =>
            this.request<EpisodeManagementResponseDto, any>({
                path: `/api/v1/dashboard/episode-management`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetTransfers
         * @request GET:/api/v1/dashboard/transfers
         */
        getTransfers: (query: GetTransfersParams, params: RequestParams = {}) =>
            this.request<TransferResponseDto, any>({
                path: `/api/v1/dashboard/transfers`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name GetAuthorizationExpirations
         * @request GET:/api/v1/dashboard/authorization-expirations
         */
        getAuthorizationExpirations: (query: GetAuthorizationExpirationsParams, params: RequestParams = {}) =>
            this.request<AuthorizationExpirationResponseDto, any>({
                path: `/api/v1/dashboard/authorization-expirations`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags dashboard
         * @name ExportAuthorizationExpirationsExcel
         * @request GET:/api/v1/dashboard/authorization-expirations/export/excel
         */
        exportAuthorizationExpirationsExcel: (query: ExportAuthorizationExpirationsExcelParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/dashboard/authorization-expirations/export/excel`,
                method: 'GET',
                query: query,
                ...params,
            }),
    };
    qaDashboard = {
        /**
         * No description
         *
         * @tags QA Dashboard
         * @name GetDashboard
         * @request GET:/api/v1/qa-dashboard
         */
        getDashboard: (query: GetDashboardParams, params: RequestParams = {}) =>
            this.request<QaDashboardDto, any>({
                path: `/api/v1/qa-dashboard`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
    clinicalDashboard = {
        /**
         * No description
         *
         * @tags Clinical Dashboard
         * @name GetTodayVisits
         * @request GET:/api/v1/clinical-dashboard/today-visits
         */
        getTodayVisits: (query: GetTodayVisitsParams, params: RequestParams = {}) =>
            this.request<TodayVisitsResponseDto, any>({
                path: `/api/v1/clinical-dashboard/today-visits`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Clinical Dashboard
         * @name GetOutstandingVisits
         * @request GET:/api/v1/clinical-dashboard/outstanding-visits
         */
        getOutstandingVisits: (query: GetOutstandingVisitsParams, params: RequestParams = {}) =>
            this.request<OutstandingVisitsResponseDto, any>({
                path: `/api/v1/clinical-dashboard/outstanding-visits`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Clinical Dashboard
         * @name GetRecentlySubmittedVisits
         * @request GET:/api/v1/clinical-dashboard/recently-submitted-visits
         */
        getRecentlySubmittedVisits: (query: GetRecentlySubmittedVisitsParams, params: RequestParams = {}) =>
            this.request<RecentlySubmittedVisitsResponseDto, any>({
                path: `/api/v1/clinical-dashboard/recently-submitted-visits`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Clinical Dashboard
         * @name GetVisitDetail
         * @request GET:/api/v1/clinical-dashboard/branch/{branchId}/visit/{visitId}
         */
        getVisitDetail: (branchId: string, visitId: string, params: RequestParams = {}) =>
            this.request<VisitDetailDto, any>({
                path: `/api/v1/clinical-dashboard/branch/${branchId}/visit/${visitId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    intake = {
        /**
         * @description Search for existing patients by SSN (exact match) or by lastName + dateOfBirth (fuzzy match) to prevent duplicate patient creation
         *
         * @tags Intake
         * @name FindMatches
         * @summary Find potential patient matches for intake
         * @request POST:/api/intake/match
         */
        findMatches: (data: IntakeMatchRequestDto, params: RequestParams = {}) =>
            this.request<IntakeMatchCandidateDto[], void>({
                path: `/api/intake/match`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientAdmissions = {
        /**
         * No description
         *
         * @tags Patient Admissions
         * @name GetPatientAdmissions
         * @summary Get all admissions for a patient
         * @request GET:/api/patient/{patientId}/admissions
         */
        getPatientAdmissions: (patientId: string, params: RequestParams = {}) =>
            this.request<PatientAdmissionSummaryDto[], any>({
                path: `/api/patient/${patientId}/admissions`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    auditClientEvents = {
        /**
         * @description Accepts a batch of client-side navigation events and logs them to the audit trail
         *
         * @tags Audit - Client Events
         * @name BatchLogClientEvents
         * @summary Batch log client-side events
         * @request POST:/api/v1/audit/client-events
         */
        batchLogClientEvents: (data: BatchClientEventsDto, params: RequestParams = {}) =>
            this.request<BatchClientEventsResponseDto, void>({
                path: `/api/v1/audit/client-events`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    careProtocol = {
        /**
         * No description
         *
         * @tags Care Protocol
         * @name MatchProtocols
         * @summary Find care protocols matching patient ICD-10 codes
         * @request POST:/api/v1/branches/{branchId}/admissions/{admissionId}/care-protocol/match
         */
        matchProtocols: (branchId: string, admissionId: string, data: MatchProtocolsDto, params: RequestParams = {}) =>
            this.request<any, MatchProtocolsError>({
                path: `/api/v1/branches/${branchId}/admissions/${admissionId}/care-protocol/match`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Care Protocol
         * @name BulkAddFromProtocols
         * @summary Add care protocol problems to admission plan of care
         * @request POST:/api/v1/branches/{branchId}/admissions/{admissionId}/care-protocol/bulk-add
         */
        bulkAddFromProtocols: (
            { branchId, admissionId, ...query }: BulkAddFromProtocolsParams,
            data: BulkAddFromProtocolsDto,
            params: RequestParams = {},
        ) =>
            this.request<any, BulkAddFromProtocolsError>({
                path: `/api/v1/branches/${branchId}/admissions/${admissionId}/care-protocol/bulk-add`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    schedulingDashboard = {
        /**
         * No description
         *
         * @tags Scheduling Dashboard
         * @name GetDashboard
         * @request GET:/api/v1/scheduling-dashboard
         */
        getDashboard: (query: GetDashboardParams2, params: RequestParams = {}) =>
            this.request<SchedulingDashboardDto, any>({
                path: `/api/v1/scheduling-dashboard`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Scheduling Dashboard
         * @name GetNurseVisits
         * @request GET:/api/v1/scheduling-dashboard/nurse/{userId}/visits
         */
        getNurseVisits: ({ userId, ...query }: GetNurseVisitsParams, params: RequestParams = {}) =>
            this.request<NurseVisitsDto, any>({
                path: `/api/v1/scheduling-dashboard/nurse/${userId}/visits`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Scheduling Dashboard
         * @name GetReassignmentCandidates
         * @request POST:/api/v1/scheduling-dashboard/reassignment-candidates
         */
        getReassignmentCandidates: (data: ReassignmentCandidatesRequestDto, params: RequestParams = {}) =>
            this.request<ReassignmentCandidatesResponseDto, any>({
                path: `/api/v1/scheduling-dashboard/reassignment-candidates`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Scheduling Dashboard
         * @name ReassignVisits
         * @request POST:/api/v1/scheduling-dashboard/reassign-visits
         */
        reassignVisits: (data: ReassignVisitsRequestDto, params: RequestParams = {}) =>
            this.request<ReassignVisitsResultDto, any>({
                path: `/api/v1/scheduling-dashboard/reassign-visits`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    compliance = {
        /**
         * No description
         *
         * @tags compliance
         * @name GetDashboard
         * @request GET:/api/v1/compliance/dashboard
         */
        getDashboard: (params: RequestParams = {}) =>
            this.request<ComplianceDashboardDto, any>({
                path: `/api/v1/compliance/dashboard`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetAlerts
         * @request GET:/api/v1/compliance/alerts
         */
        getAlerts: (query: GetAlertsParams, params: RequestParams = {}) =>
            this.request<ComplianceAlertPageDto, any>({
                path: `/api/v1/compliance/alerts`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetPendingReviewCount
         * @request GET:/api/v1/compliance/pending-review-count
         */
        getPendingReviewCount: (params: RequestParams = {}) =>
            this.request<
                {
                    pendingReviewCount: number;
                },
                any
            >({
                path: `/api/v1/compliance/pending-review-count`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetStaffDirectory
         * @request GET:/api/v1/compliance/staff
         */
        getStaffDirectory: (query: GetStaffDirectoryParams, params: RequestParams = {}) =>
            this.request<StaffComplianceListDto, any>({
                path: `/api/v1/compliance/staff`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetStaffSummary
         * @request GET:/api/v1/compliance/staff/{staffId}/summary
         */
        getStaffSummary: (staffId: string, params: RequestParams = {}) =>
            this.request<ComplianceSummaryDto, any>({
                path: `/api/v1/compliance/staff/${staffId}/summary`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetStaffApplicableTypes
         * @request GET:/api/v1/compliance/staff/{staffId}/applicable-types
         */
        getStaffApplicableTypes: (staffId: string, params: RequestParams = {}) =>
            this.request<ApplicableDocumentTypeDto[], any>({
                path: `/api/v1/compliance/staff/${staffId}/applicable-types`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetMyComplianceSummary
         * @request GET:/api/v1/compliance/my/summary
         */
        getMyComplianceSummary: (params: RequestParams = {}) =>
            this.request<ComplianceSummaryDto, any>({
                path: `/api/v1/compliance/my/summary`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetMyApplicableTypes
         * @request GET:/api/v1/compliance/my/applicable-types
         */
        getMyApplicableTypes: (params: RequestParams = {}) =>
            this.request<ApplicableDocumentTypeDto[], any>({
                path: `/api/v1/compliance/my/applicable-types`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetMyProfile
         * @request GET:/api/v1/compliance/my/profile
         */
        getMyProfile: (params: RequestParams = {}) =>
            this.request<MyProfileDto, any>({
                path: `/api/v1/compliance/my/profile`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name UpdateMyProfile
         * @request PATCH:/api/v1/compliance/my/profile
         */
        updateMyProfile: (data: UpdateMyProfileDto, params: RequestParams = {}) =>
            this.request<MyProfileDto, any>({
                path: `/api/v1/compliance/my/profile`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetAuditLog
         * @request GET:/api/v1/compliance/audit-log
         */
        getAuditLog: (query: GetAuditLogParams, params: RequestParams = {}) =>
            this.request<AuditLogListDto, any>({
                path: `/api/v1/compliance/audit-log`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name ListDocumentTypes
         * @request GET:/api/v1/compliance/document-types
         */
        listDocumentTypes: (query: ListDocumentTypesParams, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeDto[], any>({
                path: `/api/v1/compliance/document-types`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name CreateDocumentType
         * @request POST:/api/v1/compliance/document-types
         */
        createDocumentType: (data: CreateComplianceDocumentTypeDto, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeDto, any>({
                path: `/api/v1/compliance/document-types`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name UpdateDocumentType
         * @request PUT:/api/v1/compliance/document-types/{id}
         */
        updateDocumentType: (id: string, data: UpdateComplianceDocumentTypeDto, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeDto, any>({
                path: `/api/v1/compliance/document-types/${id}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name ArchiveDocumentType
         * @request PATCH:/api/v1/compliance/document-types/{id}/archive
         */
        archiveDocumentType: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/compliance/document-types/${id}/archive`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name UnarchiveDocumentType
         * @request PATCH:/api/v1/compliance/document-types/{id}/unarchive
         */
        unarchiveDocumentType: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/compliance/document-types/${id}/unarchive`,
                method: 'PATCH',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name ListRules
         * @request GET:/api/v1/compliance/document-types/{id}/rules
         */
        listRules: (id: string, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeRuleDto[], any>({
                path: `/api/v1/compliance/document-types/${id}/rules`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name AddRule
         * @request POST:/api/v1/compliance/document-types/{id}/rules
         */
        addRule: (id: string, data: CreateComplianceDocumentTypeRuleDto, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeRuleDto, any>({
                path: `/api/v1/compliance/document-types/${id}/rules`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name UpdateRule
         * @request PUT:/api/v1/compliance/document-types/{id}/rules/{ruleId}
         */
        updateRule: (id: string, ruleId: string, data: UpdateComplianceDocumentTypeRuleDto, params: RequestParams = {}) =>
            this.request<ComplianceDocumentTypeRuleDto, any>({
                path: `/api/v1/compliance/document-types/${id}/rules/${ruleId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name RemoveRule
         * @request DELETE:/api/v1/compliance/document-types/{id}/rules/{ruleId}
         */
        removeRule: (id: string, ruleId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/compliance/document-types/${id}/rules/${ruleId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetDocuments
         * @request GET:/api/v1/compliance/staff/{staffId}/documents
         */
        getDocuments: ({ staffId, ...query }: GetDocumentsParams, params: RequestParams = {}) =>
            this.request<ComplianceEmployeeDocumentDto[], any>({
                path: `/api/v1/compliance/staff/${staffId}/documents`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name UploadDocument
         * @request POST:/api/v1/compliance/staff/{staffId}/documents
         */
        uploadDocument: (staffId: string, data: string, params: RequestParams = {}) =>
            this.request<ComplianceEmployeeDocumentDto, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name RequestUpload
         * @request POST:/api/v1/compliance/staff/{staffId}/documents/upload-request
         */
        requestUpload: (staffId: string, data: ComplianceUploadRequestItemDto[], params: RequestParams = {}) =>
            this.request<ComplianceUploadResponseItemDto[], any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/upload-request`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name ConfirmUpload
         * @request POST:/api/v1/compliance/staff/{staffId}/documents/upload-confirm
         */
        confirmUpload: (staffId: string, data: ComplianceUploadConfirmDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/upload-confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetDocument
         * @request GET:/api/v1/compliance/staff/{staffId}/documents/{docId}
         */
        getDocument: (docId: string, staffId: string, params: RequestParams = {}) =>
            this.request<ComplianceEmployeeDocumentDto, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/${docId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name CancelDocument
         * @request DELETE:/api/v1/compliance/staff/{staffId}/documents/{docId}
         */
        cancelDocument: (staffId: string, docId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/${docId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name GetDownloadUrl
         * @request GET:/api/v1/compliance/staff/{staffId}/documents/{docId}/download
         */
        getDownloadUrl: (docId: string, staffId: string, params: RequestParams = {}) =>
            this.request<
                {
                    url: string;
                },
                any
            >({
                path: `/api/v1/compliance/staff/${staffId}/documents/${docId}/download`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name ApproveDocument
         * @request PATCH:/api/v1/compliance/staff/{staffId}/documents/{docId}/approve
         */
        approveDocument: (staffId: string, docId: string, params: RequestParams = {}) =>
            this.request<ComplianceEmployeeDocumentDto, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/${docId}/approve`,
                method: 'PATCH',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags compliance
         * @name RejectDocument
         * @request PATCH:/api/v1/compliance/staff/{staffId}/documents/{docId}/reject
         */
        rejectDocument: (staffId: string, docId: string, data: RejectComplianceDocumentDto, params: RequestParams = {}) =>
            this.request<ComplianceEmployeeDocumentDto, any>({
                path: `/api/v1/compliance/staff/${staffId}/documents/${docId}/reject`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    noteSummary = {
        /**
         * No description
         *
         * @tags NoteSummary
         * @name Create
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary
         */
        create: (branchId: string, admissionId: string, data: NoteSummaryInputDto, params: RequestParams = {}) =>
            this.request<NoteSummaryCreatedDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name List
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary
         */
        list: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<NoteSummaryJobListDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name ListAvailableModels
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/models
         */
        listAvailableModels: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<NoteSummaryAvailableModelsDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/models`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name GetQuotaStatus
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/quota-status
         */
        getQuotaStatus: ({ branchId, admissionId, ...query }: GetQuotaStatusParams, params: RequestParams = {}) =>
            this.request<NoteSummaryQuotaStatusDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/quota-status`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name FindActive
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/active
         */
        findActive: ({ branchId, admissionId, ...query }: FindActiveParams, params: RequestParams = {}) =>
            this.request<NoteSummaryActiveDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/active`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name Acknowledge
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/acknowledge
         */
        acknowledge: (branchId: string, admissionId: string, jobId: string, data: NoteSummaryAcknowledgeDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/${jobId}/acknowledge`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name GetStatus
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/status
         */
        getStatus: (branchId: string, admissionId: string, jobId: string, params: RequestParams = {}) =>
            this.request<NoteSummaryStatusDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/${jobId}/status`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name GetResult
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/result
         */
        getResult: (branchId: string, admissionId: string, jobId: string, params: RequestParams = {}) =>
            this.request<NoteSummaryResultDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/${jobId}/result`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags NoteSummary
         * @name Cancel
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/note-summary/{jobId}/cancel
         */
        cancel: (branchId: string, admissionId: string, jobId: string, params: RequestParams = {}) =>
            this.request<NoteSummaryStatusDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/note-summary/${jobId}/cancel`,
                method: 'POST',
                format: 'json',
                ...params,
            }),
    };
    llmFeatures = {
        /**
         * No description
         *
         * @tags LLM Features
         * @name GetStatus
         * @summary Get feature status for the caller's active organization
         * @request GET:/api/v1/llm-features/{featureType}/status
         */
        getStatus: (featureType: string, params: RequestParams = {}) =>
            this.request<FeatureStatusDto, any>({
                path: `/api/v1/llm-features/${featureType}/status`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    authentication = {
        /**
         * No description
         *
         * @tags Authentication
         * @name Login
         * @request POST:/api/v1/auth/login
         */
        login: (data: LoginRequestDto, params: RequestParams = {}) =>
            this.request<LoginResponseDto, any>({
                path: `/api/v1/auth/login`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authentication
         * @name Selector
         * @request POST:/api/v1/auth/selector
         */
        selector: (data: OrgSelectorRequestDto, params: RequestParams = {}) =>
            this.request<LoginResponseDto, any>({
                path: `/api/v1/auth/selector`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authentication
         * @name Authenticated
         * @request GET:/api/v1/auth/authenticated
         */
        authenticated: (params: RequestParams = {}) =>
            this.request<LoginResponseDto, any>({
                path: `/api/v1/auth/authenticated`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authentication
         * @name Logout
         * @request DELETE:/api/v1/auth/logout
         */
        logout: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/auth/logout`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authentication
         * @name ForgotPassword
         * @request POST:/api/v1/auth/forgot-password
         */
        forgotPassword: (data: ForgotPasswordDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/auth/forgot-password`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authentication
         * @name ChangePassword
         * @request PUT:/api/v1/auth/password
         */
        changePassword: (data: ChangePasswordDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/auth/password`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    user = {
        /**
         * No description
         *
         * @tags User
         * @name Create
         * @request POST:/api/v1/user
         */
        create: (data: CreateUserDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/user`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAll
         * @request GET:/api/v1/user
         */
        findAll: (params: RequestParams = {}) =>
            this.request<UserDto[], any>({
                path: `/api/v1/user`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name Update
         * @request PATCH:/api/v1/user/{userId}
         */
        update: (userId: string, data: CreateUserDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/user/${userId}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name Find
         * @request GET:/api/v1/user/{userId}
         */
        find: (userId: string, params: RequestParams = {}) =>
            this.request<UserDto, any>({
                path: `/api/v1/user/${userId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAllUsersForSelection
         * @request GET:/api/v1/user/all
         */
        findAllUsersForSelection: (params: RequestParams = {}) =>
            this.request<UserEmailDto[], any>({
                path: `/api/v1/user/all`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAdminUsers
         * @request GET:/api/v1/user/admin
         */
        findAdminUsers: (params: RequestParams = {}) =>
            this.request<AdminUserDto[], any>({
                path: `/api/v1/user/admin`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name CreateAdminUser
         * @request POST:/api/v1/user/admin
         */
        createAdminUser: (data: CreateAdminUserDto, params: RequestParams = {}) =>
            this.request<AdminUserDto, any>({
                path: `/api/v1/user/admin`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UpdateAdminUser
         * @request PATCH:/api/v1/user/admin/{userId}
         */
        updateAdminUser: (userId: string, data: CreateAdminUserDto, params: RequestParams = {}) =>
            this.request<AdminUserDto, any>({
                path: `/api/v1/user/admin/${userId}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAdminUser
         * @request GET:/api/v1/user/admin/{userId}
         */
        findAdminUser: (userId: string, params: RequestParams = {}) =>
            this.request<AdminUserDto, any>({
                path: `/api/v1/user/admin/${userId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAllCompany
         * @request GET:/api/v1/user/company/{companyId}
         */
        findAllCompany: (companyId: string, params: RequestParams = {}) =>
            this.request<UserDto[], any>({
                path: `/api/v1/user/company/${companyId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name FindAllBranch
         * @request GET:/api/v1/user/branch/{branchId}
         */
        findAllBranch: (branchId: string, params: RequestParams = {}) =>
            this.request<UserDto[], any>({
                path: `/api/v1/user/branch/${branchId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    company = {
        /**
         * No description
         *
         * @tags Company
         * @name FindAll
         * @request GET:/api/v1/company
         */
        findAll: (params: RequestParams = {}) =>
            this.request<CompanyDto[], any>({
                path: `/api/v1/company`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Company
         * @name Create
         * @request POST:/api/v1/company
         */
        create: (data: CreateCompanyDto, params: RequestParams = {}) =>
            this.request<CompanyDto, any>({
                path: `/api/v1/company`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Company
         * @name FindOne
         * @request GET:/api/v1/company/{id}
         */
        findOne: (id: string, params: RequestParams = {}) =>
            this.request<CompanyDto, any>({
                path: `/api/v1/company/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Company
         * @name Update
         * @request PATCH:/api/v1/company/{id}
         */
        update: (id: string, data: UpdateCompanyDto, params: RequestParams = {}) =>
            this.request<CompanyDto, any>({
                path: `/api/v1/company/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    branch = {
        /**
         * No description
         *
         * @tags branch
         * @name FindOne
         * @request GET:/api/v1/branch/{branchId}
         */
        findOne: (branchId: string, params: RequestParams = {}) =>
            this.request<BranchDto, any>({
                path: `/api/v1/branch/${branchId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags branch
         * @name Update
         * @request PATCH:/api/v1/company/{companyId}/branch/{branchId}
         */
        update: (branchId: string, companyId: string, data: UpdateBranchDto, params: RequestParams = {}) =>
            this.request<BranchDto, any>({
                path: `/api/v1/company/${companyId}/branch/${branchId}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags branch
         * @name Create
         * @request POST:/api/v1/company/{companyId}/branch
         */
        create: (companyId: string, data: CreateBranchDto, params: RequestParams = {}) =>
            this.request<BranchDto, any>({
                path: `/api/v1/company/${companyId}/branch`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    role = {
        /**
         * No description
         *
         * @tags Role
         * @name FindAll
         * @request GET:/api/v1/role
         */
        findAll: (params: RequestParams = {}) =>
            this.request<RoleDto[], any>({
                path: `/api/v1/role`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    physician = {
        /**
         * No description
         *
         * @tags Physician
         * @name PhysicianSearch
         * @request GET:/api/v1/physician/search
         */
        physicianSearch: (query: PhysicianSearchParams, params: RequestParams = {}) =>
            this.request<SearchPhysicianDto, any>({
                path: `/api/v1/physician/search`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Physician
         * @name Create
         * @request POST:/api/v1/physician
         */
        create: (data: CreatePhysicianDto, params: RequestParams = {}) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/physician`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Physician
         * @name List
         * @request GET:/api/v1/physician
         */
        list: (params: RequestParams = {}) =>
            this.request<PhysicianDto[], any>({
                path: `/api/v1/physician`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Physician
         * @name Get
         * @request GET:/api/v1/physician/{id}
         */
        get: (id: string, params: RequestParams = {}) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/physician/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Physician
         * @name Edit
         * @request PATCH:/api/v1/physician/{id}
         */
        edit: (id: string, data: UpdatePhysicianDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/physician/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Physician
         * @name EditPhysicianDetails
         * @request PATCH:/api/v1/physician/{physicianId}/details
         */
        editPhysicianDetails: (physicianId: string, data: EditPhysicianDetailsDto, params: RequestParams = {}) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/physician/${physicianId}/details`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientContact = {
        /**
         * No description
         *
         * @tags PatientContact
         * @name Save
         * @request POST:/api/v1/branchId/{branchId}/patientId/{patientId}/contact
         */
        save: (branchId: string, patientId: string, data: CreatePatientContactDto, params: RequestParams = {}) =>
            this.request<PatientContactDto, any>({
                path: `/api/v1/branchId/${branchId}/patientId/${patientId}/contact`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientSupport = {
        /**
         * No description
         *
         * @tags PatientSupport
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/support
         */
        save: (branchId: string, data: SavePatientSupportDto, params: RequestParams = {}) =>
            this.request<PatientSupportDto, any>({
                path: `/api/v1/branch/${branchId}/support`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientCaregiver = {
        /**
         * No description
         *
         * @tags PatientCaregiver
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/patient/{patientId}/caregiver
         */
        save: (branchId: string, patientId: string, data: SaveCaregiverDto, params: RequestParams = {}) =>
            this.request<PatientCaregiverDto, any>({
                path: `/api/v1/branch/${branchId}/patient/${patientId}/caregiver`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientCaregiver
         * @name Update
         * @request PUT:/api/v1/branch/{branchId}/patient/{patientId}/caregiver/{caregiverId}
         */
        update: (branchId: string, patientId: string, caregiverId: string, data: SaveCaregiverDto, params: RequestParams = {}) =>
            this.request<PatientCaregiverDto, any>({
                path: `/api/v1/branch/${branchId}/patient/${patientId}/caregiver/${caregiverId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    patientAllergyRisk = {
        /**
         * No description
         *
         * @tags PatientAllergyRisk
         * @name Save
         * @request POST:/api/v1/allergy-risk
         */
        save: (data: CreatePatientAllergyRiskDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/allergy-risk`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    admissionProvider = {
        /**
         * No description
         *
         * @tags admission-provider
         * @name Save
         * @request PUT:/api/v1/provider/branch/{branchId}/admission/{admissionId}
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionProviderDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/provider/branch/${branchId}/admission/${admissionId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    pharmacy = {
        /**
         * No description
         *
         * @tags Pharmacy
         * @name Create
         * @request POST:/api/v1/pharmacy
         */
        create: (data: SavePharmacyDto, params: RequestParams = {}) =>
            this.request<PharmacyDto, any>({
                path: `/api/v1/pharmacy`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Pharmacy
         * @name List
         * @request GET:/api/v1/pharmacy
         */
        list: (params: RequestParams = {}) =>
            this.request<PharmacyDto[], any>({
                path: `/api/v1/pharmacy`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Pharmacy
         * @name Edit
         * @request PATCH:/api/v1/pharmacy/{id}
         */
        edit: (id: string, data: SavePharmacyDto, params: RequestParams = {}) =>
            this.request<PharmacyDto, any>({
                path: `/api/v1/pharmacy/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Pharmacy
         * @name Get
         * @request GET:/api/v1/pharmacy/{id}
         */
        get: (id: string, params: RequestParams = {}) =>
            this.request<PharmacyDto, any>({
                path: `/api/v1/pharmacy/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    patientPharmacy = {
        /**
         * No description
         *
         * @tags PatientPharmacy
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy
         */
        save: (branchId: string, admissionId: string, data: SavePatientPharmacyDto, params: RequestParams = {}) =>
            this.request<PharmacyDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/pharmacy`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPharmacy
         * @name SetPrimary
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy/{pharmacyId}/primary
         */
        setPrimary: (branchId: string, admissionId: string, pharmacyId: string, params: RequestParams = {}) =>
            this.request<PharmacyDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/pharmacy/${pharmacyId}/primary`,
                method: 'PUT',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPharmacy
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/pharmacy/{pharmacyId}
         */
        delete: (branchId: string, admissionId: string, pharmacyId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/pharmacy/${pharmacyId}`,
                method: 'DELETE',
                ...params,
            }),
    };
    visitType = {
        /**
         * No description
         *
         * @tags visit-type
         * @name Create
         * @request POST:/api/v1/visit-type
         */
        create: (data: CreateVisitTypeDto, params: RequestParams = {}) =>
            this.request<VisitTypeDto, any>({
                path: `/api/v1/visit-type`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags visit-type
         * @name FindAll
         * @request GET:/api/v1/visit-type
         */
        findAll: (params: RequestParams = {}) =>
            this.request<VisitTypeDto[], any>({
                path: `/api/v1/visit-type`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags visit-type
         * @name FindOne
         * @request GET:/api/v1/visit-type/{id}
         */
        findOne: (id: string, params: RequestParams = {}) =>
            this.request<VisitTypeDto, any>({
                path: `/api/v1/visit-type/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags visit-type
         * @name Update
         * @request PATCH:/api/v1/visit-type/{id}
         */
        update: (id: string, data: UpdateVisitTypeDto, params: RequestParams = {}) =>
            this.request<VisitTypeDto, any>({
                path: `/api/v1/visit-type/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags visit-type
         * @name RevenueCodes
         * @request GET:/api/v1/revenue-codes
         */
        revenueCodes: (params: RequestParams = {}) =>
            this.request<RevenueCodeDto[], any>({
                path: `/api/v1/revenue-codes`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags visit-type
         * @name ServiceCodes
         * @request GET:/api/v1/service-codes
         */
        serviceCodes: (params: RequestParams = {}) =>
            this.request<ServiceCodeDto[], any>({
                path: `/api/v1/service-codes`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    form = {
        /**
         * No description
         *
         * @tags Form
         * @name FindAll
         * @request GET:/api/v1/form
         */
        findAll: (params: RequestParams = {}) =>
            this.request<FormDto[], any>({
                path: `/api/v1/form`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Form
         * @name FindOne
         * @request GET:/api/v1/form/{id}
         */
        findOne: (id: string, params: RequestParams = {}) =>
            this.request<FormDto, any>({
                path: `/api/v1/form/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    payroll = {
        /**
         * No description
         *
         * @tags payroll
         * @name List
         * @request GET:/api/v1/payroll
         */
        list: (query: ListParams10, params: RequestParams = {}) =>
            this.request<PayrollDto[], any>({
                path: `/api/v1/payroll`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name UpdateVisitPayroll
         * @summary Update payroll paid status for selected visits in a period
         * @request PUT:/api/v1/payroll
         */
        updateVisitPayroll: (data: UpdateVisitPayrollDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/payroll`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name ListPeriods
         * @summary List payroll periods up to current + next
         * @request GET:/api/v1/payroll/periods
         */
        listPeriods: (params: RequestParams = {}) =>
            this.request<PayrollPeriodDto[], any>({
                path: `/api/v1/payroll/periods`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name ExportExcel
         * @summary Export payroll data as Excel spreadsheet
         * @request GET:/api/v1/payroll/export/excel
         */
        exportExcel: (query: ExportExcelParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/payroll/export/excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name ListEmployeeVisits
         * @summary List visits for an employee within a payroll period
         * @request GET:/api/v1/payroll/employee/{employeeId}
         */
        listEmployeeVisits: ({ employeeId, ...query }: ListEmployeeVisitsParams, params: RequestParams = {}) =>
            this.request<PayrollEmployeeVisitDto[], any>({
                path: `/api/v1/payroll/employee/${employeeId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name UpdateVisitCharge
         * @request PUT:/api/v1/payroll/visits/{payrollId}/charge
         */
        updateVisitCharge: (payrollId: string, data: UpdateVisitChargeDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/payroll/visits/${payrollId}/charge`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name CreateVisitAdjustment
         * @summary Create a payroll adjustment record for a visit
         * @request POST:/api/v1/payroll/visits/{payrollId}/adjustments
         */
        createVisitAdjustment: (payrollId: string, data: CreateVisitAdjustmentDto, params: RequestParams = {}) =>
            this.request<VisitAdjustmentDto, any>({
                path: `/api/v1/payroll/visits/${payrollId}/adjustments`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name UpdateVisitAdjustment
         * @summary Update an existing payroll adjustment
         * @request PUT:/api/v1/payroll/visits/{payrollId}/adjustments
         */
        updateVisitAdjustment: (payrollId: string, data: UpdateVisitAdjustmentDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/payroll/visits/${payrollId}/adjustments`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name GetConfig
         * @summary Get current payroll configuration
         * @request GET:/api/v1/payroll/config
         */
        getConfig: (params: RequestParams = {}) =>
            this.request<PayrollConfigDto, any>({
                path: `/api/v1/payroll/config`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payroll
         * @name UpdateConfig
         * @summary Update payroll configuration
         * @request PUT:/api/v1/payroll/config
         */
        updateConfig: (data: UpdatePayrollConfigDto, params: RequestParams = {}) =>
            this.request<PayrollConfigDto, any>({
                path: `/api/v1/payroll/config`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    payrollV2 = {
        /**
         * No description
         *
         * @tags payrollV2
         * @name ListSchedules
         * @summary List all payroll schedules for the organization with filtering
         * @request GET:/api/v2/payroll/schedules
         */
        listSchedules: (query: ListSchedulesParams, params: RequestParams = {}) =>
            this.request<PayrollScheduleListResponseDto, any>({
                path: `/api/v2/payroll/schedules`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name CreateSchedule
         * @summary Create a new payroll schedule
         * @request POST:/api/v2/payroll/schedules
         */
        createSchedule: (data: CreatePayrollScheduleDto, params: RequestParams = {}) =>
            this.request<PayrollScheduleDto, any>({
                path: `/api/v2/payroll/schedules`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetCurrentDefaultSchedule
         * @summary Get the current default payroll schedule
         * @request GET:/api/v2/payroll/schedules/current-default
         */
        getCurrentDefaultSchedule: (params: RequestParams = {}) =>
            this.request<PayrollScheduleDto, any>({
                path: `/api/v2/payroll/schedules/current-default`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetSchedule
         * @summary Get a specific payroll schedule
         * @request GET:/api/v2/payroll/schedules/{scheduleId}
         */
        getSchedule: (scheduleId: string, params: RequestParams = {}) =>
            this.request<PayrollScheduleDto, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name UpdateSchedule
         * @summary Update a payroll schedule
         * @request PUT:/api/v2/payroll/schedules/{scheduleId}
         */
        updateSchedule: (scheduleId: string, data: UpdatePayrollScheduleDto, params: RequestParams = {}) =>
            this.request<PayrollScheduleDto, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name DeactivateSchedule
         * @summary Deactivate a payroll schedule and reassign employees to default
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/deactivate
         */
        deactivateSchedule: (scheduleId: string, params: RequestParams = {}) =>
            this.request<DeactivatePayrollScheduleResponseDto, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/deactivate`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name ReactivateSchedule
         * @summary Reactivate a deactivated payroll schedule
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/reactivate
         */
        reactivateSchedule: (scheduleId: string, params: RequestParams = {}) =>
            this.request<ReactivatePayrollScheduleResponseDto, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/reactivate`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetSchedulePeriods
         * @summary Get payroll periods for a specific schedule
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/periods
         */
        getSchedulePeriods: (scheduleId: string, params: RequestParams = {}) =>
            this.request<PayrollPeriodV2Dto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/periods`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetOpenPeriods
         * @summary Get all open/pending periods for a schedule
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/periods/open
         */
        getOpenPeriods: (scheduleId: string, params: RequestParams = {}) =>
            this.request<PayrollPeriodV2Dto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/periods/open`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name ClosePeriod
         * @summary Explicitly close a payroll period
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/periods/close
         */
        closePeriod: (scheduleId: string, data: ClosePeriodDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/periods/close`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name ReopenPeriod
         * @summary Reopen a closed payroll period
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/periods/reopen
         */
        reopenPeriod: (scheduleId: string, data: ClosePeriodDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/periods/reopen`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetSchedulePayroll
         * @summary Get payroll data for a specific schedule and period
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/payroll
         */
        getSchedulePayroll: ({ scheduleId, ...query }: GetSchedulePayrollParams, params: RequestParams = {}) =>
            this.request<PayrollDto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/payroll`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name ExportSchedulePayrollExcel
         * @summary Export payroll data for a specific schedule and period as Excel file
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/export/excel
         */
        exportSchedulePayrollExcel: ({ scheduleId, ...query }: ExportSchedulePayrollExcelParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/export/excel`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetScheduleEmployees
         * @summary Get employees assigned to a payroll schedule
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/employees
         */
        getScheduleEmployees: (scheduleId: string, params: RequestParams = {}) =>
            this.request<PayrollScheduleEmployeeDto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/employees`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name AssignEmployeeToSchedule
         * @summary Assign an employee to a payroll schedule
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/employees
         */
        assignEmployeeToSchedule: (scheduleId: string, data: CreatePayrollEmployeeAssignmentDto, params: RequestParams = {}) =>
            this.request<PayrollEmployeeAssignmentDto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/employees`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name EndEmployeeAssignment
         * @summary End an employee assignment to a payroll schedule
         * @request DELETE:/api/v2/payroll/schedules/{scheduleId}/employees/{employeeId}
         */
        endEmployeeAssignment: (scheduleId: string, employeeId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/employees/${employeeId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetAvailableEmployees
         * @summary Get all employees available for payroll assignment
         * @request GET:/api/v2/payroll/available-employees
         */
        getAvailableEmployees: (params: RequestParams = {}) =>
            this.request<PayrollAvailableEmployeeDto[], any>({
                path: `/api/v2/payroll/available-employees`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name GetScheduleEmployeeVisits
         * @summary Get detailed visit data for an employee within a schedule and period
         * @request GET:/api/v2/payroll/schedules/{scheduleId}/employee/{employeeId}
         */
        getScheduleEmployeeVisits: ({ scheduleId, employeeId, ...query }: GetScheduleEmployeeVisitsParams, params: RequestParams = {}) =>
            this.request<PayrollEmployeeVisitDto[], any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/employee/${employeeId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name UpdateVisitPayrollStatus
         * @summary Update payroll status for multiple visit payroll records within a schedule
         * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/bulk-status
         */
        updateVisitPayrollStatus: (scheduleId: string, data: UpdateVisitPayrollDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/visits/bulk-status`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name CreateVisitAdjustment
         * @summary Create a payroll adjustment record for a visit within a schedule
         * @request POST:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/adjustments
         */
        createVisitAdjustment: (scheduleId: string, payrollId: string, data: CreateVisitAdjustmentDto, params: RequestParams = {}) =>
            this.request<VisitAdjustmentDto, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/visits/${payrollId}/adjustments`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name UpdateVisitAdjustment
         * @summary Update an existing payroll adjustment within a schedule
         * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/adjustments
         */
        updateVisitAdjustment: (scheduleId: string, payrollId: string, data: UpdateVisitAdjustmentDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/visits/${payrollId}/adjustments`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags payrollV2
         * @name UpdateVisitCharge
         * @summary Update the custom charge for a visit payroll record within a schedule
         * @request PUT:/api/v2/payroll/schedules/{scheduleId}/visits/{payrollId}/charge
         */
        updateVisitCharge: (scheduleId: string, payrollId: string, data: UpdateVisitChargeDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v2/payroll/schedules/${scheduleId}/visits/${payrollId}/charge`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    visitFormSupply = {
        /**
         * No description
         *
         * @tags VisitFormSupply
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/supplies
         */
        save: (branchId: string, admissionId: string, formId: string, data: SaveVisitFormSupplyDto, params: RequestParams = {}) =>
            this.request<VisitFormSupplyDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/form/${formId}/supplies`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitFormSupply
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/supplies/{id}
         */
        delete: (id: string, branchId: string, admissionId: string, formId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/form/${formId}/supplies/${id}`,
                method: 'DELETE',
                ...params,
            }),
    };
    visitFormWound = {
        /**
         * No description
         *
         * @tags VisitFormWound
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/wounds
         */
        save: (branchId: string, admissionId: string, formId: string, data: SaveVisitFormWoundDto, params: RequestParams = {}) =>
            this.request<VisitFormWoundDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/form/${formId}/wounds`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags VisitFormWound
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/form/{formId}/wounds/{id}
         */
        delete: (id: string, branchId: string, admissionId: string, formId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/form/${formId}/wounds/${id}`,
                method: 'DELETE',
                ...params,
            }),
    };
    admissionWound = {
        /**
         * No description
         *
         * @tags AdmissionWound
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/wounds
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionWoundDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/wounds`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionWound
         * @name List
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/wounds
         */
        list: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<AdmissionWoundDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/wounds`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionWound
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/wounds/{id}
         */
        delete: ({ id, branchId, admissionId, ...query }: DeleteParams6, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/wounds/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionWound
         * @name GenerateWoundsPdf
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/wounds/episode/{episodeId}/pdf
         */
        generateWoundsPDF: ({ branchId, episodeId, admissionId, ...query }: GenerateWoundsPdfParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/wounds/episode/${episodeId}/pdf`,
                method: 'GET',
                query: query,
                ...params,
            }),
    };
    admissionVaccination = {
        /**
         * No description
         *
         * @tags AdmissionVaccination
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/vaccinations
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionVaccinationDto, params: RequestParams = {}) =>
            this.request<AdmissionVaccinationDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/vaccinations`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionVaccination
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/vaccinations/{id}
         */
        delete: ({ id, branchId, admissionId, ...query }: DeleteParams8, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/vaccinations/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),
    };
    admissionMedication = {
        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionMedicationDto, params: RequestParams = {}) =>
            this.request<AdmissionMedicationDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name SaveFromInfection
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/infections/{id}
         */
        saveFromInfection: (
            id: string,
            branchId: string,
            admissionId: string,
            data: SaveAdmissionMedicationDto,
            params: RequestParams = {},
        ) =>
            this.request<AdmissionMedicationDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/infections/${id}`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}
         */
        delete: ({ id, branchId, admissionId, ...query }: DeleteParams10, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name Inactivate
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/inactivate/{id}
         */
        inactivate: ({ id, branchId, admissionId, ...query }: InactivateParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/inactivate/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name Activate
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/activate/{id}
         */
        activate: ({ id, branchId, admissionId, ...query }: ActivateParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/activate/${id}`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name Remove
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/infection/{infectionId}
         */
        remove: (id: string, infectionId: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/${id}/infection/${infectionId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name SaveTeaching
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/teachings
         */
        saveTeaching: (branchId: string, admissionId: string, data: SaveMedicationTeachingDto, params: RequestParams = {}) =>
            this.request<AdmissionMedicationDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/teachings`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name DeleteTeaching
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/teachings/{teachingId}/forms/{formId}
         */
        deleteTeaching: (
            branchId: string,
            admissionId: string,
            formId: string,
            id: string,
            teachingId: string,
            params: RequestParams = {},
        ) =>
            this.request<AdmissionMedicationDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/${id}/teachings/${teachingId}/forms/${formId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name GeneratePdf
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/medications/episode/{episodeId}/pdf
         */
        generatePDF: ({ branchId, episodeId, admissionId, ...query }: GeneratePdfParams, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/episode/${episodeId}/pdf`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name GetDrugDetails
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/medications/details/{drugbankId}
         */
        getDrugDetails: (branchId: string, admissionId: string, drugbankId: string, params: RequestParams = {}) =>
            this.request<DrugDetailsDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/details/${drugbankId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name ApproveMedications
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/form/{formId}/approve
         */
        approveMedications: (branchId: string, admissionId: string, formId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/form/${formId}/approve`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionMedication
         * @name AssignOrder
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/medications/{id}/assign-order
         */
        assignOrder: (branchId: string, admissionId: string, id: string, data: AssignOrderDto, params: RequestParams = {}) =>
            this.request<AssignOrderResultDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/medications/${id}/assign-order`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    formOrder = {
        /**
         * No description
         *
         * @tags FormOrder
         * @name Save
         * @request POST:/api/v1/form-order/branch/{branchId}
         */
        save: (branchId: string, data: SaveFormOrderDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-order/branch/${branchId}`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name List
         * @request GET:/api/v1/form-order
         */
        list: (params: RequestParams = {}) =>
            this.request<FormOrderDto[], any>({
                path: `/api/v1/form-order`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name ListByAdmission
         * @request GET:/api/v1/form-order/branch/{branchId}/admission/{admissionId}
         */
        listByAdmission: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<FormOrderDto[], any>({
                path: `/api/v1/form-order/branch/${branchId}/admission/${admissionId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name ListEligible
         * @request GET:/api/v1/form-order/branch/{branchId}/admission/{admissionId}/eligible
         */
        listEligible: (branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<FormOrderDto[], any>({
                path: `/api/v1/form-order/branch/${branchId}/admission/${admissionId}/eligible`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name GeneratePdf
         * @request GET:/api/v1/form-order/branch/{branchId}/form/{formId}
         */
        generatePDF: (formId: string, branchId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-order/branch/${branchId}/form/${formId}`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name Reset
         * @request GET:/api/v1/form-order/branch/{branchId}/order/{orderId}
         */
        reset: (branchId: string, orderId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-order/branch/${branchId}/order/${orderId}`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormOrder
         * @name SendEfax
         * @request POST:/api/v1/form-order/branch/{branchId}/order/{orderId}/fax/send
         */
        sendEfax: (branchId: string, orderId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-order/branch/${branchId}/order/${orderId}/fax/send`,
                method: 'POST',
                ...params,
            }),
    };
    admissionPlanOfCare = {
        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name SaveProblem
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/problem
         */
        saveProblem: (branchId: string, admissionId: string, data: SaveProblemDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/problem`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name SaveGoal
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/goal
         */
        saveGoal: (branchId: string, admissionId: string, data: SaveGoalDto, params: RequestParams = {}) =>
            this.request<AdmissionProblemGoalDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/goal`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name SaveTask
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/task
         */
        saveTask: (branchId: string, admissionId: string, data: SaveTaskDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/task`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name SaveTaskLog
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/form/{formId}/task-log
         */
        saveTaskLog: (branchId: string, admissionId: string, formId: string, data: SaveTaskLogDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/form/${formId}/task-log`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name List
         * @request GET:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care
         */
        list: ({ branchId, admissionId, ...query }: ListParams14, params: RequestParams = {}) =>
            this.request<AdmissionPlanOfCareDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name AssignOrder
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/{type}/{id}/assign-order
         */
        assignOrder: (branchId: string, admissionId: string, type: string, id: string, data: AssignOrderDto, params: RequestParams = {}) =>
            this.request<AssignOrderResultDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/${type}/${id}/assign-order`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/{type}/{id}
         */
        delete: ({ branchId, admissionId, id, type, ...query }: DeleteParams12, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/${type}/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionPlanOfCare
         * @name BulkAddFromTemplates
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/plan-of-care/bulk-from-templates
         */
        bulkAddFromTemplates: (
            { branchId, admissionId, ...query }: BulkAddFromTemplatesParams,
            data: BulkAddFromTemplatesDto,
            params: RequestParams = {},
        ) =>
            this.request<AdmissionPlanOfCareDto[], any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/plan-of-care/bulk-from-templates`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    admissionIncident = {
        /**
         * No description
         *
         * @tags AdmissionIncident
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/incident
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionIncidentDto, params: RequestParams = {}) =>
            this.request<AdmissionIncidentDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/incident`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionIncident
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/incidents/{id}
         */
        delete: (id: string, branchId: string, admissionId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/incidents/${id}`,
                method: 'DELETE',
                ...params,
            }),
    };
    admissionInfection = {
        /**
         * No description
         *
         * @tags AdmissionInfection
         * @name Save
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/infections
         */
        save: (branchId: string, admissionId: string, data: SaveAdmissionInfectionDto, params: RequestParams = {}) =>
            this.request<AdmissionInfectionDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/infections`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags AdmissionInfection
         * @name Delete
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/infections/{id}
         */
        delete: ({ id, branchId, admissionId, ...query }: DeleteParams15, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/infections/${id}`,
                method: 'DELETE',
                query: query,
                ...params,
            }),
    };
    patientPhysician = {
        /**
         * No description
         *
         * @tags PatientPhysician
         * @name AddPhysician
         * @request POST:/api/v1/branch/{branchId}/admission/{admissionId}/physician
         */
        addPhysician: (branchId: string, admissionId: string, data: AddPhysicianToAdmissionDto, params: RequestParams = {}) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/physician`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPhysician
         * @name UpdatePhysician
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}
         */
        updatePhysician: (
            branchId: string,
            admissionId: string,
            physicianId: string,
            data: UpdatePatientPhysicianDto,
            params: RequestParams = {},
        ) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/physician/${physicianId}`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPhysician
         * @name RemovePhysician
         * @request DELETE:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}
         */
        removePhysician: (branchId: string, admissionId: string, physicianId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/physician/${physicianId}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPhysician
         * @name ReplacePhysician
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}/replace
         */
        replacePhysician: (
            branchId: string,
            admissionId: string,
            physicianId: string,
            data: AddPhysicianToAdmissionDto,
            params: RequestParams = {},
        ) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/physician/${physicianId}/replace`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PatientPhysician
         * @name SetPrimary
         * @request PUT:/api/v1/branch/{branchId}/admission/{admissionId}/physician/{physicianId}/primary
         */
        setPrimary: (branchId: string, admissionId: string, physicianId: string, params: RequestParams = {}) =>
            this.request<PhysicianDto, any>({
                path: `/api/v1/branch/${branchId}/admission/${admissionId}/physician/${physicianId}/primary`,
                method: 'PUT',
                format: 'json',
                ...params,
            }),
    };
    formCms = {
        /**
         * No description
         *
         * @tags FormCms
         * @name Download
         * @request POST:/api/v1/form-cms
         */
        download: (data: string[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-cms`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormCms
         * @name FindAll
         * @request GET:/api/v1/form-cms
         */
        findAll: (params: RequestParams = {}) =>
            this.request<FormCmsDto[], any>({
                path: `/api/v1/form-cms`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags FormCms
         * @name UpdateStatus
         * @request PATCH:/api/v1/form-cms
         */
        updateStatus: (data: UpdateFormCmsDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/form-cms`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    template = {
        /**
         * No description
         *
         * @tags Template
         * @name Save
         * @request POST:/api/v1/template
         */
        save: (data: SaveTemplateDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/template`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Template
         * @name FindAll
         * @request GET:/api/v1/template
         */
        findAll: (query: FindAllParams6, params: RequestParams = {}) =>
            this.request<any, FindAllError>({
                path: `/api/v1/template`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Template
         * @name GetTemplateProblemList
         * @request GET:/api/v1/template/problems
         */
        getTemplateProblemList: (query: GetTemplateProblemListParams, params: RequestParams = {}) =>
            this.request<any, GetTemplateProblemListError>({
                path: `/api/v1/template/problems`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Template
         * @name AddLink
         * @request POST:/api/v1/template/link
         */
        addLink: (data: LinkDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/template/link`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Template
         * @name Delete
         * @request DELETE:/api/v1/template/{id}
         */
        delete: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/template/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Template
         * @name RemoveLink
         * @request DELETE:/api/v1/template/link/{fromId}/{toId}
         */
        removeLink: (fromId: string, toId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/template/link/${fromId}/${toId}`,
                method: 'DELETE',
                ...params,
            }),
    };
    report = {
        /**
         * No description
         *
         * @tags Report
         * @name ExportExcel
         * @summary Export report data as Excel spreadsheet
         * @request GET:/api/v1/report/export/excel/{id}
         */
        exportExcel: ({ id, ...query }: ExportExcelParams2, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/export/excel/${id}`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name FindAll
         * @request GET:/api/v1/report
         */
        findAll: (query: FindAllParams8, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name SaveCustomReport
         * @request POST:/api/v1/report/custom
         */
        saveCustomReport: (data: SaveCustomReportDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/custom`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name GetUserReports
         * @request GET:/api/v1/report/custom
         */
        getUserReports: (params: RequestParams = {}) =>
            this.request<UserReportDto, any>({
                path: `/api/v1/report/custom`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name DeleteCustomReport
         * @request DELETE:/api/v1/report/custom/{id}
         */
        deleteCustomReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/custom/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name SaveUserFavorite
         * @request POST:/api/v1/report/user-favorite
         */
        saveUserFavorite: (data: SaveUserFavoriteDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/user-favorite`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name SaveReport
         * @request POST:/api/v1/report/report
         */
        saveReport: (data: SaveReportDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/report`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name GetApprovedReports
         * @request GET:/api/v1/report/approved-reports
         */
        getApprovedReports: (params: RequestParams = {}) =>
            this.request<ReportDto[], any>({
                path: `/api/v1/report/approved-reports`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name GetReports
         * @request GET:/api/v1/report/reports
         */
        getReports: (params: RequestParams = {}) =>
            this.request<ReportDto[], any>({
                path: `/api/v1/report/reports`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name GetReport
         * @request GET:/api/v1/report/report/{id}
         */
        getReport: (id: string, params: RequestParams = {}) =>
            this.request<ReportDto, any>({
                path: `/api/v1/report/report/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name DeleteReport
         * @request DELETE:/api/v1/report/report/{id}
         */
        deleteReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/report/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name ApproveReport
         * @request POST:/api/v1/report/approve-report/{id}
         */
        approveReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/approve-report/${id}`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name RemoveUserApproveReport
         * @request DELETE:/api/v1/report/remove-approve-report/{id}
         */
        removeUserApproveReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/remove-approve-report/${id}`,
                method: 'DELETE',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name LockReport
         * @request POST:/api/v1/report/lock-report/{id}
         */
        lockReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/lock-report/${id}`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name RevokeReport
         * @request POST:/api/v1/report/revoke-report/{id}
         */
        revokeReport: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/report/revoke-report/${id}`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name GetConfig
         * @request GET:/api/v1/report/config
         */
        getConfig: (params: RequestParams = {}) =>
            this.request<ReportConfigurationDto, any>({
                path: `/api/v1/report/config`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Report
         * @name SaveConfig
         * @request POST:/api/v1/report/config
         */
        saveConfig: (data: SaveReportConfigDto, params: RequestParams = {}) =>
            this.request<ReportConfigurationDto, any>({
                path: `/api/v1/report/config`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    googleMaps = {
        /**
         * No description
         *
         * @tags Google Maps
         * @name Autocomplete
         * @request GET:/api/v1/google-maps/autocomplete
         */
        autocomplete: (query: AutocompleteParams, params: RequestParams = {}) =>
            this.request<AutocompleteResultDto[], any>({
                path: `/api/v1/google-maps/autocomplete`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Google Maps
         * @name PlaceDetails
         * @request GET:/api/v1/google-maps/place/{placeId}
         */
        placeDetails: (placeId: string, params: RequestParams = {}) =>
            this.request<PlaceDetailsDto, any>({
                path: `/api/v1/google-maps/place/${placeId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    };
    customMedication = {
        /**
         * No description
         *
         * @tags custom-medication
         * @name Create
         * @request POST:/api/v1/custom-medication
         */
        create: (data: CreateCustomMedicationDto, params: RequestParams = {}) =>
            this.request<CustomMedicationDto, any>({
                path: `/api/v1/custom-medication`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags custom-medication
         * @name List
         * @request GET:/api/v1/custom-medication
         */
        list: (params: RequestParams = {}) =>
            this.request<CustomMedicationDto[], any>({
                path: `/api/v1/custom-medication`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags custom-medication
         * @name Get
         * @request GET:/api/v1/custom-medication/{id}
         */
        get: (id: string, params: RequestParams = {}) =>
            this.request<CustomMedicationDto, any>({
                path: `/api/v1/custom-medication/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags custom-medication
         * @name Update
         * @request PATCH:/api/v1/custom-medication/{id}
         */
        update: (id: string, data: UpdateCustomMedicationDto, params: RequestParams = {}) =>
            this.request<CustomMedicationDto, any>({
                path: `/api/v1/custom-medication/${id}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    };
    localJanitor = {
        /**
         * No description
         *
         * @tags LocalJanitor
         * @name RunCycle
         * @request POST:/api/dev/janitor/run
         */
        runCycle: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/dev/janitor/run`,
                method: 'POST',
                ...params,
            }),
    };
}
